/* * * * * * * * * * * * * * * * * * * *
*
* NagishLi v2.2 Copyright (c) 2016-2017 Localize* (http://www.nagish.li)

! This program is free software: you can redistribute it and/or modify
! it under the terms of the GNU Lesser General Public License as published by
! the Free Software Foundation, either version 3 of the License, or
! (at your option) any later version.
!
! This program is distributed in the hope that it will be useful,
! but WITHOUT ANY WARRANTY; without even the implied warranty of
! MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
! GNU Lesser General Public License for more details.
!
! You should have received a copy of the GNU Lesser General Public License
! along with this program.  If not, see <http://www.gnu.org/licenses/>.

! People & Disability Pictograms Copyright (c) 2016 anatom5 GmbH in cooperation with Natko (http://www.anatom5.de & http://www.natko.de)
! Balloon.css Copyright (c) 2016 Claudio Holanda (https://kazzkiq.github.io/balloon.css/)
! NiceScroll Copyright (c) 2011-14 InuYaksa (http://nicescroll.areaaperta.com)
! Normalize.css Copyright © Nicolas Gallagher and Jonathan Neal (https://necolas.github.io/normalize.css/)
! Styling inspired by Pedro Nauk (https://codepen.io/pedronauck/)
! Arrows icons from Flaticon by Dave Gandy (http://www.flaticon.com/authors/dave-gandy)
! Star Of David icon from Flaticon by Scott de Jonge (http://www.flaticon.com/authors/scott-de-jonge)
! Bounce animations from Animate.css Copyright (c) 2016 Daniel Eden (https://daneden.github.io/animate.css/)
! Various icons (Cursor, audio ..) from Icons8 (https://icons8.com)

*
* * * * * * * * * * * * * * * * * * * */
if ("undefined" == typeof jQuery) {
  var docHead = document.getElementsByTagName("head")[0],
    scriptTag = document.createElement("script"),
    jq_not_found = !0;
  scriptTag.type = "text/javascript";
  scriptTag.src = "//code.jquery.com/jquery-1.8.0.min.js";
  scriptTag.onload = initNagishLi;
  docHead.appendChild(scriptTag)
} else initNagishLi();

function initNagishLi() {
  function F(b, f, e, g) {
    0 > e && (e += b.length);
    g = void 0 !== g ? g : b.length;
    0 > g && (g = g + b.length - e);
    return b.slice(0, e) + f.substr(0, g) + f.slice(g) + b.slice(e + g)
  }

  function n(b) {
    return (b = b.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i)) && 4 === b.length ? "#" + ("0" + parseInt(b[1], 10).toString(16)).slice(-2) + ("0" + parseInt(b[2], 10).toString(16)).slice(-2) + ("0" + parseInt(b[3], 10).toString(16)).slice(-2) : ""
  }

  function V(b) {
    b = b.replace("#", "");
    b = b.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i,
      function (b, f, e, g) {
        return f + f + e + e + g + g
      });
    return "rgb(" + [(bigint = parseInt(b, 16)) >> 16 & 255, bigint >> 8 & 255, bigint & 255].join() + ")"
  }

  function g(b, f, e, l, p) {
    if (!B) return !1;
    b = window.atob(window.btoa("NagishLi"));
    var n = localStorage.getItem(b) ? localStorage.getItem(b) : window.btoa("version:" + L + "|menu:closed|position:" + J + "|submenus:000000|help:0|text:0|colors:normal|display:normal|highlight:00|zoom:0.0|font:normal|animations:on|cursor:normal|tabbing:off|r2m:off|ok:0");
    p = p ? p.toString() : "";
    var x = "menu position submenus help text colors display highlight zoom font animations cursor tabbing r2m ok all".split(" ");
    var r = "write change edit replace read delete".split(" ");
    if ("version" != e && (-1 === x.indexOf(e) || -1 === r.indexOf(f))) return console.log(phrases.missing_setting, "color: RoyalBlue; font-weight: bold;", "", "color: #EB2B36;", ""), !1;
    if ("delete" == f) return localStorage.removeItem(b), !1;
    n = window.atob(n).toString();
    var u;
    r = n.split("|");
    a: {
      x = e + ":";
      for (u = 0; u < r.length; u++)
        if (0 == r[u].indexOf(x)) {
          var C = u;
          break a
        }
      C = -1
    }
    x = r[C] ? r[C].length : "not_found";
    if ("not_found" == x) return g("NagishLi", "delete", "all"), $(commons.bar).css({
      "max-height": "",
      "overflow-y": ""
    }), $(commons.bar + " > #NagishLiBarStrip > #NagishLiToggleMenus, " + commons.bar + " > #NagishLiBarStrip > #NagishLiMove").remove(), $(commons.bar + " > #NagishLiBarStrip").addClass("open"), $(commons.menus).show(), $(commons.menus).html('<li class="dropdown"><ul class="dropdown-menu show"><li class="not-clickable"><div href="#">' + phrases.settings_upgrade_html + "</div></li></ul></li>"), !1;
    u = r[C].split(":")[0];
    r = r[C].split(":")[1];
    if ("write" == f || "change" == f || "edit" == f || "replace" == f) {
      if (n) {
        if ("highlight" !=
          u && "submenus" != u && "ok" != u || "all" == l) {
          var y = 1;
          f = r.length
        } else y = l, f = 1;
        l = n;
        p = e + ":" + F(r, p, y - 1, f);
        e = (n + "").indexOf(e + ":", 0);
        y = F(l, p, -1 === e ? !1 : e, x)
      }
      localStorage.setItem(b, window.btoa(y));
      return !1
    }
    if ("read" == f) return f = "highlight" == u || "ok" == u ? 1 : r.length, y = r.substr(("highlight" != u && "ok" != u || !l ? 1 : l) - 1, f)
  }
  var D = "0",
    M = "0",
    w, f, e;
  var L = "2.2";
  var W = "undefined" != typeof nl_link && "0" != nl_link ? nl_link : !1;
  var p = "undefined" != typeof nl_lang && /^(he|en)$/i.test(nl_lang) ? nl_lang.toLowerCase() : "he";
  var J = "undefined" != typeof nl_pos &&
    /^(tr|br|tl|bl)$/i.test(nl_pos) ? nl_pos.toUpperCase() : "TL";
  var X = "undefined" != typeof nl_color && /^(blue|red|green|purple|yellow|pink|gray|brown|orange|turquoise)$/i.test(nl_color) ? nl_color.toLowerCase() : "blue";
  var pa = "undefined" != typeof nl_compact && "1" == nl_compact ? !0 : !1;
  if ("undefined" != typeof nl_lic) try {
    D = nl_lic, window.atob(D)
  } catch (b) {
    D = "0"
  }
  if ("0" != D) {
    M = window.atob(D).split("+", 2)[0];
    var qa = window.atob(D).split("+", 2)[1]
  }
  var l = location.hostname;
  var N = 0 === l.lastIndexOf("www.", 0) ? "www" : "";
  var Y = "www" ==
    N || "2" == M && "" != N ? l.substr(l.indexOf(".") + 1, l.length) : l.toLowerCase();
  var ra = -1 < navigator.userAgent.toLowerCase().indexOf("firefox") ? !0 : !1;
  var sa = !window.ActiveXObject && "ActiveXObject" in window ? !0 : !1;
  var Z = "en" == p && (window.webkitSpeechSynthesisUtterance || window.mozSpeechSynthesisUtterance || window.msSpeechSynthesisUtterance || window.oSpeechSynthesisUtterance || window.SpeechSynthesisUtterance) ? !0 : !1;
  (function (b) {
    (jQuery.browser = jQuery.browser || {}).mobile = /(android|ipad|playbook|silk|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(b) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(b.substr(0,
        4))
  })(navigator.userAgent || navigator.vendor || window.opera);
  var U = jQuery.browser.mobile;
  var A = "undefined" != typeof nl_accordion && "1" == nl_accordion || U ? !0 : !1;
  var B = function () {
    var b = new Date,
      f;
    try {
      (f = window.localStorage).setItem(b, b);
      var e = f.getItem(b) == b;
      f.removeItem(b);
      return e && f
    } catch (K) {}
  }();
  
  var forEach = function (array, callback, scope) {
    for (var i = 0; i < array.length; i++) {
      callback.call(scope, i, array[i]); // passes back stuff we need
    }
  }
  if ("undefined" != typeof nl_dir) l = "/" == nl_dir.substr(-1) ? nl_dir.slice(0, -1) : nl_dir;
  else {
    l = document.querySelectorAll("script[src]");
    var nagishliSrc;
    forEach(l, function (index, value) {
      if (value.src.indexOf('nagishli') > -1) {
        nagishliSrc = value.src;
      }
    });

    l = nagishliSrc;
    var O = l.split("/");
    l = l.replace(O[O.length - 1], "").slice(0, -1);
  }
  phrases = "en" == p ? {
    a11y_info: "Accessibilty Statement",
    a11y_info_exp: "This website's accessibilty statement",
    a11y_title: "Accessibility",
    about: "About NagishLi",
    about_text: '<span class="nlap-stitle">How this website was made accessible?</span><br />This website was made accessible with <a href="https://www.nagish.li/' + p + '/" target="_blank" tabindex="1">NagishLi</a>, a free accessibility plugin developed by <a href="http://www.localize.co.il" target="_blank" tabindex="1">Localize*</a> and using it is under its <a href="https://www.nagish.li/' +
      p + '/license.html" target="_blank" tabindex="1">license terms</a>.<br /><br /><span class="nlap-stitle">Why develop such a plugin?</span><br />Since the accessibility subject got more attention, free accessibility plugins were offered mostly to WordPress users. Other scripts and website owners were pretty much "left out". Making a website accessible is a complicated and relatively long process (or at least that\'s how people describe it). Localize* also needed a plugin for its own websites, and if you need to manage a few websites, the time and cost of making them accessible can be expensive.<br /><br /><span class="nlap-stitle">Is it really free? Why?</span><br />The plugin was developed initially for Localize\'s personal use, which later decided to release it to the public in order to make every website accessible to impaired people. It still has a long way to develop and improve, but if it\'ll help make more websites accessible to impaired people - Localize* is happy to be a part of that.',
    about_text_lic: '<span class="nlap-stitle">How this website was made accessible?</span><br />This website was made accessible with <a href="https://www.nagish.li/' + p + '/" target="_blank" tabindex="1">NagishLi</a> and using it is under its <a href="https://www.nagish.li/' + p + '/license.html" target="_blank" tabindex="1">license terms</a>.<br /><br /><span class="nlap-stitle">Why develop such a plugin?</span><br />Since the accessibility subject got more attention, free accessibility plugins were offered mostly to WordPress users. Other scripts and website owners were pretty much "left out". Making a website accessible is a complicated and relatively long process (or at least that\'s how people describe it) and if you need to manage a few websites, the time and cost of making them accessible can be expensive. This plugin was developed also for non-WordPress websites.',
    accessibility_statement: 'This website takes accessibilty seriously and make every effort possible to be comfortably accessed by the general population and users with disabilties so that every user will be able to make the most out of the content it presents. For this important purpose, this website uses <a href="https://www.nagish.li/' + p + '/" target="_blank" tabindex="1">NagishLi</a> - a free accessibility plugin. The usage of NagishLi is subject to the terms of <a href="https://www.nagish.li/' + p +
      '/license.html" target="_blank" tabindex="1">license</a> attached to it.<br /><br /><span class="nlas-stitle">How to use the plugin</span><br />After clicking the accesibility button, the accessibility plugin\'s menus will expand, presenting you with the following options:<ul><li>Adjusting text sizes</li><li>Changing website\'s colors</li><li>Changing website\'s display</li><li>Highlight titles and links</li><li>Shrink or magnify the website\'s display (zoom)</li><li>Make the website\'s font easier to read</li><li>Pause animations in the website</li><li>Listen to substituted audio for the pictures in the website using a text-to-speech program</li><li>Listen to an audio reading of phone numbers</li><li>Change the mouse cursor</li><li>Navigate through the plugin options using the Tab key (and also Shift+Tab) and activate them using the Enter key</li></ul>Despite the efforts expended in the development of this plugin, scenarios are possible where content may not be made accessible by it, such as contents presented by a third party (e.g. YouTube, other external embedded content, etc.). Note that NagishLi is in continuous development in order to improve and comply with the latest accessibility standards.<br /><br />This statement was last updated on July 4th, 2017.',
    align_left: "right",
    align_right: "left",
    and: "and&nbsp;",
    animations: "Animations",
    animations_exp: "Stop moving and flickering elements",
    animations_on: "On",
    animations_off: "Off",
    aria_select_bgcolor: "Choose background color",
    aria_select_color: "Choose the color of the ",
    aria_select_txtcolor: "Choose text color",
    aria_the_option: "The option ",
    bg: "Background",
    bl_filter: "Blue light filter",
    bl_filter_exp: "Warm colors",
    blind: "Color blind",
    blind_exp: "Gray colors",
    body_missing: "NagishLi says: the <body> is missing! the accessibility plugin can't work without it.",
    chrome: "Chrome",
    clr_black: "Black",
    clr_blue: "Blue",
    clr_custom: "Custom color",
    clr_gray: "Gray",
    clr_green: "Green",
    clr_orange: "Orange",
    clr_pink: "Pink",
    clr_purple: "Purple",
    clr_red: "Red",
    clr_white: "White",
    clr_yellow: "Yellow",
    collapse_all: "Collapse all the menus",
    color_select: "Choose color",
    color: "color",
    colors: "Colors",
    cursor: "Cursor",
    cursor_exp: "Change the cursor icon",
    cursor_black: "Black",
    cursor_white: "White",
    custom_colors: "Custom",
    custom_colors_exp: "Change background and text colors",
    developed_by: "Developed by Localize",
    developed_by_exp: "Localize* - Web development services",
    developed_in: "Developed in Israel",
    developed_in_link: "https://en.wikipedia.org/wiki/Israel",
    developer_message: "A few words from the main person working on the plugin: \"I'm still studying and investigating the website accessibility subject when I can, and I'm interested in developing more features for this free plugin (there's already a feature list for the next versions), but I'm a busy guy - I can usually only work on this plugin in my free time. I do try my best to make it useful to as many website owners and visitors as possible. If you do decide to use the plugin, and like it - you can donate towards its developement. Any amount is more than welcome. If you choose not to donate, or can't donate, I still hope that the plugin will be useful to you and help your website's visitors.\"",
    dir: "ltr",
    display: "Display",
    edge: "Edge",
    expand_all: "Expand all the menus",
    experimental_feat: "This is an experimental feature",
    explorer: "Internet Explorer",
    firefox: "Firefox",
    font: "Font",
    font_exp: "Change the font of the page",
    font_readable: "Readable",
    help: "Help",
    help_exp: "Click here for help",
    highlight: "Highlight",
    hl_headings: "Highlight titles",
    hl_headings_exp: "Highlight all the titles on the page",
    hl_links: "Highlight links",
    hl_links_exp: "Highlight all the links on the page",
    how_accessible: "About this website accessibility",
    how_accessible_exp: "About this accessibilty plugin",
    images_only: "Images only",
    images_only_exp: "Hide the text on the page",
    img_alt_missing: "Image with no description",
    img_alt: "Possible image description: ",
    impaired: "Impaired vision",
    impaired_exp: "Maximum contrast",
    jq_too_low: "%cNagishLi%c says: your jQuery version is too low, it's possible that some (or all) options of the accessibility plugin won't work.",
    jq_not_found_msg: "%cNagishLi%c says: it seems that jQuery do not exist on this page. The plugin can't function without it, and added the required minimum jQuery version to the page automatically.",
    kbnav: "Keyboard navigation",
    kbnav_exp: "Navigate this site using a keyboard",
    kbnav_off: "Off",
    kbnav_on: "On",
    larger_text: "Larger",
    larger_text_exp: "Enlarge the text with each click",
    lc_filter: "Living colors filter",
    lc_filter_exp: "Cold colors",
    lic_warn: 'This website is using an unlicensed version of NagishLi. A lot of time and effort were put into this plugin, please <a href="http://www.nagish.li/en/contact.html" target="_blank" style="color: black !important; text-decoration: underline !important;" tabindex="1">click here</a> to send an anonymous report about this website. Thank you!',
    logo_alt: "Logo",
    misc: "Misc",
    missing_setting: "%cNagishLi%c says: %cThe setting is missing.%c",
    move_bl: "Move to Bottom Left",
    move_br: "Move to Bottom Right",
    move_tl: "Move to Top Left",
    move_tr: "Move to Top Right",
    normal: "Normal",
    normal_display: "Normal",
    normal_plu: "Normal",
    not_supported: "This feature is not supported by your browser.",
    opera: "Opera",
    r2m: "Audio reading",
    r2m_exp: "Listen to audio version of digits",
    r2m_na: "Audio reading is not available at the moment. Try again later.",
    r2m_off: "in development",
    r2m_on: "in development",
    reset_prompt: "Would you like to reset the accessibilty settings?",
    reset_settings: "Reset settings",
    reset_settings_exp: "Reset all of the settings set by the plugin",
    settings: "Info & Settings",
    settings_prompt: "It seems that the current accessibility settings might be problematic. Would you like to reset the settings? (Recommended)",
    settings_reset_alert_ok: "The settings have been reset. Please refresh the page.",
    settings_reset_html_ok: 'The settings have been reset. <a href="javascript:void(0);" onclick="javascript:location.replace(window.location.href.split(\'#\')[0]);" style="color: black !important; text-decoration: underline !important;" tabindex="1">Refresh the page</a>',
    settings_save: "The settings will be saved.",
    settings_save_reminder: "Remember: You can also reset them under 'Info & Settings'.",
    settings_upgrade_html: 'NagishLi was upgraded. <a href="javascript:void(0);" onclick="javascript:location.replace(window.location.href.split(\'#\')[0]);" style="color: black !important; text-decoration: underline !important;" tabindex="1">Refresh the page</a>',
    smaller_text: "Smaller",
    smaller_text_exp: "Shrink the text with each click",
    supported_browsers: "Supported browsers",
    supported_browsers_exp: "Supported browsers: Google Chrome, Microsoft Edge, Mozilla Firefox, Opera and Internet Explorer. The accessibility plugin makes use of advanced features in your browser. Please use an up-to-date browser.",
    text_only: "Text only",
    text_only_exp: "Hide the images on the page",
    text_size: "Text size",
    txt: "Text",
    toggle_single_alt: "Close or open the menu options of ",
    zoom: "Zoom",
    zoom_exp: "Zoom in and out of the page"
  } : {
    a11y_info: "\u05d4\u05e6\u05d4\u05e8\u05ea \u05e0\u05d2\u05d9\u05e9\u05d5\u05ea",
    a11y_info_exp: "\u05d4\u05e6\u05d4\u05e8\u05ea \u05d4\u05e0\u05d2\u05d9\u05e9\u05d5\u05ea \u05e9\u05dc \u05d0\u05ea\u05e8 \u05d6\u05d4",
    a11y_title: "\u05e0\u05d2\u05d9\u05e9\u05d5\u05ea",
    about: "\u05d0\u05d5\u05d3\u05d5\u05ea \u05e0\u05d2\u05d9\u05e9 \u05dc\u05d9",
    about_text: '<span class="nlap-stitle">\u05db\u05d9\u05e6\u05d3 \u05d4\u05d5\u05e0\u05d2\u05e9 \u05d0\u05ea\u05e8 \u05d6\u05d4?</span><br />\u05d0\u05ea\u05e8 \u05d6\u05d4 \u05d4\u05d5\u05e0\u05d2\u05e9 \u05e2\u05dc \u05d9\u05d3\u05d9 <a href="https://www.nagish.li/' +
      p + '/" target="_blank" tabindex="1">\u05e0\u05d2\u05d9\u05e9 \u05dc\u05d9</a>, \u05ea\u05d5\u05e1\u05e3 \u05e0\u05d2\u05d9\u05e9\u05d5\u05ea \u05dc\u05dc\u05d0 \u05e2\u05dc\u05d5\u05ea \u05e9\u05e4\u05d5\u05ea\u05d7 \u05e2\u05dc \u05d9\u05d3\u05d9 <a href="http://www.localize.co.il" target="_blank" tabindex="1">\u05dc\u05d5\u05e7\u05dc\u05d9\u05d9\u05d6*</a> \u05d5\u05d4\u05e9\u05d9\u05de\u05d5\u05e9 \u05d1\u05d5 \u05db\u05e4\u05d5\u05e3 \u05dc\u05ea\u05e0\u05d0\u05d9 <a href="https://www.nagish.li/' +
      p + '/license.html" target="_blank" tabindex="1">\u05d4\u05e8\u05d9\u05e9\u05d9\u05d5\u05df</a> \u05d4\u05de\u05e6\u05d5\u05e8\u05e4\u05d9\u05dd \u05d0\u05dc\u05d9\u05d5.<br /><br /><span class="nlap-stitle">\u05dc\u05de\u05d4 \u05e4\u05d5\u05ea\u05d7 \u05ea\u05d5\u05e1\u05e3 \u05d6\u05d4?</span><br />\u05de\u05d0\u05d6 \u05e9\u05e0\u05d5\u05e9\u05d0 \u05d4\u05e0\u05d2\u05d9\u05e9\u05d5\u05ea \u05e2\u05dc\u05d4, \u05ea\u05d5\u05e1\u05e4\u05d9 \u05d4\u05e0\u05d2\u05e9\u05d4 \u05d7\u05d9\u05e0\u05de\u05d9\u05d9\u05dd \u05d4\u05d5\u05e6\u05e2\u05d5 \u05d1\u05e2\u05d9\u05e7\u05e8 \u05dc\u05de\u05e9\u05ea\u05de\u05e9\u05d9 \u05de\u05e2\u05e8\u05db\u05ea \u05d5\u05d5\u05e8\u05d3\u05e4\u05e8\u05e1. \u05d1\u05e2\u05dc\u05d9 \u05d0\u05ea\u05e8\u05d9\u05dd \u05d0\u05d7\u05e8\u05d9\u05dd \u05d5\u05de\u05e2\u05e8\u05db\u05d5\u05ea \u05d0\u05d7\u05e8\u05d5\u05ea \u05d3\u05d9 "\u05d4\u05d5\u05d6\u05e0\u05d7\u05d5". \u05d4\u05e0\u05d2\u05e9\u05ea \u05d0\u05ea\u05e8 \u05d4\u05d9\u05d0 \u05ea\u05d4\u05dc\u05d9\u05da \u05de\u05d5\u05e8\u05db\u05d1, \u05de\u05e1\u05d5\u05d1\u05da \u05d5\u05d0\u05e8\u05d5\u05da \u05d9\u05d7\u05e1\u05d9\u05ea (\u05d0\u05d5 \u05dc\u05e4\u05d7\u05d5\u05ea \u05db\u05db\u05d4 \u05de\u05ea\u05d0\u05e8\u05d9\u05dd \u05d0\u05d5\u05ea\u05d5). \u05d2\u05dd \u05dc\u05d5\u05e7\u05dc\u05d9\u05d9\u05d6* \u05e0\u05d6\u05e7\u05e7\u05d4 \u05dc\u05ea\u05d5\u05e1\u05e3 \u05dc\u05d0\u05ea\u05e8\u05d9\u05dd \u05e9\u05dc\u05d4, \u05d5\u05d0\u05dd \u05e6\u05e8\u05d9\u05da \u05dc\u05ea\u05d7\u05d6\u05e7 \u05db\u05de\u05d4 \u05d0\u05ea\u05e8\u05d9\u05dd, \u05e2\u05dc\u05d5\u05ea \u05d5\u05d6\u05de\u05df \u05d4\u05d4\u05e0\u05d2\u05e9\u05d4 \u05e9\u05dc \u05d4\u05d0\u05ea\u05e8\u05d9\u05dd \u05d4\u05d0\u05dc\u05d4 \u05d9\u05db\u05d5\u05dc\u05d9\u05dd \u05dc\u05d4\u05d9\u05d5\u05ea \u05d9\u05e7\u05e8\u05d9\u05dd.<br /><br /><span class="nlap-stitle">\u05d4\u05d5\u05d0 \u05d1\u05d0\u05de\u05ea \u05d1\u05d7\u05d9\u05e0\u05dd? \u05dc\u05de\u05d4?</span><br />\u05d4\u05ea\u05d5\u05e1\u05e3 \u05e4\u05d5\u05ea\u05d7 \u05d1\u05ea\u05d7\u05d9\u05dc\u05d4 \u05e2\u05d1\u05d5\u05e8 \u05d4\u05e9\u05d9\u05de\u05d5\u05e9 \u05d4\u05d0\u05d9\u05e9\u05d9 \u05e9\u05dc \u05dc\u05d5\u05e7\u05dc\u05d9\u05d9\u05d6*, \u05e9\u05dc\u05d0\u05d7\u05e8 \u05de\u05db\u05df \u05d4\u05d7\u05dc\u05d9\u05d8\u05d4 \u05dc\u05e9\u05d7\u05e8\u05e8 \u05d0\u05d5\u05ea\u05d5 \u05dc\u05e6\u05d9\u05d1\u05d5\u05e8 \u05d4\u05e8\u05d7\u05d1 \u05d1\u05de\u05d8\u05e8\u05d4 \u05dc\u05d4\u05e0\u05d2\u05d9\u05e9 \u05db\u05dc \u05d0\u05ea\u05e8 \u05e2\u05d1\u05d5\u05e8 \u05d1\u05e2\u05dc\u05d9 \u05de\u05d5\u05d2\u05d1\u05dc\u05d5\u05d9\u05d5\u05ea. \u05dc\u05ea\u05d5\u05e1\u05e3 \u05d9\u05e9 \u05e2\u05d5\u05d3 \u05d3\u05e8\u05da \u05d0\u05e8\u05d5\u05db\u05d4 \u05dc\u05d4\u05ea\u05e4\u05ea\u05d7 \u05d5\u05dc\u05d4\u05e9\u05ea\u05e4\u05e8, \u05d0\u05d1\u05dc \u05d0\u05dd \u05d4\u05d5\u05d0 \u05d9\u05e1\u05d9\u05d9\u05e2 \u05dc\u05d4\u05e4\u05d5\u05da \u05d9\u05d5\u05ea\u05e8 \u05d0\u05ea\u05e8\u05d9\u05dd \u05dc\u05e0\u05d2\u05d9\u05e9\u05d9\u05dd \u05e2\u05d1\u05d5\u05e8 \u05d1\u05e2\u05dc\u05d9 \u05de\u05d5\u05d2\u05d1\u05dc\u05d5\u05d9\u05d5\u05ea - \u05dc\u05d5\u05e7\u05dc\u05d9\u05d9\u05d6* \u05e9\u05de\u05d7\u05d4 \u05e9\u05d4\u05d9\u05d0 \u05d9\u05db\u05d5\u05dc\u05d4 \u05dc\u05e7\u05d7\u05ea \u05d7\u05dc\u05e7 \u05d1\u05d6\u05d4.',
    about_text_lic: '<span class="nlap-stitle">\u05db\u05d9\u05e6\u05d3 \u05d4\u05d5\u05e0\u05d2\u05e9 \u05d0\u05ea\u05e8 \u05d6\u05d4?</span><br />\u05d0\u05ea\u05e8 \u05d6\u05d4 \u05d4\u05d5\u05e0\u05d2\u05e9 \u05e2\u05dc \u05d9\u05d3\u05d9 <a href="https://www.nagish.li/' + p + '/" target="_blank" tabindex="1">\u05e0\u05d2\u05d9\u05e9 \u05dc\u05d9</a> \u05d5\u05d4\u05e9\u05d9\u05de\u05d5\u05e9 \u05d1\u05d5 \u05db\u05e4\u05d5\u05e3 \u05dc\u05ea\u05e0\u05d0\u05d9 <a href="https://www.nagish.li/' + p + '/license.html" target="_blank" tabindex="1">\u05d4\u05e8\u05d9\u05e9\u05d9\u05d5\u05df</a> \u05d4\u05de\u05e6\u05d5\u05e8\u05e4\u05d9\u05dd \u05d0\u05dc\u05d9\u05d5.<br /><br /><span class="nlap-stitle">\u05dc\u05de\u05d4 \u05e4\u05d5\u05ea\u05d7 \u05ea\u05d5\u05e1\u05e3 \u05d6\u05d4?</span><br />\u05de\u05d0\u05d6 \u05e9\u05e0\u05d5\u05e9\u05d0 \u05d4\u05e0\u05d2\u05d9\u05e9\u05d5\u05ea \u05e2\u05dc\u05d4, \u05ea\u05d5\u05e1\u05e4\u05d9 \u05d4\u05e0\u05d2\u05e9\u05d4 \u05d7\u05d9\u05e0\u05de\u05d9\u05d9\u05dd \u05d4\u05d5\u05e6\u05e2\u05d5 \u05d1\u05e2\u05d9\u05e7\u05e8 \u05dc\u05de\u05e9\u05ea\u05de\u05e9\u05d9 \u05de\u05e2\u05e8\u05db\u05ea \u05d5\u05d5\u05e8\u05d3\u05e4\u05e8\u05e1. \u05d1\u05e2\u05dc\u05d9 \u05d0\u05ea\u05e8\u05d9\u05dd \u05d0\u05d7\u05e8\u05d9\u05dd \u05d5\u05de\u05e2\u05e8\u05db\u05d5\u05ea \u05d0\u05d7\u05e8\u05d5\u05ea \u05d3\u05d9 "\u05d4\u05d5\u05d6\u05e0\u05d7\u05d5". \u05d4\u05e0\u05d2\u05e9\u05ea \u05d0\u05ea\u05e8 \u05d4\u05d9\u05d0 \u05ea\u05d4\u05dc\u05d9\u05da \u05de\u05d5\u05e8\u05db\u05d1, \u05de\u05e1\u05d5\u05d1\u05da \u05d5\u05d0\u05e8\u05d5\u05da \u05d9\u05d7\u05e1\u05d9\u05ea (\u05d0\u05d5 \u05dc\u05e4\u05d7\u05d5\u05ea \u05db\u05db\u05d4 \u05de\u05ea\u05d0\u05e8\u05d9\u05dd \u05d0\u05d5\u05ea\u05d5). \u05ea\u05d5\u05e1\u05e3 \u05d6\u05d4 \u05e4\u05d5\u05ea\u05d7 \u05d2\u05dd \u05e2\u05d1\u05d5\u05e8 \u05d0\u05ea\u05e8\u05d9\u05dd \u05e9\u05d0\u05d9\u05e0\u05dd \u05de\u05d5\u05e4\u05e2\u05dc\u05d9\u05dd \u05e2\u05dc \u05d9\u05d3\u05d9 \u05de\u05e2\u05e8\u05db\u05ea \u05d5\u05d5\u05e8\u05d3\u05e4\u05e8\u05e1.',
    accessibility_statement: '\u05d0\u05ea\u05e8 \u05d6\u05d4 \u05de\u05d9\u05d9\u05d7\u05e1 \u05d7\u05e9\u05d9\u05d1\u05d5\u05ea \u05e8\u05d1\u05d4 \u05dc\u05d4\u05e0\u05d2\u05e9\u05ea \u05d4\u05e9\u05d9\u05de\u05d5\u05e9 \u05d1\u05d5 \u05dc\u05db\u05dc\u05dc \u05d4\u05d0\u05d5\u05db\u05dc\u05d5\u05e1\u05d9\u05d9\u05d4 \u05d5\u05e2\u05d5\u05e9\u05d4 \u05db\u05dc \u05e9\u05d1\u05d9\u05db\u05d5\u05dc\u05ea\u05d5 \u05dc\u05d4\u05d1\u05d8\u05d9\u05d7 \u05e9\u05de\u05e9\u05ea\u05de\u05e9\u05d9\u05dd \u05d1\u05e2\u05dc\u05d9 \u05de\u05d5\u05d2\u05d1\u05dc\u05d5\u05d9\u05d5\u05ea \u05d9\u05d5\u05db\u05dc\u05d5 \u05dc\u05d4\u05e4\u05d9\u05e7 \u05d0\u05ea \u05d4\u05de\u05d9\u05d8\u05d1 \u05de\u05d4\u05ea\u05db\u05e0\u05d9\u05dd \u05d4\u05de\u05d5\u05e6\u05d2\u05d9\u05dd \u05d1\u05d5. \u05d0\u05ea\u05e8 \u05d6\u05d4 \u05de\u05e9\u05ea\u05de\u05e9 \u05d1\u05ea\u05d5\u05e1\u05e3 <a href="https://www.nagish.li/' +
      p + '/" target="_blank" tabindex="1">\u05e0\u05d2\u05d9\u05e9 \u05dc\u05d9</a> \u05dc\u05e9\u05dd \u05de\u05d8\u05e8\u05d4 \u05d7\u05e9\u05d5\u05d1\u05d4 \u05d6\u05d5, \u05d5\u05d4\u05e9\u05d9\u05de\u05d5\u05e9 \u05d1\u05ea\u05d5\u05e1\u05e3 \u05db\u05e4\u05d5\u05e3 \u05dc\u05ea\u05e0\u05d0\u05d9 <a href="https://www.nagish.li/' + p + '/license.html" target="_blank" tabindex="1">\u05d4\u05e8\u05d9\u05e9\u05d9\u05d5\u05df</a> \u05d4\u05de\u05e6\u05d5\u05e8\u05e4\u05d9\u05dd \u05d0\u05dc\u05d9\u05d5.<br /><br /><span class="nlas-stitle">\u05d0\u05d9\u05da \u05dc\u05d4\u05e9\u05ea\u05de\u05e9 \u05d1\u05ea\u05d5\u05e1\u05e3</span><br />\u05dc\u05d0\u05d7\u05e8 \u05d4\u05dc\u05d7\u05d9\u05e6\u05d4 \u05e2\u05dc \u05db\u05e4\u05ea\u05d5\u05e8 \u05d4\u05e0\u05d2\u05d9\u05e9\u05d5\u05ea \u05d9\u05d9\u05e4\u05ea\u05d7\u05d5 \u05d1\u05e4\u05e0\u05d9\u05db\u05dd \u05ea\u05e4\u05e8\u05d9\u05d8\u05d9 \u05ea\u05d5\u05e1\u05e3 \u05d4\u05e0\u05d2\u05d9\u05e9\u05d5\u05ea, \u05d1\u05d0\u05de\u05e6\u05e2\u05d5\u05ea\u05dd \u05ea\u05d5\u05db\u05dc\u05d5:<ul><li>\u05dc\u05e9\u05e0\u05d5\u05ea \u05d0\u05ea \u05d2\u05d5\u05d3\u05dc \u05d4\u05d8\u05e7\u05e1\u05d8</li><li>\u05dc\u05e9\u05e0\u05d5\u05ea \u05d0\u05ea \u05e6\u05d1\u05e2\u05d9 \u05d4\u05d0\u05ea\u05e8</li><li>\u05dc\u05e9\u05e0\u05d5\u05ea \u05d0\u05ea \u05ea\u05e6\u05d5\u05d2\u05ea \u05d4\u05d0\u05ea\u05e8</li><li>\u05dc\u05e1\u05de\u05df \u05e7\u05d9\u05e9\u05d5\u05e8\u05d9\u05dd \u05d5\u05db\u05d5\u05ea\u05e8\u05d5\u05ea \u05d1\u05d0\u05ea\u05e8</li><li>\u05dc\u05d4\u05d2\u05d3\u05d9\u05dc \u05d5\u05dc\u05d4\u05e7\u05d8\u05d9\u05df \u05d0\u05ea \u05ea\u05e6\u05d5\u05d2\u05ea \u05d4\u05d0\u05ea\u05e8 (\u05d6\u05d5\u05dd)</li><li>\u05dc\u05e9\u05e0\u05d5\u05ea \u05d0\u05ea \u05d2\u05d5\u05e4\u05df \u05d4\u05d0\u05ea\u05e8 \u05dc\u05e7\u05e8\u05d9\u05d0</li><li>\u05dc\u05e2\u05e6\u05d5\u05e8 \u05d4\u05e0\u05e4\u05e9\u05d5\u05ea (\u05d0\u05e0\u05d9\u05de\u05e6\u05d9\u05d5\u05ea) \u05d1\u05d0\u05ea\u05e8</li><li>\u05dc\u05d4\u05d0\u05d6\u05d9\u05df \u05dc\u05d8\u05e7\u05e1\u05d8 \u05d7\u05dc\u05d5\u05e4\u05d9 \u05e2\u05d1\u05d5\u05e8 \u05ea\u05de\u05d5\u05e0\u05d5\u05ea \u05d1\u05d0\u05de\u05e6\u05e2\u05d5\u05ea \u05ea\u05d5\u05db\u05e0\u05ea \u05d4\u05e7\u05e8\u05d0\u05d4</li><li>\u05dc\u05d4\u05d0\u05d6\u05d9\u05df \u05dc\u05de\u05e1\u05e4\u05e8\u05d9 \u05d8\u05dc\u05e4\u05d5\u05df \u05d1\u05d0\u05de\u05e6\u05e2\u05d5\u05ea \u05d4\u05e7\u05e8\u05d0\u05d4 \u05e7\u05d5\u05dc\u05d9\u05ea</li><li>\u05dc\u05e9\u05e0\u05d5\u05ea \u05d0\u05ea \u05e1\u05de\u05df \u05d4\u05e2\u05db\u05d1\u05e8</li><li>\u05dc\u05e0\u05d5\u05d5\u05d8 \u05d1\u05d9\u05df \u05d0\u05e4\u05e9\u05e8\u05d5\u05d9\u05d5\u05ea \u05d4\u05ea\u05d5\u05e1\u05e3 \u05d1\u05d0\u05de\u05e6\u05e2\u05d5\u05ea \u05d4\u05de\u05e7\u05e9 Tab (\u05d5\u05d2\u05dd Shift+Tab) \u05d5\u05d4\u05e4\u05e2\u05dc\u05ea\u05df \u05d1\u05d0\u05de\u05e6\u05e2\u05d5\u05ea \u05d4\u05de\u05e7\u05e9 Enter</li></ul>\u05dc\u05de\u05e8\u05d5\u05ea \u05d4\u05de\u05d0\u05de\u05e6\u05d9\u05dd \u05e9\u05d4\u05d5\u05e9\u05e7\u05e2\u05d5 \u05d1\u05e4\u05d9\u05ea\u05d5\u05d7 \u05ea\u05d5\u05e1\u05e3 \u05d6\u05d4, \u05d9\u05d9\u05ea\u05db\u05e0\u05d5 \u05de\u05e6\u05d1\u05d9\u05dd \u05e9\u05d1\u05d4\u05dd \u05dc\u05d0 \u05ea\u05d4\u05d9\u05d4 \u05dc\u05d5 \u05d0\u05e4\u05e9\u05e8\u05d5\u05ea \u05dc\u05d4\u05e0\u05d2\u05d9\u05e9 \u05d7\u05dc\u05e7 \u05de\u05ea\u05db\u05e0\u05d9 \u05d4\u05d0\u05ea\u05e8, \u05db\u05d2\u05d5\u05df \u05ea\u05db\u05e0\u05d9\u05dd \u05d4\u05de\u05d5\u05e6\u05e2\u05d9\u05dd \u05d3\u05e8\u05da \u05d2\u05d5\u05e8\u05de\u05d9 \u05e6\u05d3 \u05e9\u05dc\u05d9\u05e9\u05d9 (\u05db\u05d3\u05d5\u05d2\u05de\u05ea YouTube, \u05ea\u05db\u05e0\u05d9\u05dd \u05de\u05d5\u05d8\u05de\u05e2\u05d9\u05dd \u05de\u05d0\u05ea\u05e8\u05d9\u05dd \u05d0\u05d7\u05e8\u05d9\u05dd \u05d5\u05db\u05d3\u05d5\u05de\u05d4). \u05d7\u05e9\u05d5\u05d1 \u05dc\u05e6\u05d9\u05d9\u05df \u05e9\u05e0\u05d2\u05d9\u05e9 \u05dc\u05d9 \u05e0\u05de\u05e6\u05d0 \u05d1\u05e4\u05d9\u05ea\u05d5\u05d7 \u05de\u05ea\u05de\u05d9\u05d3 \u05e2\u05dc \u05de\u05e0\u05ea \u05dc\u05d4\u05e9\u05ea\u05e4\u05e8 \u05d5\u05dc\u05e2\u05de\u05d5\u05d3 \u05d1\u05ea\u05e7\u05e0\u05d9 \u05d4\u05e0\u05d2\u05d9\u05e9\u05d5\u05ea \u05d4\u05e2\u05d3\u05db\u05e0\u05d9\u05d9\u05dd \u05d1\u05d9\u05d5\u05ea\u05e8.<br /><br />\u05d4\u05e6\u05d4\u05e8\u05d4 \u05d6\u05d5 \u05e2\u05d5\u05d3\u05db\u05e0\u05d4 \u05dc\u05d0\u05d7\u05e8\u05d5\u05e0\u05d4 \u05d1\u05ea\u05d0\u05e8\u05d9\u05da \u05d4-4.7.2017.',
    align_left: "left",
    align_right: "right",
    and: "\u05d5",
    animations: "\u05d4\u05e0\u05e4\u05e9\u05d5\u05ea \u05d1\u05d3\u05e3",
    animations_exp: "\u05d4\u05e4\u05e1\u05e7\u05ea \u05ea\u05d6\u05d5\u05d6\u05d5\u05ea \u05d5\u05d4\u05d1\u05d4\u05d5\u05d1\u05d9\u05dd \u05d1\u05d3\u05e3",
    animations_on: "\u05e4\u05e2\u05d9\u05dc\u05d5\u05ea",
    animations_off: "\u05de\u05d5\u05e4\u05e1\u05e7\u05d5\u05ea",
    aria_select_bgcolor: "\u05d1\u05d7\u05d9\u05e8\u05ea \u05e6\u05d1\u05e2 \u05e8\u05e7\u05e2",
    aria_select_color: "\u05d1\u05d7\u05d9\u05e8\u05ea \u05e6\u05d1\u05e2 ",
    aria_select_txtcolor: "\u05d1\u05d7\u05d9\u05e8\u05ea \u05e6\u05d1\u05e2 \u05d8\u05e7\u05e1\u05d8",
    aria_the_option: "\u05d4\u05d0\u05e4\u05e9\u05e8\u05d5\u05ea ",
    bg: "\u05e8\u05e7\u05e2",
    bl_filter: "\u05de\u05e1\u05e0\u05df \u05d0\u05d5\u05e8 \u05db\u05d7\u05d5\u05dc",
    bl_filter_exp: "\u05e6\u05d1\u05e2\u05d9\u05dd \u05d7\u05de\u05d9\u05dd",
    blind: "\u05e2\u05d9\u05d5\u05d5\u05e8\u05d9 \u05e6\u05d1\u05e2\u05d9\u05dd",
    blind_exp: "\u05d2\u05d5\u05d5\u05e0\u05d9 \u05e9\u05d7\u05d5\u05e8 \u05dc\u05d1\u05df",
    body_missing: "\u05e0\u05d2\u05d9\u05e9 \u05dc\u05d9 \u05d0\u05d5\u05de\u05e8: \u05ea\u05d2 \u05d4-<body> \u05d7\u05e1\u05e8! \u05ea\u05d5\u05e1\u05e3 \u05d4\u05e0\u05d2\u05d9\u05e9\u05d5\u05ea \u05dc\u05d0 \u05d9\u05db\u05d5\u05dc \u05dc\u05e2\u05d1\u05d5\u05d3 \u05d1\u05dc\u05e2\u05d3\u05d9\u05d5.",
    chrome: "\u05db\u05e8\u05d5\u05dd",
    clr_black: "\u05e9\u05d7\u05d5\u05e8",
    clr_blue: "\u05db\u05d7\u05d5\u05dc",
    clr_custom: "\u05d1\u05d7\u05d9\u05e8\u05d4 \u05d0\u05d9\u05e9\u05d9\u05ea",
    clr_gray: "\u05d0\u05e4\u05d5\u05e8",
    clr_green: "\u05d9\u05e8\u05d5\u05e7",
    clr_orange: "\u05db\u05ea\u05d5\u05dd",
    clr_pink: "\u05d5\u05e8\u05d5\u05d3",
    clr_purple: "\u05e1\u05d2\u05d5\u05dc",
    clr_red: "\u05d0\u05d3\u05d5\u05dd",
    clr_white: "\u05dc\u05d1\u05df",
    clr_yellow: "\u05e6\u05d4\u05d5\u05d1",
    collapse_all: "\u05dc\u05e1\u05d2\u05d5\u05e8 \u05d0\u05ea \u05db\u05dc \u05d4\u05ea\u05e4\u05e8\u05d9\u05d8\u05d9\u05dd",
    color: "\u05e6\u05d1\u05e2",
    colors: "\u05e6\u05d1\u05e2\u05d9\u05dd",
    cursor: "\u05e1\u05de\u05df \u05e2\u05db\u05d1\u05e8",
    cursor_exp: "\u05e9\u05d9\u05e0\u05d5\u05d9 \u05e1\u05de\u05df \u05d4\u05e2\u05db\u05d1\u05e8 \u05dc\u05d4\u05ea\u05d0\u05de\u05d4 \u05e2\u05d1\u05d5\u05e8 \u05e6\u05d1\u05e2\u05d9 \u05e8\u05e7\u05e2 \u05e9\u05d5\u05e0\u05d9\u05dd",
    cursor_black: "\u05e9\u05d7\u05d5\u05e8",
    cursor_white: "\u05dc\u05d1\u05df",
    custom_colors: "\u05d4\u05ea\u05d0\u05de\u05d4 \u05d0\u05d9\u05e9\u05d9\u05ea",
    custom_colors_exp: "\u05e9\u05d9\u05e0\u05d5\u05d9 \u05e6\u05d1\u05e2\u05d9 \u05d4\u05e8\u05e7\u05e2 \u05d5\u05d4\u05d8\u05e7\u05e1\u05d8",
    developed_by: "\u05e4\u05d5\u05ea\u05d7 \u05e2\u05dc \u05d9\u05d3\u05d9 \u05dc\u05d5\u05e7\u05dc\u05d9\u05d9\u05d6",
    developed_by_exp: "\u05dc\u05d5\u05e7\u05dc\u05d9\u05d9\u05d6* - \u05e9\u05d9\u05e8\u05d5\u05ea\u05d9 \u05d1\u05e0\u05d9\u05d9\u05ea \u05d0\u05ea\u05e8\u05d9\u05dd",
    developed_in: "\u05e4\u05d5\u05ea\u05d7 \u05d1\u05d9\u05e9\u05e8\u05d0\u05dc",
    developed_in_link: "https://he.wikipedia.org/wiki/\u05d9\u05e9\u05e8\u05d0\u05dc",
    developer_message: '\u05db\u05de\u05d4 \u05de\u05d9\u05dc\u05d9\u05dd \u05de\u05d4\u05de\u05e4\u05ea\u05d7 \u05d4\u05e2\u05d9\u05e7\u05e8\u05d9 \u05e9\u05dc \u05e0\u05d2\u05d9\u05e9 \u05dc\u05d9: "\u05d0\u05e0\u05d9 \u05e2\u05d3\u05d9\u05d9\u05df \u05d1\u05d5\u05d3\u05e7 \u05d5\u05dc\u05d5\u05de\u05d3 \u05d0\u05ea \u05e0\u05d5\u05e9\u05d0 \u05d4\u05e0\u05d2\u05e9\u05ea \u05d4\u05d0\u05ea\u05e8\u05d9\u05dd \u05db\u05e9\u05d0\u05e0\u05d9 \u05d9\u05db\u05d5\u05dc, \u05d5\u05de\u05e2\u05d5\u05e0\u05d9\u05d9\u05df \u05dc\u05e4\u05ea\u05d7 \u05d0\u05e4\u05e9\u05e8\u05d5\u05d9\u05d5\u05ea \u05e0\u05d5\u05e1\u05e4\u05d5\u05ea \u05e2\u05d1\u05d5\u05e8 \u05d4\u05ea\u05d5\u05e1\u05e3 \u05d4\u05d7\u05d9\u05e0\u05de\u05d9 \u05d4\u05d6\u05d4 (\u05d9\u05e9 \u05db\u05d1\u05e8 \u05e8\u05e9\u05d9\u05de\u05ea \u05d0\u05e4\u05e9\u05e8\u05d5\u05d9\u05d5\u05ea \u05dc\u05d2\u05d9\u05e8\u05e1\u05d0\u05d5\u05ea \u05d4\u05d1\u05d0\u05d5\u05ea), \u05d0\u05d1\u05dc \u05d0\u05e0\u05d9 \u05d0\u05d3\u05dd \u05e2\u05d5\u05d1\u05d3 \u05e9\u05dc\u05d0 \u05ea\u05de\u05d9\u05d3 \u05d9\u05db\u05d5\u05dc \u05dc\u05de\u05e6\u05d5\u05d0 \u05d0\u05ea \u05d4\u05d6\u05de\u05df \u05dc\u05d4\u05de\u05e9\u05d9\u05da \u05d5\u05dc\u05e4\u05ea\u05d7 \u05d0\u05ea \u05d4\u05ea\u05d5\u05e1\u05e3 \u05de\u05e2\u05d1\u05e8 \u05dc\u05d6\u05de\u05e0\u05d9 \u05d4\u05e4\u05e0\u05d5\u05d9. \u05d0\u05e0\u05d9 \u05de\u05e9\u05ea\u05d3\u05dc \u05dc\u05d4\u05e9\u05e7\u05d9\u05e2 \u05d1\u05d5 \u05db\u05d3\u05d9 \u05e9\u05d9\u05d5\u05db\u05dc \u05dc\u05d4\u05d5\u05e2\u05d9\u05dc \u05dc\u05db\u05de\u05d4 \u05e9\u05d9\u05d5\u05ea\u05e8 \u05de\u05e9\u05ea\u05de\u05e9\u05d9\u05dd \u05d5\u05d1\u05e2\u05dc\u05d9 \u05d0\u05ea\u05e8\u05d9\u05dd. \u05d0\u05dd \u05d4\u05d7\u05dc\u05d8\u05ea\u05dd \u05dc\u05d4\u05e9\u05ea\u05de\u05e9 \u05d1\u05ea\u05d5\u05e1\u05e3, \u05d5\u05d0\u05d4\u05d1\u05ea\u05dd \u05d0\u05d5\u05ea\u05d5 - \u05d0\u05ea\u05dd \u05de\u05d5\u05d6\u05de\u05e0\u05d9\u05dd \u05dc\u05ea\u05e8\u05d5\u05dd \u05e2\u05d1\u05d5\u05e8 \u05d4\u05ea\u05e7\u05d3\u05de\u05d5\u05ea \u05d4\u05e4\u05d9\u05ea\u05d5\u05d7 \u05e9\u05dc\u05d5. \u05db\u05dc \u05e1\u05db\u05d5\u05dd \u05d9\u05ea\u05e7\u05d1\u05dc \u05d1\u05d1\u05e8\u05db\u05d4. \u05d0\u05dd \u05d4\u05d7\u05dc\u05d8\u05ea\u05dd \u05dc\u05d0 \u05dc\u05ea\u05e8\u05d5\u05dd \u05d0\u05d5 \u05e9\u05d0\u05d9\u05df \u05d1\u05d0\u05e4\u05e9\u05e8\u05d5\u05ea\u05db\u05dd \u05dc\u05ea\u05e8\u05d5\u05dd, \u05d0\u05e0\u05d9 \u05de\u05e7\u05d5\u05d5\u05d4 \u05e9\u05d4\u05ea\u05d5\u05e1\u05e3 \u05d1\u05db\u05dc \u05d6\u05d0\u05ea \u05d9\u05d5\u05e2\u05d9\u05dc \u05dc\u05db\u05dd \u05d5\u05d9\u05e1\u05d9\u05d9\u05e2 \u05dc\u05d2\u05d5\u05dc\u05e9\u05d9\u05dd \u05d1\u05d0\u05ea\u05e8 \u05e9\u05dc\u05db\u05dd."',
    dir: "rtl",
    display: "\u05ea\u05e6\u05d5\u05d2\u05d4",
    edge: "\u05d0\u05d3\u05d2'",
    expand_all: "\u05dc\u05e4\u05ea\u05d5\u05d7 \u05d0\u05ea \u05db\u05dc \u05d4\u05ea\u05e4\u05e8\u05d9\u05d8\u05d9\u05dd",
    experimental_feat: "\u05d6\u05d5\u05d4\u05d9 \u05ea\u05db\u05d5\u05e0\u05d4 \u05e0\u05d9\u05e1\u05d9\u05d5\u05e0\u05d9\u05ea",
    explorer: "\u05d0\u05d9\u05e0\u05d8\u05e8\u05e0\u05d8 \u05d0\u05e7\u05e1\u05e4\u05dc\u05d5\u05e8\u05e8",
    firefox: "\u05e4\u05d9\u05d9\u05e8\u05e4\u05d5\u05e7\u05e1",
    font: "\u05d2\u05d5\u05e4\u05df",
    font_exp: "\u05e9\u05d9\u05e0\u05d5\u05d9 \u05d4\u05d2\u05d5\u05e4\u05df \u05e9\u05dc \u05d4\u05d3\u05e3",
    font_readable: "\u05e7\u05e8\u05d9\u05d0",
    help: "\u05e2\u05d6\u05e8\u05d4",
    help_exp: "\u05dc\u05d7\u05e6\u05d5 \u05db\u05d0\u05df \u05dc\u05d4\u05e6\u05d2\u05ea \u05e2\u05d6\u05e8\u05d4 \u05d1\u05ea\u05d5\u05e1\u05e3 \u05d4\u05e0\u05d2\u05d9\u05e9\u05d5\u05ea",
    highlight: "\u05d4\u05d3\u05d2\u05e9\u05d4",
    hl_headings: "\u05e1\u05d9\u05de\u05d5\u05df \u05db\u05d5\u05ea\u05e8\u05d5\u05ea",
    hl_headings_exp: "\u05e1\u05d9\u05de\u05d5\u05df \u05db\u05dc \u05d4\u05db\u05d5\u05ea\u05e8\u05d5\u05ea \u05d1\u05d3\u05e3",
    hl_links: "\u05e1\u05d9\u05de\u05d5\u05df \u05e7\u05d9\u05e9\u05d5\u05e8\u05d9\u05dd",
    hl_links_exp: "\u05e1\u05d9\u05de\u05d5\u05df \u05db\u05dc \u05d4\u05e7\u05d9\u05e9\u05d5\u05e8\u05d9\u05dd \u05d1\u05d3\u05e3",
    how_accessible: "\u05db\u05d9\u05e6\u05d3 \u05d4\u05d5\u05e0\u05d2\u05e9 \u05d0\u05ea\u05e8 \u05d6\u05d4",
    how_accessible_exp: "\u05d0\u05d5\u05d3\u05d5\u05ea \u05ea\u05d5\u05e1\u05e3 \u05d4\u05e0\u05d2\u05d9\u05e9\u05d5\u05ea",
    images_only: "\u05ea\u05de\u05d5\u05e0\u05d5\u05ea \u05d1\u05dc\u05d1\u05d3",
    images_only_exp: "\u05d4\u05e1\u05ea\u05e8\u05ea \u05d4\u05d8\u05e7\u05e1\u05d8 \u05d1\u05d3\u05e3",
    img_alt_missing: "\u05ea\u05de\u05d5\u05e0\u05d4 \u05dc\u05dc\u05d0 \u05ea\u05d9\u05d0\u05d5\u05e8",
    img_alt: "\u05ea\u05d9\u05d0\u05d5\u05e8 \u05d0\u05e4\u05e9\u05e8\u05d9 \u05e9\u05dc \u05ea\u05de\u05d5\u05e0\u05d4: ",
    impaired: "\u05db\u05d1\u05d3\u05d9 \u05e8\u05d0\u05d9\u05d9\u05d4",
    impaired_exp: "\u05e0\u05d9\u05d2\u05d5\u05d3\u05d9\u05d5\u05ea \u05de\u05e7\u05e1\u05d9\u05de\u05dc\u05d9\u05ea",
    jq_too_low: "%c\u05e0\u05d2\u05d9\u05e9 \u05dc\u05d9%c \u05d0\u05d5\u05de\u05e8: \u05d2\u05d9\u05e8\u05e1\u05ea jQuery \u05d1\u05d0\u05ea\u05e8 \u05d6\u05d4 \u05e0\u05de\u05d5\u05db\u05d4 \u05de\u05d3\u05d9. \u05d9\u05d9\u05ea\u05db\u05df \u05e9\u05d7\u05dc\u05e7 \u05de\u05d0\u05e4\u05e9\u05e8\u05d5\u05d9\u05d5\u05ea \u05ea\u05d5\u05e1\u05e3 \u05d4\u05e0\u05d2\u05d9\u05e9\u05d5\u05ea \u05dc\u05d0 \u05d9\u05e2\u05d1\u05d3\u05d5 (\u05d0\u05d5 \u05db\u05d5\u05dc\u05df).",
    jq_not_found_msg: "%c\u05e0\u05d2\u05d9\u05e9 \u05dc\u05d9%c \u05d0\u05d5\u05de\u05e8: \u05e0\u05e8\u05d0\u05d4 \u05e9-jQuery \u05dc\u05d0 \u05e0\u05de\u05e6\u05d0\u05d4 \u05d1\u05d3\u05e3 \u05d6\u05d4. \u05d4\u05ea\u05d5\u05e1\u05e3 \u05dc\u05d0 \u05d9\u05db\u05d5\u05dc \u05dc\u05e4\u05e2\u05d5\u05dc \u05d1\u05dc\u05e2\u05d3\u05d9\u05d4, \u05d5\u05d4\u05d8\u05de\u05d9\u05e2 \u05d1\u05d3\u05e3 \u05d0\u05ea \u05d4\u05d2\u05d9\u05e8\u05e1\u05d4 \u05d4\u05de\u05d9\u05e0\u05d9\u05de\u05dc\u05d9\u05ea \u05d4\u05d3\u05e8\u05d5\u05e9\u05d4 \u05e2\u05d1\u05d5\u05e8\u05d5 \u05d1\u05d0\u05d5\u05e4\u05df \u05d0\u05d5\u05d8\u05d5\u05de\u05d8\u05d9.",
    kbnav: "\u05e0\u05d9\u05d5\u05d5\u05d8 \u05de\u05e7\u05dc\u05d3\u05ea",
    kbnav_exp: "\u05e0\u05d9\u05d5\u05d5\u05d8 \u05d1\u05d0\u05ea\u05e8 \u05d1\u05d0\u05de\u05e6\u05e2\u05d5\u05ea \u05de\u05e7\u05e9\u05d9 \u05d4\u05de\u05e7\u05dc\u05d3\u05ea",
    kbnav_off: "\u05db\u05d1\u05d5\u05d9",
    kbnav_on: "\u05e4\u05e2\u05d9\u05dc",
    larger_text: "\u05d2\u05d3\u05d5\u05dc \u05d9\u05d5\u05ea\u05e8",
    larger_text_exp: "\u05d4\u05d2\u05d3\u05dc\u05ea \u05d4\u05d8\u05e7\u05e1\u05d8 \u05d1\u05db\u05dc \u05dc\u05d7\u05d9\u05e6\u05d4",
    lc_filter: "\u05de\u05e1\u05e0\u05df \u05e6\u05d1\u05e2\u05d9\u05dd \u05d7\u05d9\u05d9\u05dd",
    lc_filter_exp: "\u05e6\u05d1\u05e2\u05d9\u05dd \u05e7\u05e8\u05d9\u05dd",
    lic_warn: '\u05d0\u05ea\u05e8 \u05d6\u05d4 \u05de\u05e9\u05ea\u05de\u05e9 \u05d1\u05e2\u05d5\u05ea\u05e7 \u05dc\u05d0 \u05d7\u05d5\u05e7\u05d9 \u05e9\u05dc \u05e0\u05d2\u05d9\u05e9 \u05dc\u05d9. \u05de\u05d0\u05de\u05e5 \u05d5\u05d6\u05de\u05df \u05e8\u05d1\u05d9\u05dd \u05d4\u05d5\u05e9\u05e7\u05e2\u05d5 \u05d1\u05e4\u05d9\u05ea\u05d5\u05d7 \u05d4\u05ea\u05d5\u05e1\u05e3, \u05d0\u05e0\u05d0 <a href="http://www.nagish.li/he/contact.html" target="_blank" style="color: black !important; text-decoration: underline !important;" tabindex="1">\u05dc\u05d7\u05e6\u05d5 \u05db\u05d0\u05df</a> \u05db\u05d3\u05d9 \u05dc\u05d3\u05d5\u05d5\u05d7 \u05e2\u05dc \u05d0\u05ea\u05e8 \u05d6\u05d4 \u05d1\u05d0\u05d5\u05e4\u05df \u05d0\u05e0\u05d5\u05e0\u05d9\u05de\u05d9. \u05ea\u05d5\u05d3\u05d4!',
    logo_alt: "\u05dc\u05d5\u05d2\u05d5",
    misc: "\u05e9\u05d5\u05e0\u05d5\u05ea",
    missing_setting: "%c\u05e0\u05d2\u05d9\u05e9 \u05dc\u05d9%c \u05d0\u05d5\u05de\u05e8: %c\u05d4\u05d4\u05d2\u05d3\u05e8\u05d4 \u05d7\u05e1\u05e8\u05d4.%c",
    move_bl: "\u05dc\u05d4\u05d6\u05d9\u05d6 \u05e9\u05de\u05d0\u05dc\u05d4 \u05d5\u05dc\u05de\u05d8\u05d4",
    move_br: "\u05dc\u05d4\u05d6\u05d9\u05d6 \u05d9\u05de\u05d9\u05e0\u05d4 \u05d5\u05dc\u05de\u05d8\u05d4",
    move_tl: "\u05dc\u05d4\u05d6\u05d9\u05d6 \u05e9\u05de\u05d0\u05dc\u05d4 \u05d5\u05dc\u05de\u05e2\u05dc\u05d4",
    move_tr: "\u05dc\u05d4\u05d6\u05d9\u05d6 \u05d9\u05de\u05d9\u05e0\u05d4 \u05d5\u05dc\u05de\u05e2\u05dc\u05d4",
    normal: "\u05e8\u05d2\u05d9\u05dc",
    normal_display: "\u05e8\u05d2\u05d9\u05dc\u05d4",
    normal_plu: "\u05e8\u05d2\u05d9\u05dc\u05d9\u05dd",
    not_supported: "\u05d0\u05e4\u05e9\u05e8\u05d5\u05ea \u05d6\u05d5 \u05d0\u05d9\u05e0\u05d4 \u05e0\u05ea\u05de\u05db\u05ea \u05e2\u05dc \u05d9\u05d3\u05d9 \u05d4\u05d3\u05e4\u05d3\u05e4\u05df \u05e9\u05dc\u05da.",
    opera: "\u05d0\u05d5\u05e4\u05e8\u05d4",
    r2m: "\u05d4\u05e7\u05e8\u05d0\u05d4 \u05e7\u05d5\u05dc\u05d9\u05ea",
    r2m_exp: "\u05d4\u05e7\u05e8\u05d0\u05ea \u05e1\u05e4\u05e8\u05d5\u05ea",
    r2m_na: "\u05d4\u05e7\u05e8\u05d0\u05d4 \u05e7\u05d5\u05dc\u05d9\u05ea \u05d0\u05d9\u05e0\u05d4 \u05d6\u05de\u05d9\u05e0\u05d4 \u05db\u05e8\u05d2\u05e2. \u05e0\u05e1\u05d5 \u05e9\u05d5\u05d1 \u05de\u05d0\u05d5\u05d7\u05e8 \u05d9\u05d5\u05ea\u05e8.",
    r2m_off: "\u05db\u05d1\u05d5\u05d9\u05d4",
    r2m_on: "\u05e4\u05e2\u05d9\u05dc\u05d4",
    reset_prompt: "\u05dc\u05d0\u05e4\u05e1 \u05d0\u05ea \u05d4\u05d2\u05d3\u05e8\u05d5\u05ea \u05d4\u05e0\u05d2\u05d9\u05e9\u05d5\u05ea?",
    reset_settings: "\u05d0\u05d9\u05e4\u05d5\u05e1 \u05d4\u05d2\u05d3\u05e8\u05d5\u05ea",
    reset_settings_exp: "\u05d0\u05d9\u05e4\u05d5\u05e1 \u05db\u05dc \u05d4\u05d4\u05d2\u05d3\u05e8\u05d5\u05ea \u05e9\u05dc \u05ea\u05d5\u05e1\u05e3 \u05d4\u05e0\u05d2\u05d9\u05e9\u05d5\u05ea",
    settings: "\u05de\u05d9\u05d3\u05e2 \u05d5\u05d4\u05d2\u05d3\u05e8\u05d5\u05ea",
    settings_prompt: "\u05e0\u05e8\u05d0\u05d4 \u05e9\u05de\u05d9\u05e9\u05d4\u05d5 \u05d4\u05ea\u05e2\u05e1\u05e7 \u05e2\u05dd \u05d4\u05d2\u05d3\u05e8\u05d5\u05ea \u05d4\u05e0\u05d2\u05d9\u05e9\u05d5\u05ea. \u05d4\u05d0\u05dd \u05d1\u05e8\u05e6\u05d5\u05e0\u05da \u05dc\u05d0\u05e4\u05e1 \u05d0\u05ea \u05d4\u05d4\u05d2\u05d3\u05e8\u05d5\u05ea? (\u05de\u05d5\u05de\u05dc\u05e5)",
    settings_reset_alert_ok: "\u05d4\u05d4\u05d2\u05d3\u05e8\u05d5\u05ea \u05d0\u05d5\u05e4\u05e1\u05d5. \u05e0\u05d0 \u05dc\u05e8\u05e2\u05e0\u05df \u05d0\u05ea \u05d4\u05e2\u05de\u05d5\u05d3.",
    settings_reset_html_ok: '\u05d4\u05d4\u05d2\u05d3\u05e8\u05d5\u05ea \u05d0\u05d5\u05e4\u05e1\u05d5. <a href="javascript:void(0);" onclick="javascript:location.replace(window.location.href.split(\'#\')[0]);" style="color: black !important; text-decoration: underline !important;" tabindex="1">\u05dc\u05e8\u05e2\u05e0\u05df \u05d0\u05ea \u05d4\u05e2\u05de\u05d5\u05d3</a>',
    settings_save: "\u05d4\u05d4\u05d2\u05d3\u05e8\u05d5\u05ea \u05d9\u05d9\u05e9\u05de\u05e8\u05d5.",
    settings_save_reminder: "\u05d7\u05e9\u05d5\u05d1 \u05dc\u05d6\u05db\u05d5\u05e8: \u05d0\u05e4\u05e9\u05e8 \u05dc\u05d0\u05e4\u05e1 \u05d0\u05d5\u05ea\u05df \u05d2\u05dd \u05d1\u05ea\u05e4\u05e8\u05d9\u05d8 '\u05de\u05d9\u05d3\u05e2 \u05d5\u05d4\u05d2\u05d3\u05e8\u05d5\u05ea'.",
    settings_upgrade_html: '\u05e0\u05d2\u05d9\u05e9 \u05dc\u05d9 \u05e9\u05d5\u05d3\u05e8\u05d2. <a href="javascript:void(0);" onclick="javascript:location.replace(window.location.href.split(\'#\')[0]);" style="color: black !important; text-decoration: underline !important;" tabindex="1">\u05dc\u05e8\u05e2\u05e0\u05df \u05d0\u05ea \u05d4\u05e2\u05de\u05d5\u05d3</a>',
    smaller_text: "\u05e7\u05d8\u05df \u05d9\u05d5\u05ea\u05e8",
    smaller_text_exp: "\u05d4\u05e7\u05d8\u05e0\u05ea \u05d4\u05d8\u05e7\u05e1\u05d8 \u05d1\u05db\u05dc \u05dc\u05d7\u05d9\u05e6\u05d4",
    supported_browsers: "\u05d3\u05e4\u05d3\u05e4\u05e0\u05d9\u05dd \u05e0\u05ea\u05de\u05db\u05d9\u05dd",
    supported_browsers_exp: "\u05d3\u05e4\u05d3\u05e4\u05e0\u05d9\u05dd \u05e0\u05ea\u05de\u05db\u05d9\u05dd: \u05d2\u05d5\u05d2\u05dc \u05db\u05e8\u05d5\u05dd, \u05de\u05d9\u05e7\u05e8\u05d5\u05e1\u05d5\u05e4\u05d8 \u05d0\u05d3\u05d2', \u05de\u05d5\u05d6\u05d9\u05dc\u05d4 \u05e4\u05d9\u05d9\u05e8\u05e4\u05d5\u05e7\u05e1, \u05d0\u05d5\u05e4\u05e8\u05d4 \u05d5\u05d0\u05d9\u05e0\u05d8\u05e8\u05e0\u05d8 \u05d0\u05e7\u05e1\u05e4\u05dc\u05d5\u05e8\u05e8. \u05ea\u05d5\u05e1\u05e3 \u05d4\u05e0\u05d2\u05d9\u05e9\u05d5\u05ea \u05e2\u05d5\u05e9\u05d4 \u05e9\u05d9\u05de\u05d5\u05e9 \u05d1\u05d0\u05e4\u05e9\u05e8\u05d5\u05d9\u05d5\u05ea \u05de\u05ea\u05e7\u05d3\u05de\u05d5\u05ea \u05d1\u05d3\u05e4\u05d3\u05e4\u05df \u05e9\u05dc\u05db\u05dd. \u05d4\u05e7\u05e4\u05d9\u05d3\u05d5 \u05ea\u05de\u05d9\u05d3 \u05dc\u05d4\u05e9\u05ea\u05de\u05e9 \u05d1\u05d3\u05e4\u05d3\u05e4\u05df \u05e2\u05d3\u05db\u05e0\u05d9.",
    text_only: "\u05d8\u05e7\u05e1\u05d8 \u05d1\u05dc\u05d1\u05d3",
    text_only_exp: "\u05d4\u05e1\u05ea\u05e8\u05ea \u05d4\u05ea\u05de\u05d5\u05e0\u05d5\u05ea \u05d1\u05d3\u05e3",
    text_size: "\u05d2\u05d5\u05d3\u05dc \u05d8\u05e7\u05e1\u05d8",
    txt: "\u05d8\u05e7\u05e1\u05d8",
    toggle_single_alt: "\u05dc\u05e1\u05d2\u05d5\u05e8 \u05d0\u05d5 \u05dc\u05e4\u05ea\u05d5\u05d7 \u05d0\u05ea \u05d4\u05ea\u05e4\u05e8\u05d9\u05d8 ",
    zoom: "\u05d6\u05d5\u05dd",
    zoom_exp: "\u05d6\u05d5\u05dd \u05e4\u05e0\u05d9\u05de\u05d4 \u05d5\u05d4\u05d7\u05d5\u05e6\u05d4 \u05dc\u05d3\u05e3"
  };
  positions = {
    TR: "top: 0; right: 0 !important;",
    TL: "top: 0; left: 0 !important;",
    BR: "bottom: 0; right: 0 !important;",
    BL: "bottom: 0; left: 0 !important;"
  };
  icons = {
    logo: l + "/logo.png",
    TR_pos: l + "/tr.png",
    BR_pos: l + "/br.png",
    TL_pos: l + "/tl.png",
    BL_pos: l + "/bl.png",
    toggle_all: l + "/toggle_all.png",
    toggle_single: l + "/toggle_single.png",
    chrome: l + "/chrome.png",
    edge: l + "/edge.png",
    firefox: l + "/firefox.png",
    opera: l + "/opera.png",
    explorer: l + "/explorer.png",
    sod: l + "/sod.png",
    black_cursor: l + "/black_cursor.png",
    black_pointer: l +
      "/black_pointer.png",
    white_cursor: l + "/white_cursor.png",
    white_pointer: l + "/white_pointer.png",
    r2m: l + "/colored/" + X + "_r2m.png"
  };
  commons = {
    bar: "nagishli#NagishLiTag > #NagishLiBar",
    menus: "nagishli#NagishLiTag > #NagishLiBar > #NagishLiMenus",
    dropdown: "nagishli#NagishLiTag > #NagishLiBar > #NagishLiMenus > .dropdown",
    checkmark: '<span class="sign">&#x2714;&#xfe0e;&nbsp;&nbsp;</span>',
    not: "#NagishLiTag *, html, head, title, meta, script, style, br, img",
    sprite: l + "/sprite.png"
  };
  $NagishLi = jQuery;
  $NagishLi(function (b) {
    function l(c,
      d) {
      d = void 0 === d ? "grayscale" : d;
      if (b("body").attr("nl-colors") != d) {
        if ("custom" == b("body").attr("nl-colors") && (b("*").not(commons.not).each(function () {
            for (var c = b(this).length; c--;) b(this)[c].style.setProperty("background-color", "", ""), b(this)[c].style.setProperty("color", "", ""), b(this)[c].style.setProperty("border-color", "", "")
          }), b(commons.dropdown + " > #NagishLiColors > li > #NLCustomColors > #NLCustomColorsBG > #NLCurrentBG, " + commons.dropdown + " > #NagishLiColors > li > #NLCustomColors > #NLCustomColorsTXT > #NLCurrentTXT").css({
            "background-color": "transparent",
            display: "none"
          }), b(commons.dropdown + " > #NagishLiColors > li > #NLCustomColors").children("span.sign").remove(), b(commons.dropdown + " > #NagishLiColors > li > #NLCustomColors > #colorPanel > li.selected").removeClass("selected"), b(commons.dropdown + " > #NagishLiColors > li.not-clickable > #NLCustomColors > ul#colorPanel[data-type='" + phrases.bg + "'] > li[aria-label='" + phrases.clr_custom + "'] > input#NLColorPicker").attr("value", n(b("body").css("background-color"))), b(commons.dropdown + " > #NagishLiColors > li.not-clickable > #NLCustomColors > ul#colorPanel[data-type='" +
            phrases.txt + "'] > li[aria-label='" + phrases.clr_custom + "'] > input#NLColorPicker").attr("value", n(b("body").css("color"))), b(commons.dropdown + " > #NagishLiColors > li.not-clickable > #NLCustomColors > ul#colorPanel[data-type='" + phrases.bg + "'] > li[aria-label='" + phrases.clr_custom + "']").attr("aria-label", phrases.aria_select_bgcolor).css("background-color", b("body").css("background-color")), b(commons.dropdown + " > #NagishLiColors > li.not-clickable > #NLCustomColors > ul#colorPanel[data-type='" + phrases.txt +
            "'] > li[aria-label='" + phrases.clr_custom + "']").attr("aria-label", phrases.aria_select_txtcolor).css("color", b("body").css("color"))), "100%" != b("html").css("height") && b("html").css("height", "100%"), b(":root").css({
            filter: "grayscale(100%)",
            "-webkit-filter": "grayscale(100%)",
            "-khtml-filter": "grayscale(100%)",
            "-ms-filter": "grayscale(100%)",
            "-o-filter": "grayscale(100%)",
            "-moz-filter": "grayscale(100%)"
          }), b("body").attr("nl-colors", d), c) return b(commons.dropdown + " > #NagishLiColors > li > #NLGrayscaleColors").attr("aria-label",
          phrases.aria_the_option + phrases.blind + " " + phrases.r2m_on).prepend(commons.checkmark).parent("li").addClass("active").siblings("li").removeClass("active").find("span.sign").remove(), b(commons.dropdown + " > #NagishLiColors").prev("div.dropdown-toggle").hasClass("open") || b('<span class="selected">' + phrases.blind + "</span>").insertAfter(b(commons.dropdown + " > #NagishLiColors").prev("div", ".dropdown-toggle").children(".dropdown-title")), !1
      } else b("body").removeAttr("nl-colors"), b("html").css("height", ""),
        b(":root").css({
          filter: "",
          "-webkit-filter": "",
          "-khtml-filter": "",
          "-ms-filter": "",
          "-o-filter": "",
          "-moz-filter": ""
        }), d = "normal";
      g("NagishLi", "write", "colors", "", d)
    }

    function F(c, d) {
      c = void 0 === c ? !1 : c;
      d = void 0 === d ? "invert" : d;
      if (b("body").attr("nl-colors") != d) {
        if ("custom" == b("body").attr("nl-colors") && (b("*").not(commons.not).each(function () {
            for (var c = b(this).length; c--;) b(this)[c].style.setProperty("background-color", "", ""), b(this)[c].style.setProperty("color", "", ""), b(this)[c].style.setProperty("border-color",
              "", "")
          }), b(commons.dropdown + " > #NagishLiColors > li > #NLCustomColors > #NLCustomColorsBG > #NLCurrentBG, " + commons.dropdown + " > #NagishLiColors > li > #NLCustomColors > #NLCustomColorsTXT > #NLCurrentTXT").css({
            "background-color": "transparent",
            display: "none"
          }), b(commons.dropdown + " > #NagishLiColors > li > #NLCustomColors").children("span.sign").remove(), b(commons.dropdown + " > #NagishLiColors > li > #NLCustomColors > #colorPanel > li.selected").removeClass("selected"), b(commons.dropdown + " > #NagishLiColors > li.not-clickable > #NLCustomColors > ul#colorPanel[data-type='" +
            phrases.bg + "'] > li[aria-label='" + phrases.clr_custom + "'] > input#NLColorPicker").attr("value", n(b("body").css("background-color"))), b(commons.dropdown + " > #NagishLiColors > li.not-clickable > #NLCustomColors > ul#colorPanel[data-type='" + phrases.txt + "'] > li[aria-label='" + phrases.clr_custom + "'] > input#NLColorPicker").attr("value", n(b("body").css("color"))), b(commons.dropdown + " > #NagishLiColors > li.not-clickable > #NLCustomColors > ul#colorPanel[data-type='" + phrases.bg + "'] > li[aria-label='" + phrases.clr_custom +
            "']").attr("aria-label", phrases.aria_select_bgcolor).css("background-color", b("body").css("background-color")), b(commons.dropdown + " > #NagishLiColors > li.not-clickable > #NLCustomColors > ul#colorPanel[data-type='" + phrases.txt + "'] > li[aria-label='" + phrases.clr_custom + "']").attr("aria-label", phrases.aria_select_txtcolor).css("color", b("body").css("color"))), "100%" != b("html").css("height") && b("html").css("height", "100%"), b(":root").css({
            filter: "invert(100%)",
            "-webkit-filter": "invert(100%)",
            "-khtml-filter": "invert(100%)",
            "-ms-filter": "invert(100%)",
            "-o-filter": "invert(100%)",
            "-moz-filter": "invert(100%)"
          }), b("body").attr("nl-colors", d), c) return b(commons.dropdown + " > #NagishLiColors > li > #NLInvertColors").attr("aria-label", phrases.aria_the_option + phrases.invert + " " + phrases.r2m_on).prepend(commons.checkmark).parent("li").addClass("active").siblings("li").removeClass("active").find("span.sign").remove(), b(commons.dropdown + " > #NagishLiColors").prev("div.dropdown-toggle").hasClass("open") || b('<span class="selected">' +
          phrases.impaired + "</span>").insertAfter(b(commons.dropdown + " > #NagishLiColors").prev("div", ".dropdown-toggle").children(".dropdown-title")), !1
      } else b("body").removeAttr("nl-colors"), b("html").css("height", ""), b(":root").css({
        filter: "",
        "-webkit-filter": "",
        "-khtml-filter": "",
        "-ms-filter": "",
        "-o-filter": "",
        "-moz-filter": ""
      }), d = "normal";
      g("NagishLi", "write", "colors", "", d)
    }

    function K(c, d) {
      c = void 0 === c ? "warm" : c;
      d = void 0 === d ? !1 : d;
      if (b("body").attr("nl-colors") != c) {
        "custom" == b("body").attr("nl-colors") &&
          (b("*").not(commons.not).each(function () {
              for (var c = b(this).length; c--;) b(this)[c].style.setProperty("background-color", "", ""), b(this)[c].style.setProperty("color", "", ""), b(this)[c].style.setProperty("border-color", "", "")
            }), b(commons.dropdown + " > #NagishLiColors > li > #NLCustomColors > #NLCustomColorsBG > #NLCurrentBG, " + commons.dropdown + " > #NagishLiColors > li > #NLCustomColors > #NLCustomColorsTXT > #NLCurrentTXT").css({
              "background-color": "transparent",
              display: "none"
            }), b(commons.dropdown + " > #NagishLiColors > li > #NLCustomColors").children("span.sign").remove(),
            b(commons.dropdown + " > #NagishLiColors > li > #NLCustomColors > #colorPanel > li.selected").removeClass("selected"), b(commons.dropdown + " > #NagishLiColors > li.not-clickable > #NLCustomColors > ul#colorPanel[data-type='" + phrases.bg + "'] > li[aria-label='" + phrases.clr_custom + "'] > input#NLColorPicker").attr("value", n(b("body").css("background-color"))), b(commons.dropdown + " > #NagishLiColors > li.not-clickable > #NLCustomColors > ul#colorPanel[data-type='" + phrases.txt + "'] > li[aria-label='" + phrases.clr_custom +
              "'] > input#NLColorPicker").attr("value", n(b("body").css("color"))), b(commons.dropdown + " > #NagishLiColors > li.not-clickable > #NLCustomColors > ul#colorPanel[data-type='" + phrases.bg + "'] > li[aria-label='" + phrases.clr_custom + "']").attr("aria-label", phrases.aria_select_bgcolor).css("background-color", b("body").css("background-color")), b(commons.dropdown + " > #NagishLiColors > li.not-clickable > #NLCustomColors > ul#colorPanel[data-type='" + phrases.txt + "'] > li[aria-label='" + phrases.clr_custom + "']").attr("aria-label",
              phrases.aria_select_txtcolor).css("color", b("body").css("color")));
        var f = "sepia(80%)" + ("cold" == c ? " hue-rotate(200deg)" : "") + "";
        "normal" != c && "100%" != b("html").css("height") && b("html").css("height", "100%");
        b(":root").css({
          filter: f,
          "-webkit-filter": f,
          "-khtml-filter": f,
          "-ms-filter": f,
          "-o-filter": f,
          "-moz-filter": f
        });
        b("body").attr("nl-colors", c);
        if (d) return "warm" == c ? (b(commons.dropdown + " > #NagishLiColors > li > #NLWarmColors").attr("aria-label", phrases.aria_the_option + phrases.bl_filter + " " + phrases.r2m_on).prepend(commons.checkmark).parent("li").addClass("active").siblings("li").removeClass("active").find("span.sign").remove(),
          b(commons.dropdown + " > #NagishLiColors").prev("div.dropdown-toggle").hasClass("open") || b('<span class="selected">' + phrases.bl_filter + "</span>").insertAfter(b(commons.dropdown + " > #NagishLiColors").prev("div", ".dropdown-toggle").children(".dropdown-title"))) : (b(commons.dropdown + " > #NagishLiColors > li > #NLColdColors").attr("aria-label", phrases.aria_the_option + phrases.lc_filter + " " + phrases.r2m_on).prepend(commons.checkmark).parent("li").addClass("active").siblings("li").removeClass("active").find("span.sign").remove(),
          b(commons.dropdown + " > #NagishLiColors").prev("div.dropdown-toggle").hasClass("open") || b('<span class="selected">' + phrases.lc_filter + "</span>").insertAfter(b(commons.dropdown + " > #NagishLiColors").prev("div", ".dropdown-toggle").children(".dropdown-title"))), !1
      } else b("body").removeAttr("nl-colors"), b("html").css("height", ""), b(":root").css({
        filter: "",
        "-webkit-filter": "",
        "-khtml-filter": "",
        "-ms-filter": "",
        "-o-filter": "",
        "-moz-filter": ""
      }), c = "normal";
      g("NagishLi", "write", "colors", "", c)
    }

    function Q(c,
      d, f, e, q, l) {
      c = void 0 === c ? "bg" : c;
      f = void 0 === f ? !1 : f;
      B && (l = g(name, "read", "colors"), -1 !== l.indexOf(",") ? (e = 1 < l.split(",")[0].length ? l.split(",")[0] : "-", q = 1 < l.split(",")[1].length ? l.split(",")[1] : "-") : q = e = "-");
      f ? (b("body").attr("nl-colors", "custom"), f = {
          "#000000": phrases.clr_black,
          "#6495ed": phrases.clr_blue,
          "#3cb371": phrases.clr_green,
          "#ffd800": phrases.clr_yellow,
          "#e95d4f": phrases.clr_red,
          "#ffa500": phrases.clr_orange,
          "#a569bd": phrases.clr_purple,
          "#ff78bb": phrases.clr_pink,
          "#ffffff": phrases.clr_white,
          "#a3a3a3": phrases.clr_gray,
          custom: phrases.clr_custom
        }, "bg" == c ? (c = "he" == p ? "undefined" !== typeof f[n(d)] ? phrases.bg + " " + f[n(d)] : f.custom : "undefined" !== typeof f[n(d)] ? f[n(d)] + " " + phrases.bg.toLowerCase() : f.custom, b("*").not(commons.not).each(function () {
          for (var c = b(this).length; c--;) b(this)[c].style.setProperty("background-color", d, "important")
        }), b(commons.dropdown + " > #NagishLiColors > li > #NLCustomColors > #NLCustomColorsBG > #NLCurrentBG").css({
          "background-color": d,
          display: "inline-block"
        }).attr("aria-label", c)) : (c = "he" == p ? "undefined" !==
          typeof f[n(d)] ? phrases.txt + " " + f[n(d)] : f.custom : "undefined" !== typeof f[n(d)] ? f[n(d)] + " " + phrases.txt.toLowerCase() : f.custom, b("*").not(commons.not).each(function () {
            for (var c = b(this).length; c--;) b(this)[c].style.setProperty("color", d, "important"), b(this)[c].style.setProperty("border-color", d, "important")
          }), b(commons.dropdown + " > #NagishLiColors > li > #NLCustomColors > #NLCustomColorsTXT > #NLCurrentTXT").css({
            "background-color": d,
            display: "inline-block"
          }).attr("aria-label", c)), b("div#NLCustomColors").children("span.sign").length ||
        (b(commons.dropdown + " > #NagishLiColors > li.active > #NLNormalColors").children("span.sign").remove(), b(commons.dropdown + " > #NagishLiColors > li.active > #NLNormalColors").parent("li.active").removeClass("active"), b(commons.dropdown + " > #NagishLiColors > li.not-clickable > #NLCustomColors").parent("li.not-clickable").addClass("active"), b(commons.checkmark).prependTo(b("div#NLCustomColors")), b(commons.dropdown + " > #NagishLiColors").prev("div.dropdown-toggle").hasClass("open") || b('<span class="selected">' +
          phrases.custom_colors + "</span>").insertAfter(b(commons.dropdown + " > #NagishLiColors").prev("div", ".dropdown-toggle").children(".dropdown-title")))) : b(commons.dropdown + " > #NagishLiColors > li.not-clickable > #NLCustomColors > ul#colorPanel > li.selected").length ? ("custom" != b("body").attr("nl-colors") && (b("html").css("height", ""), b(":root").css({
        filter: "",
        "-webkit-filter": "",
        "-moz-filter": "",
        "-khtml-filter": "",
        "-ms-filter": "",
        "-o-filter": ""
      })), b("body").attr("nl-colors", "custom"), d = b(commons.dropdown +
        " > #NagishLiColors > li.not-clickable > #NLCustomColors > ul#colorPanel > li.selected").css("background-color"), "bg" == c ? (b("*").not(commons.not).each(function () {
        for (var c = b(this).length; c--;) b(this)[c].style.setProperty("background-color", d, "important")
      }), e = n(d)) : (b("*").not(commons.not).each(function () {
        for (var c = b(this).length; c--;) b(this)[c].style.setProperty("color", d, "important"), b(this)[c].style.setProperty("border-color", d, "important")
      }), b("body input::placeholder").css({
        "::-webkit-input-placeholder": d,
        "::-moz-placeholder": d,
        ":-ms-input-placeholder": d
      }), q = n(d)), g("NagishLi", "write", "colors", "", e + "," + q)) : ("bg" == c ? (b("*").not(commons.not).each(function () {
          for (var c = b(this).length; c--;) b(this)[c].style.setProperty("background-color", "", "")
        }), e = "-") : (b("*").not(commons.not).each(function () {
          for (var c = b(this).length; c--;) b(this)[c].style.setProperty("color", "", ""), b(this)[c].style.setProperty("border-color", "", "")
        }), q = "-"), g("NagishLi", "write", "colors", "", "-" == e && "-" == q ? "normal" : e + "," + q), "-" == e && "-" ==
        q && b("body").removeAttr("nl-colors"))
    }

    function O(c) {
      c = void 0 === c ? "normal" : c;
      "custom" == b("body").attr("nl-colors") ? (b("*").not(commons.not).each(function () {
          for (var c = b(this).length; c--;) b(this)[c].style.setProperty("background-color", "", ""), b(this)[c].style.setProperty("color", "", ""), b(this)[c].style.setProperty("border-color", "", "")
        }), b(commons.dropdown + " > #NagishLiColors > li > #NLCustomColors > #NLCustomColorsBG > #NLCurrentBG, " + commons.dropdown + " > #NagishLiColors > li > #NLCustomColors > #NLCustomColorsTXT > #NLCurrentTXT").css({
          "background-color": "transparent",
          display: "none"
        }).removeAttr("aria-label"), b(commons.dropdown + " > #NagishLiColors > li > #NLCustomColors").children("span.sign").remove(), b(commons.dropdown + " > #NagishLiColors > li > #NLCustomColors > #colorPanel > li.selected").removeClass("selected"), b(commons.dropdown + " > #NagishLiColors > li.not-clickable > #NLCustomColors > ul#colorPanel[data-type='" + phrases.bg + "'] > li[aria-label='" + phrases.clr_custom + "'] > input#NLColorPicker").attr("value", n(b("body").css("background-color"))), b(commons.dropdown +
          " > #NagishLiColors > li.not-clickable > #NLCustomColors > ul#colorPanel[data-type='" + phrases.txt + "'] > li[aria-label='" + phrases.clr_custom + "'] > input#NLColorPicker").attr("value", n(b("body").css("color"))), b(commons.dropdown + " > #NagishLiColors > li.not-clickable > #NLCustomColors > ul#colorPanel[data-type='" + phrases.bg + "'] > li[aria-label='" + phrases.clr_custom + "']").removeClass("selected").attr("aria-label", phrases.aria_select_bgcolor).css("background-color", b("body").css("background-color")),
        b(commons.dropdown + " > #NagishLiColors > li.not-clickable > #NLCustomColors > ul#colorPanel[data-type='" + phrases.txt + "'] > li[aria-label='" + phrases.clr_custom + "']").removeClass("selected").attr("aria-label", phrases.aria_select_txtcolor).css("color", b("body").css("color"))) : (b("html").css("height", ""), b(":root").css({
        filter: "",
        "-webkit-filter": "",
        "-moz-filter": "",
        "-khtml-filter": "",
        "-ms-filter": "",
        "-o-filter": ""
      }));
      b("body").removeAttr("nl-colors");
      g("NagishLi", "write", "colors", "", c)
    }

    function x(c) {
      (void 0 ===
        c ? 0 : c) ? (b(commons.dropdown + " > #NagishLiText > li > #NLNormalText").removeClass("active").find("span.sign").remove(), c = g(name, "read", "text")) : (c = 16 != parseInt(b("body").css("font-size")) ? parseInt(b("body").css("font-size")) : 16, c += 1);
      var d = c;
      b("*").not(commons.not).each(function () {
        for (var c = b(this).length; c--;) b(this)[c].style.setProperty("font-size", d + "px", "important")
      });
      "he" == p ? b(commons.dropdown + " > .dropdown-toggle > #NLTextVal")[0].innerHTML = ":&nbsp;" + d : b(commons.dropdown + " > .dropdown-toggle > #NLTextVal")[0].innerHTML =
        ":&nbsp;" + d + "px";
      b("body").attr("nl-text", d);
      g("NagishLi", "write", "text", "", d)
    }

    function r(c) {
      (void 0 === c ? 0 : c) ? (b(commons.dropdown + " > #NagishLiText > li > #NLNormalText").removeClass("active").find("span.sign").remove(), c = g(name, "read", "text")) : (c = 16 != parseInt(b("body").css("font-size")) ? parseInt(b("body").css("font-size")) : 16, --c);
      var d = Math.max(0, c);
      b("*").not(commons.not).each(function () {
        for (var c = b(this).length; c--;) b(this)[c].style.setProperty("font-size", d + "px", "important")
      });
      "he" == p ? b(commons.dropdown +
        " > .dropdown-toggle > #NLTextVal")[0].innerHTML = ":&nbsp;" + d : b(commons.dropdown + " > .dropdown-toggle > #NLTextVal")[0].innerHTML = ":&nbsp;" + d + "px";
      b("body").attr("nl-text", d);
      g("NagishLi", "write", "text", "", d)
    }

    function u(c) {
      c = void 0 === c ? "0" : c;
      b("body[nl-text]").length && (b("body").removeAttr("nl-text"), b("*").not(commons.not).each(function () {
        for (var c = b(this).length; c--;) b(this)[c].style.setProperty("font-size", "", ""), "0px" == b(this).css("font-size") && b(this)[c].style.setProperty("font-size", "initial",
          "")
      }), b(commons.dropdown + " > .dropdown-toggle > #NLTextVal")[0].innerHTML = "", g("NagishLi", "write", "text", "", c))
    }

    function C(c) {
      c = void 0 === c ? !1 : c;
      if ("text" != b("body").attr("nl-display")) {
        b("body").attr("nl-display", "text");
        aa();
        b("link[rel='stylesheet']").prop("disabled", !0);
        b("body > *").not("#NagishLiBar").css("visibility", "");
        b("body > .fb-like, img").not("#NagishLiBar img").css("display", "none");
        b("iframe[src*='youtube.com'], video").css("visibility", "hidden");
        b("body").css("background-image", "none");
        var d = "textonly"
      } else b("body").removeAttr("nl-display"), b("link[rel='stylesheet']").prop("disabled", !1), b("body > .fb-like, img").not("#NagishLiBar img").css("display", ""), b("iframe[src*='youtube.com'], video").css("visibility", ""), b("body").css("background-image", ""), d = "normal";
      if (c) return b("" + commons.dropdown + " > #NagishLiDisplay > li > #NLTextDisplay").attr("aria-label", phrases.aria_the_option + phrases.text_only + " " + phrases.r2m_on).prepend(commons.checkmark).parent("li").addClass("active").siblings("li").removeClass("active").find("span.sign").remove(),
        b("" + commons.dropdown + " > #NagishLiDisplay").prev("div.dropdown-toggle").hasClass("open") || b('<span class="selected">' + phrases.text_only + "</span>").insertAfter(b("" + commons.dropdown + " > #NagishLiDisplay").prev("div", ".dropdown-toggle").children(".dropdown-title")), !1;
      g("NagishLi", "write", "display", "", d)
    }

    function y(c, d) {
      "images" != b("body").attr("nl-display") ? (b("body").attr("nl-display", "images"), aa(), b("link[rel='stylesheet']").prop("disabled") && b("link[rel='stylesheet']").prop("disabled", !1), b("body > *").not("#NagishLiTag").css("visibility",
        "hidden"), b("body > .fb-like").css("display", "none"), b("iframe[src*='youtube.com'], video").css("visibility", "hidden"), b("body").css("background-image", ""), b("img").css({
        visibility: "visible",
        display: ""
      }), d = "imagesonly") : (b("body").removeAttr("nl-display"), b("body > *").not("#NagishLiBar").css("visibility", ""), b("body > .fb-like").css("display", ""), d = "normal");
      if (c) return b(commons.dropdown + " > #NagishLiDisplay > li > #NLImagesDisplay").attr("aria-label", phrases.aria_the_option + phrases.images_only +
        " " + phrases.r2m_on).prepend(commons.checkmark).parent("li").addClass("active").siblings("li").removeClass("active").find("span.sign").remove(), b(commons.dropdown + " > #NagishLiDisplay").prev("div.dropdown-toggle").hasClass("open") || b('<span class="selected">' + phrases.images_only + "</span>").insertAfter(b(commons.dropdown + " > #NagishLiDisplay").prev("div", ".dropdown-toggle").children(".dropdown-title")), !1;
      g("NagishLi", "write", "display", "", d)
    }

    function ba(c) {
      c = void 0 === c ? "normal" : c;
      b("body[nl-display]").length &&
        (b("body").removeAttr("nl-display"), b("link[rel='stylesheet']").prop("disabled") && b("link[rel='stylesheet']").prop("disabled", !1), b("body > *, img, iframe[src*='youtube.com'], video").css({
          display: "",
          visibility: ""
        }), b("body").css("background-image", ""), g("NagishLi", "write", "display", "", c))
    }

    function ca(c) {
      c ? (b(commons.dropdown + " > #NagishLiHighlight > li > #NLHighlightLinks").attr("aria-label", phrases.aria_the_option + phrases.hl_links + " " + phrases.r2m_on).prepend(commons.checkmark).parent("li").addClass("active"),
        b("* a").not("#NagishLiBar a").each(function () {
          this.style.setProperty("outline", "3px red dotted", "important");
          this.style.setProperty("background-color", "black", "important");
          this.style.setProperty("color", "yellow", "important");
          b("body").attr("nl-hl-links", "1")
        })) : (b("body[nl-hl-links]").length ? (b("* a").not("#NagishLiBar a").each(function () {
          this.style.setProperty("outline", "", "");
          this.style.setProperty("background-color", "", "");
          this.style.setProperty("color", "", "")
        }), b("body[nl-hl-headings]").length &&
        b("h1 a, h2 a, h3 a, h4 a, h5 a, h6 a, h1 span, h2 span, h3 span, h4 span, h5 span, h6 span").each(function () {
          this.style.setProperty("color", "inherit", "important")
        }), b("body").removeAttr("nl-hl-links"), c = "0") : (b("* a").not("#NagishLiBar a").each(function () {
        this.style.setProperty("outline", "3px red dotted", "important");
        this.style.setProperty("background-color", "black", "important");
        this.style.setProperty("color", "yellow", "important")
      }), b("body").attr("nl-hl-links", "1"), c = "1"), g("NagishLi", "write", "highlight",
        1, c))
    }

    function da(c) {
      c ? (b(commons.dropdown + " > #NagishLiHighlight > li > #NLHighlightHeadings").attr("aria-label", phrases.aria_the_option + phrases.hl_headings + " " + phrases.r2m_on).prepend(commons.checkmark).parent("li").addClass("active"), b("h1, h2, h3, h4, h5, h6").each(function () {
        this.style.setProperty("outline", "3px red dotted", "important");
        this.style.setProperty("background", "black", "important");
        this.style.setProperty("color", "yellow", "important")
      }), b("body[nl-hl-links]").length || b("h1 a, h2 a, h3 a, h4 a, h5 a, h6 a, h1 span, h2 span, h3 span, h4 span, h5 span, h6 span").each(function () {
        this.style.setProperty("color",
          "inherit", "important")
      }), b("body").attr("nl-hl-headings", "1")) : (b("body[nl-hl-headings]").length ? (b("h1, h2, h3, h4, h5, h6").each(function () {
        this.style.setProperty("outline", "", "");
        this.style.setProperty("background", "", "");
        this.style.setProperty("color", "", "")
      }), b("body[nl-hl-links]").length || b("h1 a, h2 a, h3 a, h4 a, h5 a, h6 a, h1 span, h2 span, h3 span, h4 span, h5 span, h6 span").each(function () {
        this.style.setProperty("color", "", "")
      }), b("body").removeAttr("nl-hl-headings"), c = "0") : (b("h1, h2, h3, h4, h5, h6, h1").each(function () {
        this.style.setProperty("outline",
          "3px red dotted", "important");
        this.style.setProperty("background", "black", "important");
        this.style.setProperty("color", "yellow", "important")
      }), b("body[nl-hl-links]").length || b("h1 a, h2 a, h3 a, h4 a, h5 a, h6 a, h1 span, h2 span, h3 span, h4 span, h5 span, h6 span").each(function () {
        this.style.setProperty("color", "inherit", "important")
      }), c = "1", b("body").attr("nl-hl-headings", "1")), g("NagishLi", "write", "highlight", 2, c))
    }

    function ea(c) {
      if ("zoom" in document.documentElement.style) c ? (c = g("NagishLi", "read",
        "zoom", ""), c = +c) : (c = b("body[style*='zoom']").length ? -1 !== b("body").css("zoom").indexOf("%") ? parseInt(b("body").css("zoom")) / 100 : parseFloat(b("body").css("zoom")) : 1, c = +(c + .1).toFixed(1)), b("body").css("zoom", c), b("body > iframe").css({
        "-webkit-transform-origin": "0 0",
        "-moz-transform-origin": "0 0",
        "-khtml-transform-origin": "0 0",
        "-ms-transform-origin": "0 0",
        "-o-transform-origin": "0 0",
        "-webkit-transform": "scale(" + c + ")",
        "-moz-transform": "scale(" + c + ")",
        "-khtml-transform": "scale(" + c + ")",
        "-ms-transform": "scale(" +
          c + ")",
        "-o-transform": "scale(" + c + ")"
      });
      else if ("transform" in document.documentElement.style) c ? (c = g("NagishLi", "read", "zoom", ""), c = +c) : (b("body[style*='transform: scale']").length ? (c = b("body").css("transform").match(/-?[\d\.]+/g), c = parseFloat(c[0])) : c = 1, c = +(c + .1).toFixed(1)), b("body, body > iframe").css({
        "-webkit-transform-origin": "0 0",
        "-moz-transform-origin": "0 0",
        "-khtml-transform-origin": "0 0",
        "-ms-transform-origin": "0 0",
        "-o-transform-origin": "0 0",
        "-webkit-transform": "scale(" + c + ")",
        "-moz-transform": "scale(" +
          c + ")",
        "-khtml-transform": "scale(" + c + ")",
        "-ms-transform": "scale(" + c + ")",
        "-o-transform": "scale(" + c + ")"
      });
      else return alert(phrases.not_supported), !1;
      g("NagishLi", "write", "zoom", "", c);
      b("html")[0].style.setProperty("overflow-y", "auto", "important");
      b(commons.bar)[0].style.setProperty("position", "absolute", "important");
      b(commons.dropdown + " > #NagishLiMisc > li.not-clickable > #NLZoom > #NLZoomVal")[0].innerHTML = c + "&nbsp;";
      "0px" == b(commons.bar).css("top") && b(commons.bar)[0].style.setProperty("top", b("html").offset().top,
        "important")
    }

    function fa(c) {
      if ("zoom" in document.documentElement.style) c ? (c = g("NagishLi", "read", "zoom", ""), c = +c) : (c = b("body[style*='zoom']").length ? -1 !== b("body").css("zoom").indexOf("%") ? parseInt(b("body").css("zoom")) / 100 : parseFloat(b("body").css("zoom")) : 1, c = +(c - .1).toFixed(1)), b("body").css("zoom", c), b("body > iframe").css({
        "-webkit-transform-origin": "0 0",
        "-moz-transform-origin": "0 0",
        "-khtml-transform-origin": "0 0",
        "-ms-transform-origin": "0 0",
        "-o-transform-origin": "0 0",
        "-webkit-transform": "scale(" +
          c + ")",
        "-moz-transform": "scale(" + c + ")",
        "-khtml-transform": "scale(" + c + ")",
        "-ms-transform": "scale(" + c + ")",
        "-o-transform": "scale(" + c + ")"
      });
      else if ("transform" in document.documentElement.style) c ? (c = g("NagishLi", "read", "zoom", ""), c = +c) : (b("body[style*='transform: scale']").length ? (c = b("body").css("transform").match(/-?[\d\.]+/g), c = parseFloat(c[0])) : c = 1, c = +(c - .1).toFixed(1)), b("body, body > iframe").css({
        "-webkit-transform-origin": "0 0",
        "-moz-transform-origin": "0 0",
        "-khtml-transform-origin": "0 0",
        "-ms-transform-origin": "0 0",
        "-o-transform-origin": "0 0",
        "-webkit-transform": "scale(" + c + ")",
        "-moz-transform": "scale(" + c + ")",
        "-khtml-transform": "scale(" + c + ")",
        "-ms-transform": "scale(" + c + ")",
        "-o-transform": "scale(" + c + ")"
      });
      else return alert(phrases.not_supported), !1;
      g("NagishLi", "write", "zoom", "", c);
      1 >= c && "absolute" == b(commons.bar).css("position") && (b("html")[0].style.setProperty("overflow-y", "", ""), b(commons.bar)[0].style.setProperty("position", "fixed", "important"));
      b(commons.dropdown + " > #NagishLiMisc > li.not-clickable > #NLZoom > #NLZoomVal")[0].innerHTML =
        c + "&nbsp;"
    }

    function ha(c) {
      c = void 0 === c ? "0.0" : c;
      b("body, body > iframe").css({
        zoom: "",
        "-webkit-transform-origin": "",
        "-moz-transform-origin": "",
        "-khtml-transform-origin": "",
        "-ms-transform-origin": "",
        "-o-transform-origin": "",
        "-webkit-transform": "",
        "-moz-transform": "",
        "-khtml-transform": "",
        "-ms-transform": "",
        "-o-transform": ""
      });
      b("html")[0].style.setProperty("overflow-y", "", "");
      b(commons.bar)[0].style.setProperty("position", "fixed", "important");
      b(commons.dropdown + " > #NagishLiMisc > li.not-clickable > #NLZoom > #NLZoomVal").empty();
      g("NagishLi", "write", "zoom", "", c)
    }

    function ia(c, d) {
      c = void 0 === c ? "readable" : c;
      d = void 0 === d ? !1 : d;
      b("body[nl-font]").length ? (b("body").removeAttr("nl-font"), b("body *").not(commons.not).each(function () {
        this.style.setProperty("font-family", "", "")
      }), b(commons.dropdown + " > #NagishLiMisc > li > #NLFont > #NLFontVal").text(phrases.normal), c = "normal") : (b("body").attr("nl-font", "readable"), b("body *").not(commons.not).each(function () {
          this.style.setProperty("font-family", "Arial, Helvetica, sans-serif", "important")
        }),
        b(commons.dropdown + " > #NagishLiMisc > li > #NLFont > #NLFontVal").text(phrases.font_readable));
      d || g("NagishLi", "write", "font", "", c)
    }

    function G(c, d) {
      "TL" == c ? (b(commons.bar)[0].style.setProperty("top", "0", "important"), b(commons.bar)[0].style.setProperty("bottom", "auto", "important"), b(commons.bar)[0].style.setProperty("left", "0", "important"), b(commons.bar)[0].style.setProperty("right", "auto", "important")) : "BR" == c ? (b(commons.bar)[0].style.setProperty("bottom", "0", "important"), b(commons.bar)[0].style.setProperty("top",
        "auto", "important"), b(commons.bar)[0].style.setProperty("right", "0", "important"), b(commons.bar)[0].style.setProperty("left", "auto", "important")) : "TR" == c ? (b(commons.bar)[0].style.setProperty("bottom", "auto", "important"), b(commons.bar)[0].style.setProperty("top", "0", "important"), b(commons.bar)[0].style.setProperty("right", "0", "important"), b(commons.bar)[0].style.setProperty("left", "auto", "important")) : "BL" == c && (b(commons.bar)[0].style.setProperty("bottom", "0", "important"), b(commons.bar)[0].style.setProperty("top",
        "auto", "important"), b(commons.bar)[0].style.setProperty("right", "auto", "important"), b(commons.bar)[0].style.setProperty("left", "0", "important"));
      b(commons.bar + " > #NagishLiBarStrip > #NagishLiMove > span").css("visibility", "visible");
      b(commons.bar + " > #NagishLiBarStrip > #NagishLiMove > #NagishLiMove" + c).css("visibility", "hidden");
      d || g("NagishLi", "write", "position", "", c)
    }

    function ja(c, d) {
      c = void 0 === c ? !1 : c;
      d = void 0 === d ? "off" : d;
      b("body[nl-animations]").length || "off" != d ? (jQuery.fx.off = !1, b("body *").not(commons.not).each(function () {
        this.style.setProperty("animation-play-state",
          "", "");
        this.style.setProperty("transition-duration", "", "")
      }), b("body").removeAttr("nl-animations"), b(commons.dropdown + " > #NagishLiMisc > li > #NLAnimations > #NLAnimationsVal").attr({
        title: phrases.animations_on
      }), b(commons.dropdown + " > #NagishLiMisc > li > #NLAnimations > #NLAnimationsVal")[0].innerHTML = "&#x25ba;&nbsp;" + phrases.animations_on + "", d = "on") : (jQuery.fx.off = !0, b("body *").not(commons.not).each(function () {
        this.style.setProperty("animation-play-state", "paused", "important");
        this.style.setProperty("transition-duration",
          "0s", "important")
      }), b("body").attr("nl-animations", d), b(commons.dropdown + " > #NagishLiMisc > li > #NLAnimations > #NLAnimationsVal").attr({
        title: phrases.animations_off
      }), b(commons.dropdown + " > #NagishLiMisc > li > #NLAnimations > #NLAnimationsVal")[0].innerHTML = "&#x275a;&#x275a;&nbsp;" + phrases.animations_off + "");
      c || g("NagishLi", "write", "animations", "", d)
    }

    function ka(c, d) {
      c = void 0 === c ? !1 : c;
      d = void 0 === d ? "off" : d;
      if (b("body[nl-r2m]").length || b("body span.r2m").length || "off" != d) b("body span.r2m > img").toggleClass("bounceIn bounceOut").fadeOut(600,
        function () {
          b(this).parent("span.r2m").remove()
        }), b("body").removeAttr("nl-r2m"), b(commons.bar + " > script#nlr2ms, " + commons.bar + " > audio#nlr2mp").remove(), b(commons.dropdown + " > #NagishLiMisc > li > #NLR2M > #NLR2MVal")[0].innerHTML = phrases.r2m_off, d = "off";
      else {
        var f = function (c, d) {
            3 === d.nodeType ? e.test(d.data) && b(d).replaceWith(d.data.replace(e, l)) : b(d).not("iframe").contents().each(f)
          },
          e = /([0|1][0-9-]{9,})/g,
          l = '$1<span style="display: inline !important; overflow-x: visible !important;" class="r2m" data-balloon="' +
          phrases.r2m_exp + '" nl-r2m-data="$1" data-balloon-pos="' + phrases.align_left + '">&nbsp;<img style="display: inline-block !important; vertical-align: top !important; width: 21px !important; height: 21px !important; cursor: pointer !important;" class="bounceIn animated" src="' + icons.r2m + '" alt="' + phrases.r2m_exp + '" /></span>';
        Z || !c && (b(commons.bar + " > #nlr2mp").length || b(commons.bar + " > #nlr2ms").length) || b.ajax({
          url: "//static.localize.co.il/nagishli/r2m/male_" + p + "/sounds.js",
          dataType: "script",
          cache: !0
        }).done(function () {
          b(commons.bar).append('<script id="nlr2ms" src="//static.localize.co.il/nagishli/r2m/male_' +
            p + '/sounds.js" crossorigin="anonymous" charset="utf-8">\x3c/script><audio crossorigin="anonymous" id="nlr2mp" style="display: none !important;">' + phrases.not_supported + "</audio>")
        }).fail(function () {
          alert(phrases.r2m_na);
          b("body span.r2m > img").toggleClass("bounceIn bounceOut").fadeOut(600, function () {
            b(this).parent("span.r2m").remove()
          });
          b("body").removeAttr("nl-r2m");
          b(commons.dropdown + " > #NagishLiMisc > li > #NLR2M > #NLR2MVal")[0].innerHTML = phrases.r2m_off;
          g("NagishLi", "write", "r2m", "", "off");
          return !1
        });
        b("body").attr("nl-r2m", "1").not(commons.not).each(f);
        b(commons.dropdown + " > #NagishLiMisc > li > #NLR2M > #NLR2MVal")[0].innerHTML = phrases.r2m_on;
        b("span.r2m > img").click(function () {
          if (Z) {
            var c = new SpeechSynthesisUtterance;
            c.lang = "en";
            ra ? (c.pitch = .7, c.rate = .7) : (c.pitch = 1, c.rate = .7 - .2);
            c.text = b(this).parent("span.r2m").attr("nl-r2m-data").replace(/\D/g, "");
            speechSynthesis.speak(c)
          } else {
            var d = function (b) {
                e.src = "data:audio/mp3;base64," + edgts[b];
                e.load();
                e.play()
              },
              f = b(this).parent("span.r2m").attr("nl-r2m-data").replace(/\D/g,
                "").split(""),
              e = document.getElementById("nlr2mp"),
              g = 0;
            e.addEventListener("ended", function () {
              g < f.length - 1 && (g++, d(f[g]))
            });
            d(g)
          }
        });
        d = "on"
      }
      c || g("NagishLi", "write", "r2m", "", d)
    }

    function S(c, d) {
      c = void 0 === c ? "black" : c;
      d = void 0 === d ? !1 : d;
      b("html[nl-cursor]").length && b("html").attr("nl-cursor") == c ? (b(":root").removeAttr("nl-cursor"), c = "normal") : b(":root").attr("nl-cursor", c);
      if (d) return "black" == c ? b(commons.checkmark).prependTo(b(commons.dropdown + " > #NagishLiMisc > li > #NLCursor > #NLCursorBlack").attr("aria-label",
        phrases.aria_the_option + phrases.cursor + " " + phrases.cursor_black + " " + phrases.r2m_on).addClass("active")) : b(commons.checkmark).prependTo(b(commons.dropdown + " > #NagishLiMisc > li > #NLCursor > #NLCursorWhite").attr("aria-label", phrases.aria_the_option + phrases.cursor + " " + phrases.cursor_white + " " + phrases.r2m_on).addClass("active")), !1;
      g("NagishLi", "write", "cursor", "", c)
    }

    function la() {
      b(commons.dropdown + " > .dropdown-toggle.open").length ? b(commons.bar + " > #NagishLiBarStrip > #NagishLiToggleMenus").attr("class",
        "collapse-all").children("img").attr("alt", phrases.collapse_all) : b(commons.bar + " > #NagishLiBarStrip > #NagishLiToggleMenus").attr("class", "expand-all").children("img").attr("alt", phrases.expand_all)
    }

    function ma(c, d) {
      c = void 0 === c ? !1 : c;
      d = void 0 === d ? "1" : d;
      b(commons.dropdown + " > #NagishLiInfo > #NagishLiHelp").hasClass("active") ? (b(commons.dropdown + " > #NagishLiInfo > #NagishLiHelp").removeClass("active").find("span.sign").remove(), b(commons.dropdown + " > .dropdown-menu > li > div").children("span.help, span.notice").hide(),
        d = "0") : (b(commons.checkmark).prependTo(b(commons.dropdown + " > #NagishLiInfo > #NagishLiHelp").attr("aria-label", phrases.aria_the_option + phrases.help + " " + phrases.r2m_on).addClass("active").children("div")), b(commons.dropdown + " > .dropdown-menu > li > div").children("span.help, span.notice").show());
      c || g("NagishLi", "write", "help", "", d)
    }

    function na(c, d) {
      c = void 0 === c ? !1 : c;
      d = void 0 === d ? "on" : d;
      b("body[nl-kbnav]").length || "on" != d ? (b("body").removeAttr("nl-kbnav"), b("nagishli > style#NagishLiTabbingStyle").remove(),
        b(commons.dropdown + " > #NagishLiMisc > li > #NLKBNav > #NLKBNavVal")[0].innerHTML = phrases.kbnav_off, b("#NagishLiMenus .dropdown-toggle").off("keypress.nlkbnavclk"), d = "off") : (b(commons.bar + " > #NagishLiBarStrip, " + commons.bar + " > #NagishLiBarStrip > #NagishLiMove > span#NagishLiMoveTL, " + commons.bar + " > #NagishLiBarStrip > #NagishLiMove > span#NagishLiMoveTR, " + commons.bar + " > #NagishLiBarStrip > #NagishLiMove > span#NagishLiMoveBL, " + commons.bar + " > #NagishLiBarStrip > #NagishLiMove > span#NagishLiMoveBR, " +
        commons.bar + " > #NagishLiBarStrip > #NagishLiToggleMenus, " + commons.dropdown + " > .dropdown-toggle, " + commons.dropdown + " > .dropdown-menu > li > div, " + commons.dropdown + " > .dropdown-menu > li > div > a, " + commons.dropdown + " > .dropdown-menu > li > div > span, " + commons.dropdown + " > .dropdown-menu > li#NagishLiHelp, " + commons.dropdown + " > ul > li, " + commons.dropdown + " > .dropdown-menu > li > div > ul > li, " + commons.dropdown + " > #NagishLiColors > li > #NLCustomColors > ul > li#NLCloseColorPanel").on("keypress.nlkbnavclk",
        function (c) {
          13 === c.which && b(this).triggerHandler("click")
        }), b("body").attr("nl-kbnav", "1"), b("nagishli").append('<style type="text/css" id="NagishLiTabbingStyle">body.focus-style *:focus { outline: 5px solid rgba(88, 144, 255, 0.75) !important; } ' + commons.dropdown + " > .dropdown-menu > li > div:focus, " + commons.dropdown + " > .dropdown-toggle:focus, " + commons.dropdown + " > .dropdown-menu > li > div > span:focus, " + commons.dropdown + ":last-child > .dropdown-menu > li:last-child > div:focus, " + commons.dropdown + " > .dropdown-menu > li > div > a:focus, #NagishLiBarStrip:focus { border: 5px solid rgba(88, 144, 255, 0.75) !important; } " +
        commons.bar + " > #NagishLiBarStrip > #NagishLiMove > span:focus, " + commons.bar + " > #NagishLiBarStrip > #NagishLiToggleMenus:focus, nagishli#NagishLiTag > .NagishLiOverlay #closeBtn:focus, #NagishLiOverlayContent > .NagishLiStatementText > a:focus, #NagishLiOverlayContent > .NagishLiAboutText > a:focus, #NagishLiOverlayContent > .NagishLiAboutText > span#licWarn > a:focus, #NagishLiOverlayContent > .NagishLiStatementText > span#licWarn > a:focus, #NagishLiOverlayContent > .NagishLiAboutText > #DeveloperMsg > a:focus > img, " +
        commons.dropdown + " > .dropdown-menu > li > div > ul > li:focus, " + commons.dropdown + " > .dropdown-menu > li > div > ul > li > input:focus { outline: 5px solid rgba(88, 144, 255, 0.75) !important; } " + commons.dropdown + " > .dropdown-menu > li > div > ul > li > input:focus { outline-width: 8px !important; } " + commons.dropdown + " > .dropdown-menu > li > div:focus { background: #f6f6f6 !important; } " + commons.dropdown + " > .dropdown-toggle:focus, " + commons.menus + ".blue > .dropdown > .dropdown-toggle:focus { background: #5478E4 !important; } " +
        commons.menus + ".red > .dropdown > .dropdown-toggle:focus { background: #EB2B36 !important; } " + commons.menus + ".green > .dropdown > .dropdown-toggle:focus { background: #365E1B !important; } " + commons.menus + ".purple > .dropdown > .dropdown-toggle:focus { background: #8562B1 !important; } " + commons.menus + ".yellow > .dropdown > .dropdown-toggle:focus { background: #EDCA19 !important; } " + commons.menus + ".pink > .dropdown > .dropdown-toggle:focus { background: #FF78BB !important; } " + commons.menus + ".gray > .dropdown > .dropdown-toggle:focus { background: #8493A3 !important; } " +
        commons.menus + ".brown > .dropdown > .dropdown-toggle:focus { background: #A96342 !important; } " + commons.menus + ".orange > .dropdown > .dropdown-toggle:focus { background: #FF9719 !important; } " + commons.menus + ".turquoise > .dropdown > .dropdown-toggle:focus { background: #36B9B2 !important; }</style>"), b(commons.dropdown + " > #NagishLiMisc > li > #NLKBNav > #NLKBNavVal")[0].innerHTML = phrases.kbnav_on, b(commons.dropdown + " > #NagishLiMisc > li > #NLKBNav").blur(), b(commons.bar + " > #NagishLiBarStrip").focus());
      c || g("NagishLi", "write", "tabbing", "", d)
    }

    function aa() {
      b("[nl-role*='media']").length && (b("iframe[src*='youtube.com']").each(function () {
        for (var c = b(this).length; c--;) "ytmedia" == b(this).attr("nl-role") ? (b("iframe[src*='youtube.com']")[c].contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*"), b(this).attr("nl-role", "ytmedia-paused")) : b(this).attr("nl-role", "ytmedia")
      }), b("video, audio").each(function () {
        for (var c = b(this).length; c--;) "media" == b(this).attr("nl-role") ? (b("video, audio")[c].pause(),
          b(this).attr("nl-role", "media-paused")) : b(this).attr("nl-role", "media")
      }))
    }
    jq_not_found && console.log(phrases.jq_not_found_msg, "color: RoyalBlue; font-weight: bold;", "");
    180 > jQuery.fn.jquery.replace(/\D/g, "") && console.log(phrases.jq_too_low, "color: RoyalBlue; font-weight: bold;", "");
    if (!b("body").length) throw alert(phrases.body_missing), Error(phrases.body_missing);
    if (B && 2 > parseInt(g("NagishLi", "read", "version"))) return g("NagishLi", "delete", "all"), b(commons.bar).css({
        "max-height": "",
        "overflow-y": ""
      }),
      b(commons.bar + " > #NagishLiBarStrip > #NagishLiToggleMenus, " + commons.bar + " > #NagishLiBarStrip > #NagishLiMove").remove(), b(commons.bar + " > #NagishLiBarStrip").addClass("open"), b(commons.menus).show(), b(commons.menus).html('<li class="dropdown"><ul class="dropdown-menu show"><li class="not-clickable"><div href="#">' + phrases.settings_upgrade_html + "</div></li></ul></li>"), !1;
    (function (b) {
      "function" === typeof define && define.amd ? define(["jquery"], b) : "object" === typeof exports ? module.exports = b(require("jquery")) :
        b(jQuery)
    })(function (b) {
      var c = !1,
        f = !1,
        e = 0,
        g = 2E3,
        l = 0,
        p = ["webkit", "ms", "moz", "o"],
        n = window.requestAnimationFrame || !1,
        r = window.cancelAnimationFrame || !1;
      if (!n)
        for (var u in p) {
          var x = p[u];
          if (n = window[x + "RequestAnimationFrame"]) {
            r = window[x + "CancelAnimationFrame"] || window[x + "CancelRequestAnimationFrame"];
            break
          }
        }
      var I = window.MutationObserver || window.WebKitMutationObserver || !1,
        C = {
          zindex: "auto",
          cursoropacitymin: 0,
          cursoropacitymax: 1,
          cursorcolor: "#424242",
          cursorwidth: "6px",
          cursorborder: "1px solid #fff",
          cursorborderradius: "5px",
          scrollspeed: 60,
          mousescrollstep: 24,
          touchbehavior: !1,
          hwacceleration: !0,
          usetransition: !0,
          boxzoom: !1,
          dblclickzoom: !0,
          gesturezoom: !0,
          grabcursorenabled: !0,
          autohidemode: !0,
          background: "",
          iframeautoresize: !0,
          cursorminheight: 32,
          preservenativescrolling: !0,
          railoffset: !1,
          railhoffset: !1,
          bouncescroll: !0,
          spacebarenabled: !0,
          railpadding: {
            top: 0,
            right: 0,
            left: 0,
            bottom: 0
          },
          disableoutline: !0,
          horizrailenabled: !0,
          railalign: "right",
          railvalign: "bottom",
          enabletranslate3d: !0,
          enablemousewheel: !0,
          enablekeyboard: !0,
          smoothscroll: !0,
          sensitiverail: !0,
          enablemouselockapi: !0,
          cursorfixedheight: !1,
          directionlockdeadzone: 6,
          hidecursordelay: 400,
          nativeparentscrolling: !0,
          enablescrollonselection: !0,
          overflowx: !0,
          overflowy: !0,
          cursordragspeed: .3,
          rtlmode: "auto",
          cursordragontouch: !1,
          oneaxismousemode: "auto",
          scriptpath: function () {
            var b = document.getElementsByTagName("script");
            b = b.length ? b[b.length - 1].src.split("?")[0] : "";
            return 0 < b.split("/").length ? b.split("/").slice(0, -1).join("/") + "/" : ""
          }(),
          preventmultitouchscrolling: !0,
          disablemutationobserver: !1
        },
        y = !1,
        G = function () {
          if (y) return y;
          var b = document.createElement("DIV"),
            c = b.style,
            d = navigator.userAgent,
            f = navigator.platform,
            e = {
              haspointerlock: "pointerLockElement" in document || "webkitPointerLockElement" in document || "mozPointerLockElement" in document
            };
          e.isopera = "opera" in window;
          e.isopera12 = e.isopera && "getUserMedia" in navigator;
          e.isoperamini = "[object OperaMini]" === Object.prototype.toString.call(window.operamini);
          e.isie = "all" in document && "attachEvent" in b && !e.isopera;
          e.isieold = e.isie && !("msInterpolationMode" in
            c);
          e.isie7 = e.isie && !e.isieold && (!("documentMode" in document) || 7 == document.documentMode);
          e.isie8 = e.isie && "documentMode" in document && 8 == document.documentMode;
          e.isie9 = e.isie && "performance" in window && 9 == document.documentMode;
          e.isie10 = e.isie && "performance" in window && 10 == document.documentMode;
          e.isie11 = "msRequestFullscreen" in b && 11 <= document.documentMode;
          e.isieedge12 = navigator.userAgent.match(/Edge\/12\./);
          e.isieedge = "msOverflowStyle" in b;
          e.ismodernie = e.isie11 || e.isieedge;
          e.isie9mobile = /iemobile.9/i.test(d);
          e.isie9mobile && (e.isie9 = !1);
          e.isie7mobile = !e.isie9mobile && e.isie7 && /iemobile/i.test(d);
          e.ismozilla = "MozAppearance" in c;
          e.iswebkit = "WebkitAppearance" in c;
          e.ischrome = "chrome" in window;
          e.ischrome38 = e.ischrome && "touchAction" in c;
          e.ischrome22 = !e.ischrome38 && e.ischrome && e.haspointerlock;
          e.ischrome26 = !e.ischrome38 && e.ischrome && "transition" in c;
          e.cantouch = "ontouchstart" in document.documentElement || "ontouchstart" in window;
          e.hasw3ctouch = (window.PointerEvent || !1) && (0 < navigator.MaxTouchPoints || 0 < navigator.msMaxTouchPoints);
          e.hasmstouch = !e.hasw3ctouch && (window.MSPointerEvent || !1);
          e.isios = e.cantouch && /iphone|ipad|ipod/i.test(f);
          e.isios4 = e.isios && !("seal" in Object);
          e.isios7 = e.isios && "webkitHidden" in document;
          e.isios8 = e.isios && "hidden" in document;
          e.isandroid = /android/i.test(d);
          e.haseventlistener = "addEventListener" in b;
          e.trstyle = !1;
          e.hastransform = !1;
          e.hastranslate3d = !1;
          e.transitionstyle = !1;
          e.hastransition = !1;
          e.transitionend = !1;
          f = ["transform", "msTransform", "webkitTransform", "MozTransform", "OTransform"];
          for (d = 0; d < f.length; d++)
            if (void 0 !==
              c[f[d]]) {
              e.trstyle = f[d];
              break
            }
          e.hastransform = !!e.trstyle;
          e.hastransform && (c[e.trstyle] = "translate3d(1px,2px,3px)", e.hastranslate3d = /translate3d/.test(c[e.trstyle]));
          e.transitionstyle = !1;
          e.prefixstyle = "";
          e.transitionend = !1;
          f = "transition webkitTransition msTransition MozTransition OTransition OTransition KhtmlTransition".split(" ");
          var g = " -webkit- -ms- -moz- -o- -o -khtml-".split(" "),
            l = "transitionend webkitTransitionEnd msTransitionEnd transitionend otransitionend oTransitionEnd KhtmlTransitionEnd".split(" ");
          for (d = 0; d < f.length; d++)
            if (f[d] in c) {
              e.transitionstyle = f[d];
              e.prefixstyle = g[d];
              e.transitionend = l[d];
              break
            }
          e.ischrome26 && (e.prefixstyle = g[1]);
          e.hastransition = e.transitionstyle;
          a: {
            d = ["grab", "-webkit-grab", "-moz-grab"];
            if (e.ischrome && !e.ischrome38 || e.isie) d = [];
            for (f = 0; f < d.length; f++)
              if (g = d[f], c.cursor = g, c.cursor == g) {
                c = g;
                break a
              }
            c = "url(//patriciaportfolio.googlecode.com/files/openhand.cur),n-resize"
          }
          e.cursorgrabvalue = c;
          e.hasmousecapture = "setCapture" in b;
          e.hasMutationObserver = !1 !== I;
          return y = e
        },
        D = function (d,
          m) {
          function P() {
            var b = a.doc.css(h.trstyle);
            return b && "matrix" == b.substr(0, 6) ? b.replace(/^.*\((.*)\)$/g, "$1").replace(/px/g, "").split(/, +/) : !1
          }

          function ta() {
            var b = a.win;
            if ("zIndex" in b) return b.zIndex();
            for (; 0 < b.length && 9 != b[0].nodeType;) {
              var c = b.css("zIndex");
              if (!isNaN(c) && 0 != c) return parseInt(c);
              b = b.parent()
            }
            return !1
          }

          function q(b, c, e) {
            c = b.css(c);
            b = parseFloat(c);
            return isNaN(b) ? (b = w[c] || 0, e = 3 == b ? e ? a.win.outerHeight() - a.win.innerHeight() : a.win.outerWidth() - a.win.innerWidth() : 1, a.isie8 && b && (b += 1),
              e ? b : 0) : b
          }

          function p(b, c, e, d) {
            a._bind(b, c, function (a) {
              a = a ? a : window.event;
              var k = {
                original: a,
                target: a.target || a.srcElement,
                type: "wheel",
                deltaMode: "MozMousePixelScroll" == a.type ? 0 : 1,
                deltaX: 0,
                deltaZ: 0,
                preventDefault: function () {
                  a.preventDefault ? a.preventDefault() : a.returnValue = !1;
                  return !1
                },
                stopImmediatePropagation: function () {
                  a.stopImmediatePropagation ? a.stopImmediatePropagation() : a.cancelBubble = !0
                }
              };
              "mousewheel" == c ? (a.wheelDeltaX && (k.deltaX = -.025 * a.wheelDeltaX), a.wheelDeltaY && (k.deltaY = -.025 * a.wheelDeltaY),
                k.deltaY || k.deltaX || (k.deltaY = -.025 * a.wheelDelta)) : k.deltaY = a.detail;
              return e.call(b, k)
            }, d)
          }

          function R(b, c, e) {
            var k, d;
            0 == b.deltaMode ? (k = -Math.floor(a.opt.mousescrollstep / 54 * b.deltaX), d = -Math.floor(a.opt.mousescrollstep / 54 * b.deltaY)) : 1 == b.deltaMode && (k = -Math.floor(b.deltaX * a.opt.mousescrollstep), d = -Math.floor(b.deltaY * a.opt.mousescrollstep));
            c && a.opt.oneaxismousemode && 0 == k && d && (k = d, d = 0, e && (0 > k ? a.getScrollLeft() >= a.page.maxw : 0 >= a.getScrollLeft()) && (d = k, k = 0));
            a.isrtlmode && (k = -k);
            k && (a.scrollmom && a.scrollmom.stop(),
              a.lastdeltax += k, a.debounced("mousewheelx", function () {
                var b = a.lastdeltax;
                a.lastdeltax = 0;
                a.rail.drag || a.doScrollLeftBy(b)
              }, 15));
            if (d) {
              if (a.opt.nativeparentscrolling && e && !a.ispage && !a.zoomactive)
                if (0 > d) {
                  if (a.getScrollTop() >= a.page.maxh) return !0
                } else if (0 >= a.getScrollTop()) return !0;
              a.scrollmom && a.scrollmom.stop();
              a.lastdeltay += d;
              a.synched("mousewheely", function () {
                var b = a.lastdeltay;
                a.lastdeltay = 0;
                a.rail.drag || a.doScrollBy(b)
              }, 15)
            }
            b.stopImmediatePropagation();
            return b.preventDefault()
          }
          var a = this;
          this.version =
            "3.6.8";
          this.name = "nicescroll";
          this.me = m;
          this.opt = {
            doc: b("body"),
            win: !1
          };
          b.extend(this.opt, C);
          this.opt.snapbackspeed = 80;
          if (d)
            for (var E in a.opt) void 0 !== d[E] && (a.opt[E] = d[E]);
          a.opt.disablemutationobserver && (I = !1);
          this.iddoc = (this.doc = a.opt.doc) && this.doc[0] ? this.doc[0].id || "" : "";
          this.ispage = /^BODY|HTML/.test(a.opt.win ? a.opt.win[0].nodeName : this.doc[0].nodeName);
          this.haswrapper = !1 !== a.opt.win;
          this.win = a.opt.win || (this.ispage ? b(window) : this.doc);
          this.docscroll = this.ispage && !this.haswrapper ? b(window) :
            this.win;
          this.body = b("body");
          this.iframe = this.isfixed = this.viewport = !1;
          this.isiframe = "IFRAME" == this.doc[0].nodeName && "IFRAME" == this.win[0].nodeName;
          this.istextarea = "TEXTAREA" == this.win[0].nodeName;
          this.forcescreen = !1;
          this.canshowonmouseevent = "scroll" != a.opt.autohidemode;
          this.page = this.view = this.onzoomout = this.onzoomin = this.onscrollcancel = this.onscrollend = this.onscrollstart = this.onclick = this.ongesturezoom = this.onkeypress = this.onmousewheel = this.onmousemove = this.onmouseup = this.onmousedown = !1;
          this.scroll = {
            x: 0,
            y: 0
          };
          this.scrollratio = {
            x: 0,
            y: 0
          };
          this.cursorheight = 20;
          this.scrollvaluemax = 0;
          if ("auto" == this.opt.rtlmode) {
            E = this.win[0] == window ? this.body : this.win;
            var H = E.css("writing-mode") || E.css("-webkit-writing-mode") || E.css("-ms-writing-mode") || E.css("-moz-writing-mode");
            "horizontal-tb" == H || "lr-tb" == H || "" == H ? (this.isrtlmode = "rtl" == E.css("direction"), this.isvertical = !1) : (this.isrtlmode = "vertical-rl" == H || "tb" == H || "tb-rl" == H || "rl-tb" == H, this.isvertical = "vertical-rl" == H || "tb" == H || "tb-rl" == H)
          } else this.isrtlmode = !0 === this.opt.rtlmode, this.isvertical = !1;
          this.observerbody = this.observerremover = this.observer = this.scrollmom = this.scrollrunning = !1;
          do this.id = "ascrail" + g++; while (document.getElementById(this.id));
          this.hasmousefocus = this.hasfocus = this.zoomactive = this.zoom = this.selectiondrag = this.cursorfreezed = this.cursor = this.rail = !1;
          this.visibility = !0;
          this.hidden = this.locked = this.railslocked = !1;
          this.cursoractive = !0;
          this.wheelprevented = !1;
          this.overflowx = a.opt.overflowx;
          this.overflowy = a.opt.overflowy;
          this.nativescrollingarea = !1;
          this.checkarea = 0;
          this.events = [];
          this.saved = {};
          this.delaylist = {};
          this.synclist = {};
          this.lastdeltay = this.lastdeltax = 0;
          this.detected = G();
          var h = b.extend({}, this.detected);
          this.ishwscroll = (this.canhwscroll = h.hastransform && a.opt.hwacceleration) && a.haswrapper;
          this.hasreversehr = this.isrtlmode ? this.isvertical ? !(h.iswebkit || h.isie || h.isie11) : !(h.iswebkit || h.isie && !h.isie10 && !h.isie11) : !1;
          this.istouchcapable = !1;
          h.cantouch || !h.hasw3ctouch && !h.hasmstouch ? !h.cantouch || h.isios || h.isandroid || !h.iswebkit && !h.ismozilla ||
            (this.istouchcapable = !0) : this.istouchcapable = !0;
          a.opt.enablemouselockapi || (h.hasmousecapture = !1, h.haspointerlock = !1);
          this.debounced = function (b, c, e) {
            a && (a.delaylist[b] || (a.delaylist[b] = {
              h: n(function () {
                a.delaylist[b].fn.call(a);
                a.delaylist[b] = !1
              }, e)
            }, c.call(a)), a.delaylist[b].fn = c)
          };
          var u = !1;
          this.synched = function (b, c) {
            a.synclist[b] = c;
            (function () {
              u || (n(function () {
                if (a) {
                  u = !1;
                  for (var b in a.synclist) {
                    var c = a.synclist[b];
                    c && c.call(a);
                    a.synclist[b] = !1
                  }
                }
              }), u = !0)
            })();
            return b
          };
          this.unsynched = function (b) {
            a.synclist[b] &&
              (a.synclist[b] = !1)
          };
          this.css = function (b, c) {
            for (var k in c) a.saved.css.push([b, k, b.css(k)]), b.css(k, c[k])
          };
          this.scrollTop = function (b) {
            return void 0 === b ? a.getScrollTop() : a.setScrollTop(b)
          };
          this.scrollLeft = function (b) {
            return void 0 === b ? a.getScrollLeft() : a.setScrollLeft(b)
          };
          var x = function (a, b, c, e, d, f, m) {
            this.st = a;
            this.ed = b;
            this.spd = c;
            this.p1 = e || 0;
            this.p2 = d || 1;
            this.p3 = f || 0;
            this.p4 = m || 1;
            this.ts = (new Date).getTime();
            this.df = this.ed - this.st
          };
          x.prototype = {
            B2: function (a) {
              return 3 * a * a * (1 - a)
            },
            B3: function (a) {
              return 3 *
                a * (1 - a) * (1 - a)
            },
            B4: function (a) {
              return (1 - a) * (1 - a) * (1 - a)
            },
            getNow: function () {
              var a = 1 - ((new Date).getTime() - this.ts) / this.spd,
                b = this.B2(a) + this.B3(a) + this.B4(a);
              return 0 > a ? this.ed : this.st + Math.round(this.df * b)
            },
            update: function (a, b) {
              this.st = this.getNow();
              this.ed = a;
              this.spd = b;
              this.ts = (new Date).getTime();
              this.df = this.ed - this.st;
              return this
            }
          };
          if (this.ishwscroll) {
            this.doc.translate = {
              x: 0,
              y: 0,
              tx: "0px",
              ty: "0px"
            };
            h.hastranslate3d && h.isios && this.doc.css("-webkit-backface-visibility", "hidden");
            this.getScrollTop =
              function (b) {
                if (!b) {
                  if (b = P()) return 16 == b.length ? -b[13] : -b[5];
                  if (a.timerscroll && a.timerscroll.bz) return a.timerscroll.bz.getNow()
                }
                return a.doc.translate.y
              };
            this.getScrollLeft = function (b) {
              if (!b) {
                if (b = P()) return 16 == b.length ? -b[12] : -b[4];
                if (a.timerscroll && a.timerscroll.bh) return a.timerscroll.bh.getNow()
              }
              return a.doc.translate.x
            };
            this.notifyScrollEvent = function (a) {
              var b = document.createEvent("UIEvents");
              b.initUIEvent("scroll", !1, !0, window, 1);
              b.niceevent = !0;
              a.dispatchEvent(b)
            };
            var y = this.isrtlmode ? 1 : -1;
            h.hastranslate3d && a.opt.enabletranslate3d ? (this.setScrollTop = function (b, c) {
              a.doc.translate.y = b;
              a.doc.translate.ty = -1 * b + "px";
              a.doc.css(h.trstyle, "translate3d(" + a.doc.translate.tx + "," + a.doc.translate.ty + ",0px)");
              c || a.notifyScrollEvent(a.win[0])
            }, this.setScrollLeft = function (b, c) {
              a.doc.translate.x = b;
              a.doc.translate.tx = b * y + "px";
              a.doc.css(h.trstyle, "translate3d(" + a.doc.translate.tx + "," + a.doc.translate.ty + ",0px)");
              c || a.notifyScrollEvent(a.win[0])
            }) : (this.setScrollTop = function (b, c) {
              a.doc.translate.y = b;
              a.doc.translate.ty = -1 * b + "px";
              a.doc.css(h.trstyle, "translate(" + a.doc.translate.tx + "," + a.doc.translate.ty + ")");
              c || a.notifyScrollEvent(a.win[0])
            }, this.setScrollLeft = function (b, c) {
              a.doc.translate.x = b;
              a.doc.translate.tx = b * y + "px";
              a.doc.css(h.trstyle, "translate(" + a.doc.translate.tx + "," + a.doc.translate.ty + ")");
              c || a.notifyScrollEvent(a.win[0])
            })
          } else this.getScrollTop = function () {
            return a.docscroll.scrollTop()
          }, this.setScrollTop = function (b) {
            return setTimeout(function () {
              a && a.docscroll.scrollTop(b)
            }, 1)
          }, this.getScrollLeft = function () {
            return a.hasreversehr ?
              a.detected.ismozilla ? a.page.maxw - Math.abs(a.docscroll.scrollLeft()) : a.page.maxw - a.docscroll.scrollLeft() : a.docscroll.scrollLeft()
          }, this.setScrollLeft = function (b) {
            return setTimeout(function () {
              if (a) return a.hasreversehr && (b = a.detected.ismozilla ? -(a.page.maxw - b) : a.page.maxw - b), a.docscroll.scrollLeft(b)
            }, 1)
          };
          this.getTarget = function (a) {
            return a ? a.target ? a.target : a.srcElement ? a.srcElement : !1 : !1
          };
          this.hasParent = function (a, b) {
            if (!a) return !1;
            for (var c = a.target || a.srcElement || a || !1; c && c.id != b;) c = c.parentNode ||
              !1;
            return !1 !== c
          };
          var w = {
            thin: 1,
            medium: 3,
            thick: 5
          };
          this.getDocumentScrollOffset = function () {
            return {
              top: window.pageYOffset || document.documentElement.scrollTop,
              left: window.pageXOffset || document.documentElement.scrollLeft
            }
          };
          this.getOffset = function () {
            if (a.isfixed) {
              var b = a.win.offset(),
                c = a.getDocumentScrollOffset();
              b.top -= c.top;
              b.left -= c.left;
              return b
            }
            b = a.win.offset();
            if (!a.viewport) return b;
            c = a.viewport.offset();
            return {
              top: b.top - c.top,
              left: b.left - c.left
            }
          };
          this.updateScrollBar = function (b) {
            var c;
            if (a.ishwscroll) a.rail.css({
              height: a.win.innerHeight() -
                (a.opt.railpadding.top + a.opt.railpadding.bottom)
            }), a.railh && a.railh.css({
              width: a.win.innerWidth() - (a.opt.railpadding.left + a.opt.railpadding.right)
            });
            else {
              var k = a.getOffset();
              var e = k.top;
              var d = k.left - (a.opt.railpadding.left + a.opt.railpadding.right);
              e += q(a.win, "border-top-width", !0);
              d += a.rail.align ? a.win.outerWidth() - q(a.win, "border-right-width") - a.rail.width : q(a.win, "border-left-width");
              if (c = a.opt.railoffset) c.top && (e += c.top), c.left && (d += c.left);
              a.railslocked || a.rail.css({
                top: e,
                left: d,
                height: (b ? b.h :
                  a.win.innerHeight()) - (a.opt.railpadding.top + a.opt.railpadding.bottom)
              });
              a.zoom && a.zoom.css({
                top: e + 1,
                left: 1 == a.rail.align ? d - 20 : d + a.rail.width + 4
              });
              if (a.railh && !a.railslocked) {
                e = k.top;
                d = k.left;
                if (c = a.opt.railhoffset) c.top && (e += c.top), c.left && (d += c.left);
                b = a.railh.align ? e + q(a.win, "border-top-width", !0) + a.win.innerHeight() - a.railh.height : e + q(a.win, "border-top-width", !0);
                d += q(a.win, "border-left-width");
                a.railh.css({
                  top: b - (a.opt.railpadding.top + a.opt.railpadding.bottom),
                  left: d,
                  width: a.railh.width
                })
              }
            }
          };
          this.doRailClick =
            function (b, c, e) {
              var k;
              a.railslocked || (a.cancelEvent(b), c ? (c = e ? a.doScrollLeft : a.doScrollTop, k = e ? (b.pageX - a.railh.offset().left - a.cursorwidth / 2) * a.scrollratio.x : (b.pageY - a.rail.offset().top - a.cursorheight / 2) * a.scrollratio.y, c(k)) : (c = e ? a.doScrollLeftBy : a.doScrollBy, k = e ? a.scroll.x : a.scroll.y, b = e ? b.pageX - a.railh.offset().left : b.pageY - a.rail.offset().top, e = e ? a.view.w : a.view.h, c(k >= b ? e : -e)))
            };
          a.hasanimationframe = n;
          a.hascancelanimationframe = r;
          a.hasanimationframe ? a.hascancelanimationframe || (r = function () {
            a.cancelAnimationFrame = !0
          }) : (n = function (a) {
            return setTimeout(a, 15 - Math.floor(+new Date / 1E3) % 16)
          }, r = clearTimeout);
          this.init = function () {
            a.saved.css = [];
            if (h.isie7mobile || h.isoperamini) return !0;
            h.hasmstouch && a.css(a.ispage ? b("html") : a.win, {
              _touchaction: "none"
            });
            var k = h.ismodernie || h.isie10 ? {
              "-ms-overflow-style": "none"
            } : {
              "overflow-y": "hidden"
            };
            a.zindex = "auto";
            a.zindex = a.ispage || "auto" != a.opt.zindex ? a.opt.zindex : ta() || "auto";
            !a.ispage && "auto" != a.zindex && a.zindex > l && (l = a.zindex);
            a.isie && 0 == a.zindex && "auto" == a.opt.zindex && (a.zindex =
              "auto");
            if (!a.ispage || !h.cantouch && !h.isieold && !h.isie9mobile) {
              var d = a.docscroll;
              a.ispage && (d = a.haswrapper ? a.win : a.doc);
              h.isie9mobile || a.css(d, k);
              a.ispage && h.isie7 && ("BODY" == a.doc[0].nodeName ? a.css(b("html"), {
                "overflow-y": "hidden"
              }) : "HTML" == a.doc[0].nodeName && a.css(b("body"), k));
              !h.isios || a.ispage || a.haswrapper || a.css(b("body"), {
                "-webkit-overflow-scrolling": "touch"
              });
              var m = b(document.createElement("div"));
              m.css({
                position: "relative",
                top: 0,
                "float": "right",
                width: a.opt.cursorwidth,
                height: 0,
                "background-color": a.opt.cursorcolor,
                border: a.opt.cursorborder,
                "background-clip": "padding-box",
                "-webkit-border-radius": a.opt.cursorborderradius,
                "-moz-border-radius": a.opt.cursorborderradius,
                "border-radius": a.opt.cursorborderradius
              });
              m.hborder = parseFloat(m.outerHeight() - m.innerHeight());
              m.addClass("nicescroll-cursors");
              a.cursor = m;
              var g = b(document.createElement("div"));
              g.attr("id", a.id);
              g.addClass("nicescroll-rails nicescroll-rails-vr");
              var P, q = ["left", "right", "top", "bottom"],
                p;
              for (p in q) {
                var n = q[p];
                (P = a.opt.railpadding[n]) ? g.css("padding-" +
                  n, P + "px"): a.opt.railpadding[n] = 0
              }
              g.append(m);
              g.width = Math.max(parseFloat(a.opt.cursorwidth), m.outerWidth());
              g.css({
                width: g.width + "px",
                zIndex: a.zindex,
                background: a.opt.background,
                cursor: "default"
              });
              g.visibility = !0;
              g.scrollable = !0;
              g.align = "left" == a.opt.railalign ? 0 : 1;
              a.rail = g;
              m = a.rail.drag = !1;
              if (a.opt.boxzoom && !a.ispage && !h.isieold) {
                m = document.createElement("div");
                a.on(m, "click", a.doZoom);
                a.on(m, "mouseenter", function () {
                  a.zoom.css("opacity", a.opt.cursoropacitymax)
                });
                a.on(m, "mouseleave", function () {
                  a.zoom.css("opacity",
                    a.opt.cursoropacitymin)
                });
                a.zoom = b(m);
                a.zoom.css({
                  cursor: "pointer",
                  zIndex: a.zindex,
                  backgroundImage: "url(" + a.opt.scriptpath + "zoomico.png)",
                  height: 18,
                  width: 18,
                  backgroundPosition: "0px 0px"
                });
                if (a.opt.dblclickzoom) a.on(a.win, "dblclick", a.doZoom);
                h.cantouch && a.opt.gesturezoom && (a.ongesturezoom = function (b) {
                  1.5 < b.scale && a.doZoomIn(b);
                  .8 > b.scale && a.doZoomOut(b);
                  return a.cancelEvent(b)
                }, a.on(a.win, "gestureend", a.ongesturezoom))
              }
              a.railh = !1;
              var t;
              a.opt.horizrailenabled && (a.css(d, {
                  overflowX: "hidden"
                }), m = b(document.createElement("div")),
                m.css({
                  position: "absolute",
                  top: 0,
                  height: a.opt.cursorwidth,
                  width: 0,
                  backgroundColor: a.opt.cursorcolor,
                  border: a.opt.cursorborder,
                  backgroundClip: "padding-box",
                  "-webkit-border-radius": a.opt.cursorborderradius,
                  "-moz-border-radius": a.opt.cursorborderradius,
                  "border-radius": a.opt.cursorborderradius
                }), h.isieold && m.css("overflow", "hidden"), m.wborder = parseFloat(m.outerWidth() - m.innerWidth()), m.addClass("nicescroll-cursors"), a.cursorh = m, t = b(document.createElement("div")), t.attr("id", a.id + "-hr"), t.addClass("nicescroll-rails nicescroll-rails-hr"),
                t.height = Math.max(parseFloat(a.opt.cursorwidth), m.outerHeight()), t.css({
                  height: t.height + "px",
                  zIndex: a.zindex,
                  background: a.opt.background
                }), t.append(m), t.visibility = !0, t.scrollable = !0, t.align = "top" == a.opt.railvalign ? 0 : 1, a.railh = t, a.railh.drag = !1);
              a.ispage ? (g.css({
                position: "fixed",
                top: 0,
                height: "100%"
              }), g.align ? g.css({
                right: 0
              }) : g.css({
                left: 0
              }), a.body.append(g), a.railh && (t.css({
                position: "fixed",
                left: 0,
                width: "100%"
              }), t.align ? t.css({
                bottom: 0
              }) : t.css({
                top: 0
              }), a.body.append(t))) : (a.ishwscroll ? ("static" ==
                  a.win.css("position") && a.css(a.win, {
                    position: "relative"
                  }), d = "HTML" == a.win[0].nodeName ? a.body : a.win, b(d).scrollTop(0).scrollLeft(0), a.zoom && (a.zoom.css({
                    position: "absolute",
                    top: 1,
                    right: 0,
                    "margin-right": g.width + 4
                  }), d.append(a.zoom)), g.css({
                    position: "absolute",
                    top: 0
                  }), g.align ? g.css({
                    right: 0
                  }) : g.css({
                    left: 0
                  }), d.append(g), t && (t.css({
                    position: "absolute",
                    left: 0,
                    bottom: 0
                  }), t.align ? t.css({
                    bottom: 0
                  }) : t.css({
                    top: 0
                  }), d.append(t))) : (a.isfixed = "fixed" == a.win.css("position"), d = a.isfixed ? "fixed" : "absolute", a.isfixed ||
                  (a.viewport = a.getViewport(a.win[0])), a.viewport && (a.body = a.viewport, 0 == /fixed|absolute/.test(a.viewport.css("position")) && a.css(a.viewport, {
                    position: "relative"
                  })), g.css({
                    position: d
                  }), a.zoom && a.zoom.css({
                    position: d
                  }), a.updateScrollBar(), a.body.append(g), a.zoom && a.body.append(a.zoom), a.railh && (t.css({
                    position: d
                  }), a.body.append(t))), h.isios && a.css(a.win, {
                  "-webkit-tap-highlight-color": "rgba(0,0,0,0)",
                  "-webkit-touch-callout": "none"
                }), h.isie && a.opt.disableoutline && a.win.attr("hideFocus", "true"), h.iswebkit &&
                a.opt.disableoutline && a.win.css("outline", "none"));
              !1 === a.opt.autohidemode ? (a.autohidedom = !1, a.rail.css({
                opacity: a.opt.cursoropacitymax
              }), a.railh && a.railh.css({
                opacity: a.opt.cursoropacitymax
              })) : !0 === a.opt.autohidemode || "leave" === a.opt.autohidemode ? (a.autohidedom = b().add(a.rail), h.isie8 && (a.autohidedom = a.autohidedom.add(a.cursor)), a.railh && (a.autohidedom = a.autohidedom.add(a.railh)), a.railh && h.isie8 && (a.autohidedom = a.autohidedom.add(a.cursorh))) : "scroll" == a.opt.autohidemode ? (a.autohidedom = b().add(a.rail),
                a.railh && (a.autohidedom = a.autohidedom.add(a.railh))) : "cursor" == a.opt.autohidemode ? (a.autohidedom = b().add(a.cursor), a.railh && (a.autohidedom = a.autohidedom.add(a.cursorh))) : "hidden" == a.opt.autohidemode && (a.autohidedom = !1, a.hide(), a.railslocked = !1);
              if (h.isie9mobile) a.scrollmom = new B(a), a.onmangotouch = function () {
                var b = a.getScrollTop(),
                  c = a.getScrollLeft();
                if (b == a.scrollmom.lastscrolly && c == a.scrollmom.lastscrollx) return !0;
                var k = b - a.mangotouch.sy,
                  d = c - a.mangotouch.sx;
                if (0 != Math.round(Math.sqrt(Math.pow(d,
                    2) + Math.pow(k, 2)))) {
                  var e = 0 > k ? -1 : 1,
                    f = 0 > d ? -1 : 1,
                    m = +new Date;
                  a.mangotouch.lazy && clearTimeout(a.mangotouch.lazy);
                  80 < m - a.mangotouch.tm || a.mangotouch.dry != e || a.mangotouch.drx != f ? (a.scrollmom.stop(), a.scrollmom.reset(c, b), a.mangotouch.sy = b, a.mangotouch.ly = b, a.mangotouch.sx = c, a.mangotouch.lx = c, a.mangotouch.dry = e, a.mangotouch.drx = f, a.mangotouch.tm = m) : (a.scrollmom.stop(), a.scrollmom.update(a.mangotouch.sx - d, a.mangotouch.sy - k), a.mangotouch.tm = m, k = Math.max(Math.abs(a.mangotouch.ly - b), Math.abs(a.mangotouch.lx -
                    c)), a.mangotouch.ly = b, a.mangotouch.lx = c, 2 < k && (a.mangotouch.lazy = setTimeout(function () {
                    a.mangotouch.lazy = !1;
                    a.mangotouch.dry = 0;
                    a.mangotouch.drx = 0;
                    a.mangotouch.tm = 0;
                    a.scrollmom.doMomentum(30)
                  }, 100)))
                }
              }, g = a.getScrollTop(), t = a.getScrollLeft(), a.mangotouch = {
                sy: g,
                ly: g,
                dry: 0,
                sx: t,
                lx: t,
                drx: 0,
                lazy: !1,
                tm: 0
              }, a.on(a.docscroll, "scroll", a.onmangotouch);
              else {
                if (h.cantouch || a.istouchcapable || a.opt.touchbehavior || h.hasmstouch) {
                  a.scrollmom = new B(a);
                  a.ontouchstart = function (c) {
                    if (c.pointerType && 2 != c.pointerType && "touch" !=
                      c.pointerType) return !1;
                    a.hasmoving = !1;
                    if (!a.railslocked) {
                      var k;
                      if (h.hasmstouch)
                        for (k = c.target ? c.target : !1; k;) {
                          var d = b(k).getNiceScroll();
                          if (0 < d.length && d[0].me == a.me) break;
                          if (0 < d.length) return !1;
                          if ("DIV" == k.nodeName && k.id == a.id) break;
                          k = k.parentNode ? k.parentNode : !1
                        }
                      a.cancelScroll();
                      if ((k = a.getTarget(c)) && /INPUT/i.test(k.nodeName) && /range/i.test(k.type)) return a.stopPropagation(c);
                      !("clientX" in c) && "changedTouches" in c && (c.clientX = c.changedTouches[0].clientX, c.clientY = c.changedTouches[0].clientY);
                      a.forcescreen &&
                        (d = c, c = {
                          original: c.original ? c.original : c
                        }, c.clientX = d.screenX, c.clientY = d.screenY);
                      a.rail.drag = {
                        x: c.clientX,
                        y: c.clientY,
                        sx: a.scroll.x,
                        sy: a.scroll.y,
                        st: a.getScrollTop(),
                        sl: a.getScrollLeft(),
                        pt: 2,
                        dl: !1
                      };
                      if (a.ispage || !a.opt.directionlockdeadzone) a.rail.drag.dl = "f";
                      else {
                        d = b(window).width();
                        var e = b(window).height();
                        e = Math.max(0, Math.max(document.body.scrollHeight, document.documentElement.scrollHeight) - e);
                        d = Math.max(0, Math.max(document.body.scrollWidth, document.documentElement.scrollWidth) - d);
                        a.rail.drag.ck = !a.rail.scrollable && a.railh.scrollable ? 0 < e ? "v" : !1 : a.rail.scrollable && !a.railh.scrollable ? 0 < d ? "h" : !1 : !1;
                        a.rail.drag.ck || (a.rail.drag.dl = "f")
                      }
                      a.opt.touchbehavior && a.isiframe && h.isie && (d = a.win.position(), a.rail.drag.x += d.left, a.rail.drag.y += d.top);
                      a.hasmoving = !1;
                      a.lastmouseup = !1;
                      a.scrollmom.reset(c.clientX, c.clientY);
                      if (!h.cantouch && !this.istouchcapable && !c.pointerType) {
                        if (!k || !/INPUT|SELECT|TEXTAREA/i.test(k.nodeName)) return !a.ispage && h.hasmousecapture && k.setCapture(), a.opt.touchbehavior ? (k.onclick &&
                          !k._onclick && (k._onclick = k.onclick, k.onclick = function (b) {
                            if (a.hasmoving) return !1;
                            k._onclick.call(this, b)
                          }), a.cancelEvent(c)) : a.stopPropagation(c);
                        /SUBMIT|CANCEL|BUTTON/i.test(b(k).attr("type")) && (pc = {
                          tg: k,
                          click: !1
                        }, a.preventclick = pc)
                      }
                    }
                  };
                  a.ontouchend = function (b) {
                    if (!a.rail.drag) return !0;
                    if (2 == a.rail.drag.pt) {
                      if (b.pointerType && 2 != b.pointerType && "touch" != b.pointerType) return !1;
                      a.scrollmom.doMomentum();
                      a.rail.drag = !1;
                      if (a.hasmoving && (a.lastmouseup = !0, a.hideCursor(), h.hasmousecapture && document.releaseCapture(), !h.cantouch)) return a.cancelEvent(b)
                    } else if (1 == a.rail.drag.pt) return a.onmouseup(b)
                  };
                  var R = a.opt.touchbehavior && a.isiframe && !h.hasmousecapture;
                  a.ontouchmove = function (c, k) {
                    if (!a.rail.drag || c.targetTouches && a.opt.preventmultitouchscrolling && 1 < c.targetTouches.length || c.pointerType && 2 != c.pointerType && "touch" != c.pointerType) return !1;
                    if (2 == a.rail.drag.pt) {
                      if (h.cantouch && h.isios && void 0 === c.original) return !0;
                      a.hasmoving = !0;
                      a.preventclick && !a.preventclick.click && (a.preventclick.click = a.preventclick.tg.onclick ||
                        !1, a.preventclick.tg.onclick = a.onpreventclick);
                      c = b.extend({
                        original: c
                      }, c);
                      "changedTouches" in c && (c.clientX = c.changedTouches[0].clientX, c.clientY = c.changedTouches[0].clientY);
                      if (a.forcescreen) {
                        var d = c;
                        c = {
                          original: c.original ? c.original : c
                        };
                        c.clientX = d.screenX;
                        c.clientY = d.screenY
                      }
                      var e;
                      d = e = 0;
                      R && !k && (e = a.win.position(), d = -e.left, e = -e.top);
                      var f = c.clientY + e;
                      e = f - a.rail.drag.y;
                      var m = c.clientX + d,
                        v = m - a.rail.drag.x,
                        g = a.rail.drag.st - e;
                      a.ishwscroll && a.opt.bouncescroll ? 0 > g ? g = Math.round(g / 2) : g > a.page.maxh && (g = a.page.maxh +
                        Math.round((g - a.page.maxh) / 2)) : (0 > g && (f = g = 0), g > a.page.maxh && (g = a.page.maxh, f = 0));
                      var z;
                      a.railh && a.railh.scrollable && (z = a.isrtlmode ? v - a.rail.drag.sl : a.rail.drag.sl - v, a.ishwscroll && a.opt.bouncescroll ? 0 > z ? z = Math.round(z / 2) : z > a.page.maxw && (z = a.page.maxw + Math.round((z - a.page.maxw) / 2)) : (0 > z && (m = z = 0), z > a.page.maxw && (z = a.page.maxw, m = 0)));
                      d = !1;
                      if (a.rail.drag.dl) d = !0, "v" == a.rail.drag.dl ? z = a.rail.drag.sl : "h" == a.rail.drag.dl && (g = a.rail.drag.st);
                      else {
                        e = Math.abs(e);
                        v = Math.abs(v);
                        var T = a.opt.directionlockdeadzone;
                        if ("v" == a.rail.drag.ck) {
                          if (e > T && v <= .3 * e) return a.rail.drag = !1, !0;
                          v > T && (a.rail.drag.dl = "f", b("body").scrollTop(b("body").scrollTop()))
                        } else if ("h" == a.rail.drag.ck) {
                          if (v > T && e <= .3 * v) return a.rail.drag = !1, !0;
                          e > T && (a.rail.drag.dl = "f", b("body").scrollLeft(b("body").scrollLeft()))
                        }
                      }
                      a.synched("touchmove", function () {
                        a.rail.drag && 2 == a.rail.drag.pt && (a.prepareTransition && a.prepareTransition(0), a.rail.scrollable && a.setScrollTop(g), a.scrollmom.update(m, f), a.railh && a.railh.scrollable ? (a.setScrollLeft(z), a.showCursor(g,
                          z)) : a.showCursor(g), h.isie10 && document.selection.clear())
                      });
                      h.ischrome && a.istouchcapable && (d = !1);
                      if (d) return a.cancelEvent(c)
                    } else if (1 == a.rail.drag.pt) return a.onmousemove(c)
                  }
                }
                a.onmousedown = function (b, c) {
                  if (!a.rail.drag || 1 == a.rail.drag.pt) {
                    if (a.railslocked) return a.cancelEvent(b);
                    a.cancelScroll();
                    a.rail.drag = {
                      x: b.clientX,
                      y: b.clientY,
                      sx: a.scroll.x,
                      sy: a.scroll.y,
                      pt: 1,
                      hr: !!c
                    };
                    var k = a.getTarget(b);
                    !a.ispage && h.hasmousecapture && k.setCapture();
                    a.isiframe && !h.hasmousecapture && (a.saved.csspointerevents =
                      a.doc.css("pointer-events"), a.css(a.doc, {
                        "pointer-events": "none"
                      }));
                    a.hasmoving = !1;
                    return a.cancelEvent(b)
                  }
                };
                a.onmouseup = function (b) {
                  if (a.rail.drag) {
                    if (1 != a.rail.drag.pt) return !0;
                    h.hasmousecapture && document.releaseCapture();
                    a.isiframe && !h.hasmousecapture && a.doc.css("pointer-events", a.saved.csspointerevents);
                    a.rail.drag = !1;
                    a.hasmoving && a.triggerScrollEnd();
                    return a.cancelEvent(b)
                  }
                };
                a.onmousemove = function (b) {
                  if (a.rail.drag) {
                    if (1 == a.rail.drag.pt) {
                      if (h.ischrome && 0 == b.which) return a.onmouseup(b);
                      a.cursorfreezed = !0;
                      a.hasmoving = !0;
                      if (a.rail.drag.hr) {
                        a.scroll.x = a.rail.drag.sx + (b.clientX - a.rail.drag.x);
                        0 > a.scroll.x && (a.scroll.x = 0);
                        var c = a.scrollvaluemaxw;
                        a.scroll.x > c && (a.scroll.x = c)
                      } else a.scroll.y = a.rail.drag.sy + (b.clientY - a.rail.drag.y), 0 > a.scroll.y && (a.scroll.y = 0), c = a.scrollvaluemax, a.scroll.y > c && (a.scroll.y = c);
                      a.synched("mousemove", function () {
                        a.rail.drag && 1 == a.rail.drag.pt && (a.showCursor(), a.rail.drag.hr ? a.hasreversehr ? a.doScrollLeft(a.scrollvaluemaxw - Math.round(a.scroll.x * a.scrollratio.x), a.opt.cursordragspeed) :
                          a.doScrollLeft(Math.round(a.scroll.x * a.scrollratio.x), a.opt.cursordragspeed) : a.doScrollTop(Math.round(a.scroll.y * a.scrollratio.y), a.opt.cursordragspeed))
                      });
                      return a.cancelEvent(b)
                    }
                  } else a.checkarea = 0
                };
                if (h.cantouch || a.opt.touchbehavior) a.onpreventclick = function (b) {
                  if (a.preventclick) return a.preventclick.tg.onclick = a.preventclick.click, a.preventclick = !1, a.cancelEvent(b)
                }, a.on(a.win, "mousedown", a.ontouchstart), a.onclick = h.isios ? !1 : function (b) {
                  return a.lastmouseup ? (a.lastmouseup = !1, a.cancelEvent(b)) :
                    !0
                }, a.opt.grabcursorenabled && h.cursorgrabvalue && (a.css(a.ispage ? a.doc : a.win, {
                  cursor: h.cursorgrabvalue
                }), a.css(a.rail, {
                  cursor: h.cursorgrabvalue
                }));
                else {
                  var oa = function (b) {
                    if (a.selectiondrag) {
                      if (b) {
                        var c = a.win.outerHeight();
                        b = b.pageY - a.selectiondrag.top;
                        0 < b && b < c && (b = 0);
                        b >= c && (b -= c);
                        a.selectiondrag.df = b
                      }
                      0 != a.selectiondrag.df && (a.doScrollBy(2 * -Math.floor(a.selectiondrag.df / 6)), a.debounced("doselectionscroll", function () {
                        oa()
                      }, 50))
                    }
                  };
                  a.hasTextSelected = "getSelection" in document ? function () {
                      return 0 < document.getSelection().rangeCount
                    } :
                    "selection" in document ? function () {
                      return "None" != document.selection.type
                    } : function () {
                      return !1
                    };
                  a.onselectionstart = function (b) {
                    a.ispage || (a.selectiondrag = a.win.offset())
                  };
                  a.onselectionend = function (b) {
                    a.selectiondrag = !1
                  };
                  a.onselectiondrag = function (b) {
                    a.selectiondrag && a.hasTextSelected() && a.debounced("selectionscroll", function () {
                      oa(b)
                    }, 250)
                  }
                }
                h.hasw3ctouch ? (a.css(a.rail, {
                    "touch-action": "none"
                  }), a.css(a.cursor, {
                    "touch-action": "none"
                  }), a.on(a.win, "pointerdown", a.ontouchstart), a.on(document, "pointerup", a.ontouchend),
                  a.on(document, "pointermove", a.ontouchmove)) : h.hasmstouch ? (a.css(a.rail, {
                  "-ms-touch-action": "none"
                }), a.css(a.cursor, {
                  "-ms-touch-action": "none"
                }), a.on(a.win, "MSPointerDown", a.ontouchstart), a.on(document, "MSPointerUp", a.ontouchend), a.on(document, "MSPointerMove", a.ontouchmove), a.on(a.cursor, "MSGestureHold", function (a) {
                  a.preventDefault()
                }), a.on(a.cursor, "contextmenu", function (a) {
                  a.preventDefault()
                })) : this.istouchcapable && (a.on(a.win, "touchstart", a.ontouchstart), a.on(document, "touchend", a.ontouchend), a.on(document,
                  "touchcancel", a.ontouchend), a.on(document, "touchmove", a.ontouchmove));
                if (a.opt.cursordragontouch || !h.cantouch && !a.opt.touchbehavior) a.rail.css({
                  cursor: "default"
                }), a.railh && a.railh.css({
                  cursor: "default"
                }), a.jqbind(a.rail, "mouseenter", function () {
                  if (!a.ispage && !a.win.is(":visible")) return !1;
                  a.canshowonmouseevent && a.showCursor();
                  a.rail.active = !0
                }), a.jqbind(a.rail, "mouseleave", function () {
                  a.rail.active = !1;
                  a.rail.drag || a.hideCursor()
                }), a.opt.sensitiverail && (a.on(a.rail, "click", function (b) {
                  a.doRailClick(b, !1, !1)
                }), a.on(a.rail, "dblclick", function (b) {
                  a.doRailClick(b, !0, !1)
                }), a.on(a.cursor, "click", function (b) {
                  a.cancelEvent(b)
                }), a.on(a.cursor, "dblclick", function (b) {
                  a.cancelEvent(b)
                })), a.railh && (a.jqbind(a.railh, "mouseenter", function () {
                  if (!a.ispage && !a.win.is(":visible")) return !1;
                  a.canshowonmouseevent && a.showCursor();
                  a.rail.active = !0
                }), a.jqbind(a.railh, "mouseleave", function () {
                  a.rail.active = !1;
                  a.rail.drag || a.hideCursor()
                }), a.opt.sensitiverail && (a.on(a.railh, "click", function (b) {
                  a.doRailClick(b, !1, !0)
                }), a.on(a.railh,
                  "dblclick",
                  function (b) {
                    a.doRailClick(b, !0, !0)
                  }), a.on(a.cursorh, "click", function (b) {
                  a.cancelEvent(b)
                }), a.on(a.cursorh, "dblclick", function (b) {
                  a.cancelEvent(b)
                })));
                if (h.cantouch || a.opt.touchbehavior) {
                  a.on(h.hasmousecapture ? a.win : document, "mouseup", a.ontouchend);
                  a.on(document, "mousemove", a.ontouchmove);
                  if (a.onclick) a.on(document, "click", a.onclick);
                  a.opt.cursordragontouch ? (a.on(a.cursor, "mousedown", a.onmousedown), a.on(a.cursor, "mouseup", a.onmouseup), a.cursorh && a.on(a.cursorh, "mousedown", function (b) {
                    a.onmousedown(b, !0)
                  }), a.cursorh && a.on(a.cursorh, "mouseup", a.onmouseup)) : (a.on(a.rail, "mousedown", function (a) {
                    a.preventDefault()
                  }), a.railh && a.on(a.railh, "mousedown", function (a) {
                    a.preventDefault()
                  }))
                } else {
                  a.on(h.hasmousecapture ? a.win : document, "mouseup", a.onmouseup);
                  a.on(document, "mousemove", a.onmousemove);
                  if (a.onclick) a.on(document, "click", a.onclick);
                  a.on(a.cursor, "mousedown", a.onmousedown);
                  a.on(a.cursor, "mouseup", a.onmouseup);
                  a.railh && (a.on(a.cursorh, "mousedown", function (b) {
                    a.onmousedown(b, !0)
                  }), a.on(a.cursorh, "mouseup",
                    a.onmouseup));
                  if (!a.ispage && a.opt.enablescrollonselection) {
                    a.on(a.win[0], "mousedown", a.onselectionstart);
                    a.on(document, "mouseup", a.onselectionend);
                    a.on(a.cursor, "mouseup", a.onselectionend);
                    if (a.cursorh) a.on(a.cursorh, "mouseup", a.onselectionend);
                    a.on(document, "mousemove", a.onselectiondrag)
                  }
                  a.zoom && (a.jqbind(a.zoom, "mouseenter", function () {
                    a.canshowonmouseevent && a.showCursor();
                    a.rail.active = !0
                  }), a.jqbind(a.zoom, "mouseleave", function () {
                    a.rail.active = !1;
                    a.rail.drag || a.hideCursor()
                  }))
                }
                a.opt.enablemousewheel &&
                  (a.isiframe || a.mousewheel(h.isie && a.ispage ? document : a.win, a.onmousewheel), a.mousewheel(a.rail, a.onmousewheel), a.railh && a.mousewheel(a.railh, a.onmousewheelhr));
                a.ispage || h.cantouch || /HTML|^BODY/.test(a.win[0].nodeName) || (a.win.attr("tabindex") || a.win.attr({
                  tabindex: e++
                }), a.jqbind(a.win, "focus", function (b) {
                  c = a.getTarget(b).id || !0;
                  a.hasfocus = !0;
                  a.canshowonmouseevent && a.noticeCursor()
                }), a.jqbind(a.win, "blur", function (b) {
                  c = !1;
                  a.hasfocus = !1
                }), a.jqbind(a.win, "mouseenter", function (b) {
                  f = a.getTarget(b).id ||
                    !0;
                  a.hasmousefocus = !0;
                  a.canshowonmouseevent && a.noticeCursor()
                }), a.jqbind(a.win, "mouseleave", function () {
                  f = !1;
                  a.hasmousefocus = !1;
                  a.rail.drag || a.hideCursor()
                }))
              }
              a.onkeypress = function (k) {
                if (a.railslocked && 0 == a.page.maxh) return !0;
                k = k ? k : window.e;
                var d = a.getTarget(k);
                if (d && /INPUT|TEXTAREA|SELECT|OPTION/.test(d.nodeName) && (!d.getAttribute("type") && !d.type || !/submit|button|cancel/i.tp) || b(d).attr("contenteditable")) return !0;
                if (a.hasfocus || a.hasmousefocus && !c || a.ispage && !c && !f) {
                  d = k.keyCode;
                  if (a.railslocked &&
                    27 != d) return a.cancelEvent(k);
                  var e = k.ctrlKey || !1,
                    m = k.shiftKey || !1,
                    v = !1;
                  switch (d) {
                    case 38:
                    case 63233:
                      a.doScrollBy(72);
                      v = !0;
                      break;
                    case 40:
                    case 63235:
                      a.doScrollBy(-72);
                      v = !0;
                      break;
                    case 37:
                    case 63232:
                      a.railh && (e ? a.doScrollLeft(0) : a.doScrollLeftBy(72), v = !0);
                      break;
                    case 39:
                    case 63234:
                      a.railh && (e ? a.doScrollLeft(a.page.maxw) : a.doScrollLeftBy(-72), v = !0);
                      break;
                    case 33:
                    case 63276:
                      a.doScrollBy(a.view.h);
                      v = !0;
                      break;
                    case 34:
                    case 63277:
                      a.doScrollBy(-a.view.h);
                      v = !0;
                      break;
                    case 36:
                    case 63273:
                      a.railh && e ? a.doScrollPos(0,
                        0) : a.doScrollTo(0);
                      v = !0;
                      break;
                    case 35:
                    case 63275:
                      a.railh && e ? a.doScrollPos(a.page.maxw, a.page.maxh) : a.doScrollTo(a.page.maxh);
                      v = !0;
                      break;
                    case 32:
                      a.opt.spacebarenabled && (m ? a.doScrollBy(a.view.h) : a.doScrollBy(-a.view.h), v = !0);
                      break;
                    case 27:
                      a.zoomactive && (a.doZoom(), v = !0)
                  }
                  if (v) return a.cancelEvent(k)
                }
              };
              if (a.opt.enablekeyboard) a.on(document, h.isopera && !h.isopera12 ? "keypress" : "keydown", a.onkeypress);
              a.on(document, "keydown", function (b) {
                b.ctrlKey && (a.wheelprevented = !0)
              });
              a.on(document, "keyup", function (b) {
                b.ctrlKey ||
                  (a.wheelprevented = !1)
              });
              a.on(window, "blur", function (b) {
                a.wheelprevented = !1
              });
              a.on(window, "resize", a.lazyResize);
              a.on(window, "orientationchange", a.lazyResize);
              a.on(window, "load", a.lazyResize);
              if (h.ischrome && !a.ispage && !a.haswrapper) {
                var E = a.win.attr("style");
                g = parseFloat(a.win.css("width")) + 1;
                a.win.css("width", g);
                a.synched("chromefix", function () {
                  a.win.attr("style", E)
                })
              }
              a.onAttributeChange = function (b) {
                a.lazyResize(a.isieold ? 250 : 30)
              };
              a.isie11 || !1 === I || (a.observerbody = new I(function (c) {
                c.forEach(function (c) {
                  if ("attributes" ==
                    c.type) return b("body").hasClass("modal-open") && b("body").hasClass("modal-dialog") && !b.contains(b(".modal-dialog")[0], a.doc[0]) ? a.hide() : a.show()
                });
                if (document.body.scrollHeight != a.page.maxh) return a.lazyResize(30)
              }), a.observerbody.observe(document.body, {
                childList: !0,
                subtree: !0,
                characterData: !1,
                attributes: !0,
                attributeFilter: ["class"]
              }));
              a.ispage || a.haswrapper || (!1 !== I ? (a.observer = new I(function (b) {
                b.forEach(a.onAttributeChange)
              }), a.observer.observe(a.win[0], {
                childList: !0,
                characterData: !1,
                attributes: !0,
                subtree: !1
              }), a.observerremover = new I(function (b) {
                b.forEach(function (b) {
                  if (0 < b.removedNodes.length)
                    for (var c in b.removedNodes)
                      if (a && b.removedNodes[c] == a.win[0]) return a.remove()
                })
              }), a.observerremover.observe(a.win[0].parentNode, {
                childList: !0,
                characterData: !1,
                attributes: !1,
                subtree: !1
              })) : (a.on(a.win, h.isie && !h.isie9 ? "propertychange" : "DOMAttrModified", a.onAttributeChange), h.isie9 && a.win[0].attachEvent("onpropertychange", a.onAttributeChange), a.on(a.win, "DOMNodeRemoved", function (b) {
                b.target == a.win[0] &&
                  a.remove()
              })));
              if (!a.ispage && a.opt.boxzoom) a.on(window, "resize", a.resizeZoom);
              a.istextarea && (a.on(a.win, "keydown", a.lazyResize), a.on(a.win, "mouseup", a.lazyResize));
              a.lazyResize(30)
            }
            if ("IFRAME" == this.doc[0].nodeName) {
              var r = function () {
                a.iframexd = !1;
                try {
                  var c = "contentDocument" in this ? this.contentDocument : this.contentWindow.document
                } catch (ua) {
                  a.iframexd = !0, c = !1
                }
                if (a.iframexd) return "console" in window && console.log("NiceScroll error: policy restriced iframe"), !0;
                a.forcescreen = !0;
                a.isiframe && (a.iframe = {
                  doc: b(c),
                  html: a.doc.contents().find("html")[0],
                  body: a.doc.contents().find("body")[0]
                }, a.getContentSize = function () {
                  return {
                    w: Math.max(a.iframe.html.scrollWidth, a.iframe.body.scrollWidth),
                    h: Math.max(a.iframe.html.scrollHeight, a.iframe.body.scrollHeight)
                  }
                }, a.docscroll = b(a.iframe.body));
                if (!h.isios && a.opt.iframeautoresize && !a.isiframe) {
                  a.win.scrollTop(0);
                  a.doc.height("");
                  var d = Math.max(c.getElementsByTagName("html")[0].scrollHeight, c.body.scrollHeight);
                  a.doc.height(d)
                }
                a.lazyResize(30);
                h.isie7 && a.css(b(a.iframe.html),
                  k);
                a.css(b(a.iframe.body), k);
                h.isios && a.haswrapper && a.css(b(c.body), {
                  "-webkit-transform": "translate3d(0,0,0)"
                });
                if ("contentWindow" in this) a.on(this.contentWindow, "scroll", a.onscroll);
                else a.on(c, "scroll", a.onscroll);
                a.opt.enablemousewheel && a.mousewheel(c, a.onmousewheel);
                if (a.opt.enablekeyboard) a.on(c, h.isopera ? "keypress" : "keydown", a.onkeypress);
                if (h.cantouch || a.opt.touchbehavior) a.on(c, "mousedown", a.ontouchstart), a.on(c, "mousemove", function (b) {
                    return a.ontouchmove(b, !0)
                  }), a.opt.grabcursorenabled &&
                  h.cursorgrabvalue && a.css(b(c.body), {
                    cursor: h.cursorgrabvalue
                  });
                a.on(c, "mouseup", a.ontouchend);
                if (a.zoom) {
                  if (a.opt.dblclickzoom) a.on(c, "dblclick", a.doZoom);
                  if (a.ongesturezoom) a.on(c, "gestureend", a.ongesturezoom)
                }
              };
              this.doc[0].readyState && "complete" == this.doc[0].readyState && setTimeout(function () {
                r.call(a.doc[0], !1)
              }, 500);
              a.on(this.doc, "load", r)
            }
          };
          this.showCursor = function (b, c) {
            a.cursortimeout && (clearTimeout(a.cursortimeout), a.cursortimeout = 0);
            if (a.rail) {
              a.autohidedom && (a.autohidedom.stop().css({
                  opacity: a.opt.cursoropacitymax
                }),
                a.cursoractive = !0);
              a.rail.drag && 1 == a.rail.drag.pt || (void 0 !== b && !1 !== b && (a.scroll.y = Math.round(1 * b / a.scrollratio.y)), void 0 !== c && (a.scroll.x = Math.round(1 * c / a.scrollratio.x)));
              a.cursor.css({
                height: a.cursorheight,
                top: a.scroll.y
              });
              if (a.cursorh) {
                var k = a.hasreversehr ? a.scrollvaluemaxw - a.scroll.x : a.scroll.x;
                !a.rail.align && a.rail.visibility ? a.cursorh.css({
                  width: a.cursorwidth,
                  left: k + a.rail.width
                }) : a.cursorh.css({
                  width: a.cursorwidth,
                  left: k
                });
                a.cursoractive = !0
              }
              a.zoom && a.zoom.stop().css({
                opacity: a.opt.cursoropacitymax
              })
            }
          };
          this.hideCursor = function (b) {
            a.cursortimeout || !a.rail || !a.autohidedom || a.hasmousefocus && "leave" == a.opt.autohidemode || (a.cursortimeout = setTimeout(function () {
              a.rail.active && a.showonmouseevent || (a.autohidedom.stop().animate({
                opacity: a.opt.cursoropacitymin
              }), a.zoom && a.zoom.stop().animate({
                opacity: a.opt.cursoropacitymin
              }), a.cursoractive = !1);
              a.cursortimeout = 0
            }, b || a.opt.hidecursordelay))
          };
          this.noticeCursor = function (b, c, d) {
            a.showCursor(c, d);
            a.rail.active || a.hideCursor(b)
          };
          this.getContentSize = a.ispage ? function () {
            return {
              w: Math.max(document.body.scrollWidth,
                document.documentElement.scrollWidth),
              h: Math.max(document.body.scrollHeight, document.documentElement.scrollHeight)
            }
          } : a.haswrapper ? function () {
            return {
              w: a.doc.outerWidth() + parseInt(a.win.css("paddingLeft")) + parseInt(a.win.css("paddingRight")),
              h: a.doc.outerHeight() + parseInt(a.win.css("paddingTop")) + parseInt(a.win.css("paddingBottom"))
            }
          } : function () {
            return {
              w: a.docscroll[0].scrollWidth,
              h: a.docscroll[0].scrollHeight
            }
          };
          this.onResize = function (b, c) {
            if (!a || !a.win) return !1;
            if (!a.haswrapper && !a.ispage) {
              if ("none" ==
                a.win.css("display")) return a.visibility && a.hideRail().hideRailHr(), !1;
              a.hidden || a.visibility || a.showRail().showRailHr()
            }
            var k = a.page.maxh,
              d = a.page.maxw,
              e = a.view.h,
              f = a.view.w;
            a.view = {
              w: a.ispage ? a.win.width() : parseInt(a.win[0].clientWidth),
              h: a.ispage ? a.win.height() : parseInt(a.win[0].clientHeight)
            };
            a.page = c ? c : a.getContentSize();
            a.page.maxh = Math.max(0, a.page.h - a.view.h);
            a.page.maxw = Math.max(0, a.page.w - a.view.w);
            if (a.page.maxh == k && a.page.maxw == d && a.view.w == f && a.view.h == e) {
              if (a.ispage) return a;
              k = a.win.offset();
              if (a.lastposition && (d = a.lastposition, d.top == k.top && d.left == k.left)) return a;
              a.lastposition = k
            }
            0 == a.page.maxh ? (a.hideRail(), a.scrollvaluemax = 0, a.scroll.y = 0, a.scrollratio.y = 0, a.cursorheight = 0, a.setScrollTop(0), a.rail && (a.rail.scrollable = !1)) : (a.page.maxh -= a.opt.railpadding.top + a.opt.railpadding.bottom, a.rail.scrollable = !0);
            0 == a.page.maxw ? (a.hideRailHr(), a.scrollvaluemaxw = 0, a.scroll.x = 0, a.scrollratio.x = 0, a.cursorwidth = 0, a.setScrollLeft(0), a.railh && (a.railh.scrollable = !1)) : (a.page.maxw -= a.opt.railpadding.left +
              a.opt.railpadding.right, a.railh && (a.railh.scrollable = a.opt.horizrailenabled));
            a.railslocked = a.locked || 0 == a.page.maxh && 0 == a.page.maxw;
            if (a.railslocked) return a.ispage || a.updateScrollBar(a.view), !1;
            a.hidden || a.visibility ? !a.railh || a.hidden || a.railh.visibility || a.showRailHr() : a.showRail().showRailHr();
            a.istextarea && a.win.css("resize") && "none" != a.win.css("resize") && (a.view.h -= 20);
            a.cursorheight = Math.min(a.view.h, Math.round(a.view.h / a.page.h * a.view.h));
            a.cursorheight = a.opt.cursorfixedheight ? a.opt.cursorfixedheight :
              Math.max(a.opt.cursorminheight, a.cursorheight);
            a.cursorwidth = Math.min(a.view.w, Math.round(a.view.w / a.page.w * a.view.w));
            a.cursorwidth = a.opt.cursorfixedheight ? a.opt.cursorfixedheight : Math.max(a.opt.cursorminheight, a.cursorwidth);
            a.scrollvaluemax = a.view.h - a.cursorheight - a.cursor.hborder - (a.opt.railpadding.top + a.opt.railpadding.bottom);
            a.railh && (a.railh.width = 0 < a.page.maxh ? a.view.w - a.rail.width : a.view.w, a.scrollvaluemaxw = a.railh.width - a.cursorwidth - a.cursorh.wborder - (a.opt.railpadding.left + a.opt.railpadding.right));
            a.ispage || a.updateScrollBar(a.view);
            a.scrollratio = {
              x: a.page.maxw / a.scrollvaluemaxw,
              y: a.page.maxh / a.scrollvaluemax
            };
            a.getScrollTop() > a.page.maxh ? a.doScrollTop(a.page.maxh) : (a.scroll.y = Math.round(a.getScrollTop() * (1 / a.scrollratio.y)), a.scroll.x = Math.round(a.getScrollLeft() * (1 / a.scrollratio.x)), a.cursoractive && a.noticeCursor());
            a.scroll.y && 0 == a.getScrollTop() && a.doScrollTo(Math.floor(a.scroll.y * a.scrollratio.y));
            return a
          };
          this.resize = a.onResize;
          this.hlazyresize = 0;
          this.lazyResize = function (b) {
            a.haswrapper ||
              a.hide();
            a.hlazyresize && clearTimeout(a.hlazyresize);
            a.hlazyresize = setTimeout(function () {
              a && a.show().resize()
            }, 240);
            return a
          };
          this.jqbind = function (c, d, e) {
            a.events.push({
              e: c,
              n: d,
              f: e,
              q: !0
            });
            b(c).on(d, e)
          };
          this.mousewheel = function (b, c, d) {
            b = "jquery" in b ? b[0] : b;
            if ("onwheel" in document.createElement("div")) a._bind(b, "wheel", c, d || !1);
            else {
              var k = void 0 !== document.onmousewheel ? "mousewheel" : "DOMMouseScroll";
              p(b, k, c, d || !1);
              "DOMMouseScroll" == k && p(b, "MozMousePixelScroll", c, d || !1)
            }
          };
          h.haseventlistener ? (this.on = function (b,
            c, d, e) {
            a._bind("jquery" in b ? b[0] : b, c, d, e || !1)
          }, this._bind = function (b, c, d, e) {
            a.events.push({
              e: b,
              n: c,
              f: d,
              b: e,
              q: !1
            });
            b.addEventListener(c, d, e || !1)
          }, this.cancelEvent = function (a) {
            if (!a) return !1;
            a = a.original ? a.original : a;
            a.cancelable && a.preventDefault();
            a.stopPropagation();
            a.preventManipulation && a.preventManipulation();
            return !1
          }, this.stopPropagation = function (a) {
            if (!a) return !1;
            a = a.original ? a.original : a;
            a.stopPropagation();
            return !1
          }, this._unbind = function (a, b, c, d) {
            a.removeEventListener(b, c, d)
          }) : (this.on = function (b,
            c, d, e) {
            var k = "jquery" in b ? b[0] : b;
            a._bind(k, c, function (b) {
              (b = b || window.event || !1) && b.srcElement && (b.target = b.srcElement);
              "pageY" in b || (b.pageX = b.clientX + document.documentElement.scrollLeft, b.pageY = b.clientY + document.documentElement.scrollTop);
              return !1 === d.call(k, b) || !1 === e ? a.cancelEvent(b) : !0
            })
          }, this._bind = function (b, c, d, e) {
            a.events.push({
              e: b,
              n: c,
              f: d,
              b: e,
              q: !1
            });
            b.attachEvent ? b.attachEvent("on" + c, d) : b["on" + c] = d
          }, this.cancelEvent = function (a) {
            a = window.event || !1;
            if (!a) return !1;
            a.cancelBubble = !0;
            a.cancel = !0;
            return a.returnValue = !1
          }, this.stopPropagation = function (a) {
            a = window.event || !1;
            if (!a) return !1;
            a.cancelBubble = !0;
            return !1
          }, this._unbind = function (a, b, c, d) {
            a.detachEvent ? a.detachEvent("on" + b, c) : a["on" + b] = !1
          });
          this.unbindAll = function () {
            for (var b = 0; b < a.events.length; b++) {
              var c = a.events[b];
              c.q ? c.e.unbind(c.n, c.f) : a._unbind(c.e, c.n, c.f, c.b)
            }
          };
          this.showRail = function () {
            0 == a.page.maxh || !a.ispage && "none" == a.win.css("display") || (a.visibility = !0, a.rail.visibility = !0, a.rail.css("display", "block"));
            return a
          };
          this.showRailHr =
            function () {
              if (!a.railh) return a;
              0 == a.page.maxw || !a.ispage && "none" == a.win.css("display") || (a.railh.visibility = !0, a.railh.css("display", "block"));
              return a
            };
          this.hideRail = function () {
            a.visibility = !1;
            a.rail.visibility = !1;
            a.rail.css("display", "none");
            return a
          };
          this.hideRailHr = function () {
            if (!a.railh) return a;
            a.railh.visibility = !1;
            a.railh.css("display", "none");
            return a
          };
          this.show = function () {
            a.hidden = !1;
            a.railslocked = !1;
            return a.showRail().showRailHr()
          };
          this.hide = function () {
            a.hidden = !0;
            a.railslocked = !0;
            return a.hideRail().hideRailHr()
          };
          this.toggle = function () {
            return a.hidden ? a.show() : a.hide()
          };
          this.remove = function () {
            a.stop();
            a.cursortimeout && clearTimeout(a.cursortimeout);
            for (var c in a.delaylist) a.delaylist[c] && r(a.delaylist[c].h);
            a.doZoomOut();
            a.unbindAll();
            h.isie9 && a.win[0].detachEvent("onpropertychange", a.onAttributeChange);
            !1 !== a.observer && a.observer.disconnect();
            !1 !== a.observerremover && a.observerremover.disconnect();
            !1 !== a.observerbody && a.observerbody.disconnect();
            a.events = null;
            a.cursor && a.cursor.remove();
            a.cursorh && a.cursorh.remove();
            a.rail && a.rail.remove();
            a.railh && a.railh.remove();
            a.zoom && a.zoom.remove();
            for (c = 0; c < a.saved.css.length; c++) {
              var d = a.saved.css[c];
              d[0].css(d[1], void 0 === d[2] ? "" : d[2])
            }
            a.saved = !1;
            a.me.data("__nicescroll", "");
            var e = b.nicescroll;
            e.each(function (b) {
              if (this && this.id === a.id) {
                delete e[b];
                for (var c = ++b; c < e.length; c++, b++) e[b] = e[c];
                e.length--;
                e.length && delete e[e.length]
              }
            });
            for (var f in a) a[f] = null, delete a[f];
            a = null
          };
          this.scrollstart = function (b) {
            this.onscrollstart = b;
            return a
          };
          this.scrollend = function (b) {
            this.onscrollend =
              b;
            return a
          };
          this.scrollcancel = function (b) {
            this.onscrollcancel = b;
            return a
          };
          this.zoomin = function (b) {
            this.onzoomin = b;
            return a
          };
          this.zoomout = function (b) {
            this.onzoomout = b;
            return a
          };
          this.isScrollable = function (a) {
            a = a.target ? a.target : a;
            if ("OPTION" == a.nodeName) return !0;
            for (; a && 1 == a.nodeType && !/^BODY|HTML/.test(a.nodeName);) {
              var c = b(a);
              c = c.css("overflowY") || c.css("overflowX") || c.css("overflow") || "";
              if (/scroll|auto/.test(c)) return a.clientHeight != a.scrollHeight;
              a = a.parentNode ? a.parentNode : !1
            }
            return !1
          };
          this.getViewport =
            function (a) {
              for (a = a && a.parentNode ? a.parentNode : !1; a && 1 == a.nodeType && !/^BODY|HTML/.test(a.nodeName);) {
                var c = b(a);
                if (/fixed|absolute/.test(c.css("position"))) return c;
                var d = c.css("overflowY") || c.css("overflowX") || c.css("overflow") || "";
                if (/scroll|auto/.test(d) && a.clientHeight != a.scrollHeight || 0 < c.getNiceScroll().length) return c;
                a = a.parentNode ? a.parentNode : !1
              }
              return !1
            };
          this.triggerScrollEnd = function () {
            if (a.onscrollend) {
              var b = a.getScrollLeft(),
                c = a.getScrollTop();
              a.onscrollend.call(a, {
                type: "scrollend",
                current: {
                  x: b,
                  y: c
                },
                end: {
                  x: b,
                  y: c
                }
              })
            }
          };
          this.onmousewheel = function (b) {
            if (!a.wheelprevented) {
              if (a.railslocked) return a.debounced("checkunlock", a.resize, 250), !0;
              if (a.rail.drag) return a.cancelEvent(b);
              "auto" == a.opt.oneaxismousemode && 0 != b.deltaX && (a.opt.oneaxismousemode = !1);
              if (a.opt.oneaxismousemode && 0 == b.deltaX && !a.rail.scrollable) return a.railh && a.railh.scrollable ? a.onmousewheelhr(b) : !0;
              var c = +new Date,
                d = !1;
              a.opt.preservenativescrolling && a.checkarea + 600 < c && (a.nativescrollingarea = a.isScrollable(b), d = !0);
              a.checkarea = c;
              if (a.nativescrollingarea) return !0;
              if (b = R(b, !1, d)) a.checkarea = 0;
              return b
            }
          };
          this.onmousewheelhr = function (b) {
            if (!a.wheelprevented) {
              if (a.railslocked || !a.railh.scrollable) return !0;
              if (a.rail.drag) return a.cancelEvent(b);
              var c = +new Date,
                d = !1;
              a.opt.preservenativescrolling && a.checkarea + 600 < c && (a.nativescrollingarea = a.isScrollable(b), d = !0);
              a.checkarea = c;
              return a.nativescrollingarea ? !0 : a.railslocked ? a.cancelEvent(b) : R(b, !0, d)
            }
          };
          this.stop = function () {
            a.cancelScroll();
            a.scrollmon && a.scrollmon.stop();
            a.cursorfreezed = !1;
            a.scroll.y = Math.round(a.getScrollTop() * (1 / a.scrollratio.y));
            a.noticeCursor();
            return a
          };
          this.getTransitionSpeed = function (b) {
            b = Math.min(Math.round(10 * a.opt.scrollspeed), Math.round(b / 20 * a.opt.scrollspeed));
            return 20 < b ? b : 0
          };
          a.opt.smoothscroll ? a.ishwscroll && h.hastransition && a.opt.usetransition && a.opt.smoothscroll ? (this.prepareTransition = function (b, c) {
            var d = c ? 20 < b ? b : 0 : a.getTransitionSpeed(b),
              e = d ? h.prefixstyle + "transform " + d + "ms ease-out" : "";
            a.lasttransitionstyle && a.lasttransitionstyle ==
              e || (a.lasttransitionstyle = e, a.doc.css(h.transitionstyle, e));
            return d
          }, this.doScrollLeft = function (b, c) {
            var d = a.scrollrunning ? a.newscrolly : a.getScrollTop();
            a.doScrollPos(b, d, c)
          }, this.doScrollTop = function (b, c) {
            var d = a.scrollrunning ? a.newscrollx : a.getScrollLeft();
            a.doScrollPos(d, b, c)
          }, this.doScrollPos = function (b, c, d) {
            var e = a.getScrollTop(),
              f = a.getScrollLeft();
            (0 > (a.newscrolly - e) * (c - e) || 0 > (a.newscrollx - f) * (b - f)) && a.cancelScroll();
            0 == a.opt.bouncescroll && (0 > c ? c = 0 : c > a.page.maxh && (c = a.page.maxh), 0 > b ? b = 0 : b >
              a.page.maxw && (b = a.page.maxw));
            if (a.scrollrunning && b == a.newscrollx && c == a.newscrolly) return !1;
            a.newscrolly = c;
            a.newscrollx = b;
            a.newscrollspeed = d || !1;
            if (a.timer) return !1;
            a.timer = setTimeout(function () {
              var d = a.getScrollTop(),
                e = a.getScrollLeft(),
                f = Math.round(Math.sqrt(Math.pow(b - e, 2) + Math.pow(c - d, 2)));
              f = a.newscrollspeed && 1 < a.newscrollspeed ? a.newscrollspeed : a.getTransitionSpeed(f);
              a.newscrollspeed && 1 >= a.newscrollspeed && (f *= a.newscrollspeed);
              a.prepareTransition(f, !0);
              a.timerscroll && a.timerscroll.tm && clearInterval(a.timerscroll.tm);
              0 < f && (!a.scrollrunning && a.onscrollstart && a.onscrollstart.call(a, {
                type: "scrollstart",
                current: {
                  x: e,
                  y: d
                },
                request: {
                  x: b,
                  y: c
                },
                end: {
                  x: a.newscrollx,
                  y: a.newscrolly
                },
                speed: f
              }), h.transitionend ? a.scrollendtrapped || (a.scrollendtrapped = !0, a.on(a.doc, h.transitionend, a.onScrollTransitionEnd, !1)) : (a.scrollendtrapped && clearTimeout(a.scrollendtrapped), a.scrollendtrapped = setTimeout(a.onScrollTransitionEnd, f)), a.timerscroll = {
                bz: new x(d, a.newscrolly, f, 0, 0, .58, 1),
                bh: new x(e, a.newscrollx, f, 0, 0, .58, 1)
              }, a.cursorfreezed || (a.timerscroll.tm =
                setInterval(function () {
                  a.showCursor(a.getScrollTop(), a.getScrollLeft())
                }, 60)));
              a.synched("doScroll-set", function () {
                a.timer = 0;
                a.scrollendtrapped && (a.scrollrunning = !0);
                a.setScrollTop(a.newscrolly);
                a.setScrollLeft(a.newscrollx);
                if (!a.scrollendtrapped) a.onScrollTransitionEnd()
              })
            }, 50)
          }, this.cancelScroll = function () {
            if (!a.scrollendtrapped) return !0;
            var b = a.getScrollTop(),
              c = a.getScrollLeft();
            a.scrollrunning = !1;
            h.transitionend || clearTimeout(h.transitionend);
            a.scrollendtrapped = !1;
            a._unbind(a.doc[0], h.transitionend,
              a.onScrollTransitionEnd);
            a.prepareTransition(0);
            a.setScrollTop(b);
            a.railh && a.setScrollLeft(c);
            a.timerscroll && a.timerscroll.tm && clearInterval(a.timerscroll.tm);
            a.timerscroll = !1;
            a.cursorfreezed = !1;
            a.showCursor(b, c);
            return a
          }, this.onScrollTransitionEnd = function () {
            a.scrollendtrapped && a._unbind(a.doc[0], h.transitionend, a.onScrollTransitionEnd);
            a.scrollendtrapped = !1;
            a.prepareTransition(0);
            a.timerscroll && a.timerscroll.tm && clearInterval(a.timerscroll.tm);
            a.timerscroll = !1;
            var b = a.getScrollTop(),
              c = a.getScrollLeft();
            a.setScrollTop(b);
            a.railh && a.setScrollLeft(c);
            a.noticeCursor(!1, b, c);
            a.cursorfreezed = !1;
            0 > b ? b = 0 : b > a.page.maxh && (b = a.page.maxh);
            0 > c ? c = 0 : c > a.page.maxw && (c = a.page.maxw);
            if (b != a.newscrolly || c != a.newscrollx) return a.doScrollPos(c, b, a.opt.snapbackspeed);
            a.onscrollend && a.scrollrunning && a.triggerScrollEnd();
            a.scrollrunning = !1
          }) : (this.doScrollLeft = function (b, c) {
            var d = a.scrollrunning ? a.newscrolly : a.getScrollTop();
            a.doScrollPos(b, d, c)
          }, this.doScrollTop = function (b, c) {
            var d = a.scrollrunning ? a.newscrollx : a.getScrollLeft();
            a.doScrollPos(d, b, c)
          }, this.doScrollPos = function (b, c, d) {
            function e() {
              if (a.cancelAnimationFrame) return !0;
              a.scrollrunning = !0;
              if (l = 1 - l) return a.timer = n(e) || 1;
              var b = 0,
                c, d = c = a.getScrollTop();
              if (a.dst.ay) {
                d = a.bzscroll ? a.dst.py + a.bzscroll.getNow() * a.dst.ay : a.newscrolly;
                var f = d - c;
                if (0 > f && d < a.newscrolly || 0 < f && d > a.newscrolly) d = a.newscrolly;
                a.setScrollTop(d);
                d == a.newscrolly && (b = 1)
              } else b = 1;
              c = f = a.getScrollLeft();
              if (a.dst.ax) {
                c = a.bzscroll ? a.dst.px + a.bzscroll.getNow() * a.dst.ax : a.newscrollx;
                f = c - f;
                if (0 > f && c < a.newscrollx ||
                  0 < f && c > a.newscrollx) c = a.newscrollx;
                a.setScrollLeft(c);
                c == a.newscrollx && (b += 1)
              } else b += 1;
              2 == b ? (a.timer = 0, a.cursorfreezed = !1, a.bzscroll = !1, a.scrollrunning = !1, 0 > d ? d = 0 : d > a.page.maxh && (d = Math.max(0, a.page.maxh)), 0 > c ? c = 0 : c > a.page.maxw && (c = a.page.maxw), c != a.newscrollx || d != a.newscrolly ? a.doScrollPos(c, d) : a.onscrollend && a.triggerScrollEnd()) : a.timer = n(e) || 1
            }
            c = void 0 === c || !1 === c ? a.getScrollTop(!0) : c;
            if (a.timer && a.newscrolly == c && a.newscrollx == b) return !0;
            a.timer && r(a.timer);
            a.timer = 0;
            var f = a.getScrollTop(),
              m =
              a.getScrollLeft();
            (0 > (a.newscrolly - f) * (c - f) || 0 > (a.newscrollx - m) * (b - m)) && a.cancelScroll();
            a.newscrolly = c;
            a.newscrollx = b;
            a.bouncescroll && a.rail.visibility || (0 > a.newscrolly ? a.newscrolly = 0 : a.newscrolly > a.page.maxh && (a.newscrolly = a.page.maxh));
            a.bouncescroll && a.railh.visibility || (0 > a.newscrollx ? a.newscrollx = 0 : a.newscrollx > a.page.maxw && (a.newscrollx = a.page.maxw));
            a.dst = {};
            a.dst.x = b - m;
            a.dst.y = c - f;
            a.dst.px = m;
            a.dst.py = f;
            var g = Math.round(Math.sqrt(Math.pow(a.dst.x, 2) + Math.pow(a.dst.y, 2)));
            a.dst.ax = a.dst.x /
              g;
            a.dst.ay = a.dst.y / g;
            var k = 0,
              h = g;
            0 == a.dst.x ? (k = f, h = c, a.dst.ay = 1, a.dst.py = 0) : 0 == a.dst.y && (k = m, h = b, a.dst.ax = 1, a.dst.px = 0);
            g = a.getTransitionSpeed(g);
            d && 1 >= d && (g *= d);
            a.bzscroll = 0 < g ? a.bzscroll ? a.bzscroll.update(h, g) : new x(k, h, g, 0, 1, 0, 1) : !1;
            if (!a.timer) {
              (f == a.page.maxh && c >= a.page.maxh || m == a.page.maxw && b >= a.page.maxw) && a.checkContentSize();
              var l = 1;
              a.cancelAnimationFrame = !1;
              a.timer = 1;
              a.onscrollstart && !a.scrollrunning && a.onscrollstart.call(a, {
                type: "scrollstart",
                current: {
                  x: m,
                  y: f
                },
                request: {
                  x: b,
                  y: c
                },
                end: {
                  x: a.newscrollx,
                  y: a.newscrolly
                },
                speed: g
              });
              e();
              (f == a.page.maxh && c >= f || m == a.page.maxw && b >= m) && a.checkContentSize();
              a.noticeCursor()
            }
          }, this.cancelScroll = function () {
            a.timer && r(a.timer);
            a.timer = 0;
            a.bzscroll = !1;
            a.scrollrunning = !1;
            return a
          }) : (this.doScrollLeft = function (b, c) {
            var d = a.getScrollTop();
            a.doScrollPos(b, d, c)
          }, this.doScrollTop = function (b, c) {
            var d = a.getScrollLeft();
            a.doScrollPos(d, b, c)
          }, this.doScrollPos = function (b, c, d) {
            var e = b > a.page.maxw ? a.page.maxw : b;
            0 > e && (e = 0);
            var f = c > a.page.maxh ? a.page.maxh : c;
            0 > f && (f = 0);
            a.synched("scroll",
              function () {
                a.setScrollTop(f);
                a.setScrollLeft(e)
              })
          }, this.cancelScroll = function () {});
          this.doScrollBy = function (b, c) {
            var d = c ? Math.floor((a.scroll.y - b) * a.scrollratio.y) : (a.timer ? a.newscrolly : a.getScrollTop(!0)) - b;
            if (a.bouncescroll) {
              var e = Math.round(a.view.h / 2);
              d < -e ? d = -e : d > a.page.maxh + e && (d = a.page.maxh + e)
            }
            a.cursorfreezed = !1;
            e = a.getScrollTop(!0);
            if (0 > d && 0 >= e) return a.noticeCursor();
            if (d > a.page.maxh && e >= a.page.maxh) return a.checkContentSize(), a.noticeCursor();
            a.doScrollTop(d)
          };
          this.doScrollLeftBy = function (b,
            c) {
            var d = c ? Math.floor((a.scroll.x - b) * a.scrollratio.x) : (a.timer ? a.newscrollx : a.getScrollLeft(!0)) - b;
            if (a.bouncescroll) {
              var e = Math.round(a.view.w / 2);
              d < -e ? d = -e : d > a.page.maxw + e && (d = a.page.maxw + e)
            }
            a.cursorfreezed = !1;
            e = a.getScrollLeft(!0);
            if (0 > d && 0 >= e || d > a.page.maxw && e >= a.page.maxw) return a.noticeCursor();
            a.doScrollLeft(d)
          };
          this.doScrollTo = function (b, c) {
            a.cursorfreezed = !1;
            a.doScrollTop(b)
          };
          this.checkContentSize = function () {
            var b = a.getContentSize();
            b.h == a.page.h && b.w == a.page.w || a.resize(!1, b)
          };
          a.onscroll =
            function (b) {
              a.rail.drag || a.cursorfreezed || a.synched("scroll", function () {
                a.scroll.y = Math.round(a.getScrollTop() * (1 / a.scrollratio.y));
                a.railh && (a.scroll.x = Math.round(a.getScrollLeft() * (1 / a.scrollratio.x)));
                a.noticeCursor()
              })
            };
          a.on(a.docscroll, "scroll", a.onscroll);
          this.doZoomIn = function (c) {
            if (!a.zoomactive) {
              a.zoomactive = !0;
              a.zoomrestore = {
                style: {}
              };
              var d = "position top left zIndex backgroundColor marginTop marginBottom marginLeft marginRight".split(" "),
                e = a.win[0].style,
                f;
              for (f in d) {
                var m = d[f];
                a.zoomrestore.style[m] =
                  void 0 !== e[m] ? e[m] : ""
              }
              a.zoomrestore.style.width = a.win.css("width");
              a.zoomrestore.style.height = a.win.css("height");
              a.zoomrestore.padding = {
                w: a.win.outerWidth() - a.win.width(),
                h: a.win.outerHeight() - a.win.height()
              };
              h.isios4 && (a.zoomrestore.scrollTop = b(window).scrollTop(), b(window).scrollTop(0));
              a.win.css({
                position: h.isios4 ? "absolute" : "fixed",
                top: 0,
                left: 0,
                zIndex: l + 100,
                margin: 0
              });
              d = a.win.css("backgroundColor");
              ("" == d || /transparent|rgba\(0, 0, 0, 0\)|rgba\(0,0,0,0\)/.test(d)) && a.win.css("backgroundColor",
                "#fff");
              a.rail.css({
                zIndex: l + 101
              });
              a.zoom.css({
                zIndex: l + 102
              });
              a.zoom.css("backgroundPosition", "0px -18px");
              a.resizeZoom();
              a.onzoomin && a.onzoomin.call(a);
              return a.cancelEvent(c)
            }
          };
          this.doZoomOut = function (c) {
            if (a.zoomactive) return a.zoomactive = !1, a.win.css("margin", ""), a.win.css(a.zoomrestore.style), h.isios4 && b(window).scrollTop(a.zoomrestore.scrollTop), a.rail.css({
                "z-index": a.zindex
              }), a.zoom.css({
                "z-index": a.zindex
              }), a.zoomrestore = !1, a.zoom.css("backgroundPosition", "0px 0px"), a.onResize(), a.onzoomout &&
              a.onzoomout.call(a), a.cancelEvent(c)
          };
          this.doZoom = function (b) {
            return a.zoomactive ? a.doZoomOut(b) : a.doZoomIn(b)
          };
          this.resizeZoom = function () {
            if (a.zoomactive) {
              var c = a.getScrollTop();
              a.win.css({
                width: b(window).width() - a.zoomrestore.padding.w + "px",
                height: b(window).height() - a.zoomrestore.padding.h + "px"
              });
              a.onResize();
              a.setScrollTop(Math.min(a.page.maxh, c))
            }
          };
          this.init();
          b.nicescroll.push(this)
        },
        B = function (b) {
          var c = this;
          this.nc = b;
          this.steptime = this.lasttime = this.speedy = this.speedx = this.lasty = this.lastx =
            0;
          this.snapy = this.snapx = !1;
          this.demuly = this.demulx = 0;
          this.lastscrolly = this.lastscrollx = -1;
          this.timer = this.chky = this.chkx = 0;
          this.time = function () {
            return +new Date
          };
          this.reset = function (b, d) {
            c.stop();
            var e = c.time();
            c.steptime = 0;
            c.lasttime = e;
            c.speedx = 0;
            c.speedy = 0;
            c.lastx = b;
            c.lasty = d;
            c.lastscrollx = -1;
            c.lastscrolly = -1
          };
          this.update = function (b, d) {
            var e = c.time();
            c.steptime = e - c.lasttime;
            c.lasttime = e;
            e = d - c.lasty;
            var f = b - c.lastx,
              g = c.nc.getScrollTop(),
              a = c.nc.getScrollLeft();
            g += e;
            a += f;
            c.snapx = 0 > a || a > c.nc.page.maxw;
            c.snapy = 0 > g || g > c.nc.page.maxh;
            c.speedx = f;
            c.speedy = e;
            c.lastx = b;
            c.lasty = d
          };
          this.stop = function () {
            c.nc.unsynched("domomentum2d");
            c.timer && clearTimeout(c.timer);
            c.timer = 0;
            c.lastscrollx = -1;
            c.lastscrolly = -1
          };
          this.doSnapy = function (b, d) {
            var e = !1;
            0 > d ? (d = 0, e = !0) : d > c.nc.page.maxh && (d = c.nc.page.maxh, e = !0);
            0 > b ? (b = 0, e = !0) : b > c.nc.page.maxw && (b = c.nc.page.maxw, e = !0);
            e ? c.nc.doScrollPos(b, d, c.nc.opt.snapbackspeed) : c.nc.triggerScrollEnd()
          };
          this.doMomentum = function (b) {
            var d = c.time(),
              e = b ? d + b : c.lasttime;
            b = c.nc.getScrollLeft();
            var f = c.nc.getScrollTop(),
              g = c.nc.page.maxh,
              a = c.nc.page.maxw;
            c.speedx = 0 < a ? Math.min(60, c.speedx) : 0;
            c.speedy = 0 < g ? Math.min(60, c.speedy) : 0;
            e = e && 60 >= d - e;
            if (0 > f || f > g || 0 > b || b > a) e = !1;
            b = c.speedx && e ? c.speedx : !1;
            if (c.speedy && e && c.speedy || b) {
              var m = Math.max(16, c.steptime);
              50 < m && (b = m / 50, c.speedx *= b, c.speedy *= b, m = 50);
              c.demulxy = 0;
              c.lastscrollx = c.nc.getScrollLeft();
              c.chkx = c.lastscrollx;
              c.lastscrolly = c.nc.getScrollTop();
              c.chky = c.lastscrolly;
              var l = c.lastscrollx,
                h = c.lastscrolly,
                q = function () {
                  var b = 600 < c.time() - d ? .04 : .02;
                  c.speedx && (l = Math.floor(c.lastscrollx - c.speedx * (1 - c.demulxy)), c.lastscrollx = l, 0 > l || l > a) && (b = .1);
                  c.speedy && (h = Math.floor(c.lastscrolly - c.speedy * (1 - c.demulxy)), c.lastscrolly = h, 0 > h || h > g) && (b = .1);
                  c.demulxy = Math.min(1, c.demulxy + b);
                  c.nc.synched("domomentum2d", function () {
                    c.speedx && (c.nc.getScrollLeft(), c.chkx = l, c.nc.setScrollLeft(l));
                    c.speedy && (c.nc.getScrollTop(), c.chky = h, c.nc.setScrollTop(h));
                    c.timer || (c.nc.hideCursor(), c.doSnapy(l, h))
                  });
                  1 > c.demulxy ? c.timer = setTimeout(q, m) : (c.stop(), c.nc.hideCursor(),
                    c.doSnapy(l, h))
                };
              q()
            } else c.doSnapy(c.nc.getScrollLeft(), c.nc.getScrollTop())
          }
        },
        w = b.fn.scrollTop;
      b.cssHooks.pageYOffset = {
        get: function (c, d, e) {
          return (d = b.data(c, "__nicescroll") || !1) && d.ishwscroll ? d.getScrollTop() : w.call(c)
        },
        set: function (c, d) {
          var e = b.data(c, "__nicescroll") || !1;
          e && e.ishwscroll ? e.setScrollTop(parseInt(d)) : w.call(c, d);
          return this
        }
      };
      b.fn.scrollTop = function (c) {
        if (void 0 === c) {
          var d = this[0] ? b.data(this[0], "__nicescroll") || !1 : !1;
          return d && d.ishwscroll ? d.getScrollTop() : w.call(this)
        }
        return this.each(function () {
          var d =
            b.data(this, "__nicescroll") || !1;
          d && d.ishwscroll ? d.setScrollTop(parseInt(c)) : w.call(b(this), c)
        })
      };
      var A = b.fn.scrollLeft;
      b.cssHooks.pageXOffset = {
        get: function (c, d, e) {
          return (d = b.data(c, "__nicescroll") || !1) && d.ishwscroll ? d.getScrollLeft() : A.call(c)
        },
        set: function (c, d) {
          var e = b.data(c, "__nicescroll") || !1;
          e && e.ishwscroll ? e.setScrollLeft(parseInt(d)) : A.call(c, d);
          return this
        }
      };
      b.fn.scrollLeft = function (c) {
        if (void 0 === c) {
          var d = this[0] ? b.data(this[0], "__nicescroll") || !1 : !1;
          return d && d.ishwscroll ? d.getScrollLeft() :
            A.call(this)
        }
        return this.each(function () {
          var d = b.data(this, "__nicescroll") || !1;
          d && d.ishwscroll ? d.setScrollLeft(parseInt(c)) : A.call(b(this), c)
        })
      };
      var F = function (c) {
        var d = this;
        this.length = 0;
        this.name = "nicescrollarray";
        this.each = function (c) {
          b.each(d, c);
          return d
        };
        this.push = function (b) {
          d[d.length] = b;
          d.length++
        };
        this.eq = function (b) {
          return d[b]
        };
        if (c)
          for (var e = 0; e < c.length; e++) {
            var f = b.data(c[e], "__nicescroll") || !1;
            f && (this[this.length] = f, this.length++)
          }
        return this
      };
      (function (b, c, d) {
        for (var e = 0; e < c.length; e++) d(b,
          c[e])
      })(F.prototype, "show hide toggle onResize resize remove stop doScrollPos".split(" "), function (b, c) {
        b[c] = function () {
          var b = arguments;
          return this.each(function () {
            this[c].apply(this, b)
          })
        }
      });
      b.fn.getNiceScroll = function (c) {
        return void 0 === c ? new F(this) : this[c] && b.data(this[c], "__nicescroll") || !1
      };
      b.expr[":"].nicescroll = function (c) {
        return void 0 !== b.data(c, "__nicescroll")
      };
      b.fn.niceScroll = function (c, d) {
        void 0 !== d || "object" != typeof c || "jquery" in c || (d = c, c = !1);
        d = b.extend({}, d);
        var e = new F;
        void 0 === d &&
          (d = {});
        c && (d.doc = b(c), d.win = b(this));
        var f = !("doc" in d);
        f || "win" in d || (d.win = b(this));
        this.each(function () {
          var c = b(this).data("__nicescroll") || !1;
          c || (d.doc = f ? b(this) : d.doc, c = new D(d, b(this)), b(this).data("__nicescroll", c));
          e.push(c)
        });
        return 1 == e.length ? e[0] : e
      };
      window.NiceScroll = {
        getjQuery: function () {
          return b
        }
      };
      b.nicescroll || (b.nicescroll = new F, b.nicescroll.options = C)
    });
    "he" == p ? (w = "\x3c!--\n", w += "/* * * * * * * * * * * * * * * * * * * *\n* \u05e0\u05d2\u05d9\u05e9 \u05dc\u05d9 - \u05ea\u05d5\u05e1\u05e3 \u05e0\u05d2\u05d9\u05e9\u05d5\u05ea \u05d1\u05d7\u05d9\u05e0\u05dd\n* \u05e4\u05d5\u05ea\u05d7 \u05e2\u05dc \u05d9\u05d3\u05d9 \u05dc\u05d5\u05e7\u05dc\u05d9\u05d9\u05d6* (c) 2016-2017\n* http://www.nagish.li\n* * * * * * * * * * * * * * * * * * * */\n") :
      (w = "\x3c!--\n", w += "/* * * * * * * * * * * * * * * * * * * *\n* NagishLi - Free accessibility plugin\n* Developed by Localize* (c) 2016-2017\n* http://www.nagish.li\n* * * * * * * * * * * * * * * * * * * */\n");
    w += "--\x3e";
    f = '<nagishli id="NagishLiTag" lang="' + p + '">';
    f += '<div id="NagishLiBar">';
    f += '<div id="NagishLiBarStrip" tabindex="1">';
    f = A ? f + ('<img id="NagishLiLogo" src="' + icons.logo + '" alt="' + phrases.logo_alt + '" style="vertical-align: ' + ("he" == p ? "middle" : "top") + ' !important;"><span id="NagishLiTitle" style="margin-' +
      phrases.align_right + ': 5px !important;">' + phrases.a11y_title + "</span>") : f + ('<img id="NagishLiLogo" src="' + icons.logo + '" alt="' + phrases.logo_alt + '" style="vertical-align: ' + ("he" == p ? "middle" : "top") + ' !important;"><span id="NagishLiTitle" style="margin-' + phrases.align_right + ': 5px !important;">' + phrases.a11y_title + '</span><span id="NagishLiToggleMenus" class="expand-all" tabindex="6"><img src="' + icons.toggle_all + '" alt="' + phrases.expand_all + '" /></span>');
    f += '<span id="NagishLiMove" style="height: 21px !important; width: 21px !important; vertical-align: middle !important; float: ' +
      phrases.align_left + " !important; margin-" + phrases.align_right + ': 10px !important;">';
    f = "he" == p ? f + ('<span id="NagishLiMoveTL" alt="' + phrases.move_tl + '" title="' + phrases.move_tl + '" style="background-image: url(\'' + icons.TL_pos + '\');" tabindex="3"></span><span id="NagishLiMoveTR" alt="' + phrases.move_tr + '" title="' + phrases.move_tr + '" style="background-image: url(\'' + icons.TR_pos + '\');" tabindex="2"></span><span id="NagishLiMoveBL" alt="' + phrases.move_bl + '" title="' + phrases.move_bl + '" style="background-image: url(\'' +
      icons.BL_pos + '\');" tabindex="5"></span><span id="NagishLiMoveBR" alt="' + phrases.move_br + '" title="' + phrases.move_br + '" style="background-image: url(\'' + icons.BR_pos + '\');" tabindex="4"></span>') : f + ('<span id="NagishLiMoveTR" alt="' + phrases.move_tr + '" title="' + phrases.move_tr + '" style="background-image: url(\'' + icons.TR_pos + '\');" tabindex="3"></span><span id="NagishLiMoveTL" alt="' + phrases.move_tl + '" title="' + phrases.move_tl + '" style="background-image: url(\'' + icons.TL_pos + '\');" tabindex="2"></span><span id="NagishLiMoveBR" alt="' +
      phrases.move_br + '" title="' + phrases.move_br + '" style="background-image: url(\'' + icons.BR_pos + '\');" tabindex="5"></span><span id="NagishLiMoveBL" alt="' + phrases.move_bl + '" title="' + phrases.move_bl + '" style="background-image: url(\'' + icons.BL_pos + '\');" tabindex="4"></span></span>');
    f += "</span>";
    f += "</div>";
    f += '<ul id="NagishLiMenus" class="' + X + '">';
    f += '<li class="dropdown">';
    f += '<div class="dropdown-toggle" tabindex="10"><span class="dropdown-title">' + phrases.settings + '</span><span class="dropdown-arrow"></span></div>';
    f += '<ul id="NagishLiInfo" class="dropdown-menu">';
    f += '<li><div id="NagishLiStatement" tabindex="11"><span class="help" data-balloon="' + phrases.a11y_info_exp + '" tabindex="11">&#x2753;&#xfe0e;&nbsp;</span>' + phrases.a11y_info + "</div></li>";
    f += '<li><div id="NagishLiHowAccessible" tabindex="12"><span class="help" data-balloon="' + phrases.how_accessible_exp + '" tabindex="12">&#x2753;&#xfe0e;&nbsp;</span>' + phrases.how_accessible + "</span></div></li>";
    f += '<li class="not-clickable"><div tabindex="13" data-balloon-length="large" data-balloon="' +
      phrases.supported_browsers_exp + '" data-balloon-pos="up"><span id="NagishLiSupportedBrowsers">' + phrases.supported_browsers + ':<img src="' + icons.chrome + '" alt="' + phrases.chrome + '" title="' + phrases.chrome + '" /><img src="' + icons.edge + '" alt="' + phrases.edge + '" title="' + phrases.edge + '" /><img src="' + icons.firefox + '" alt="' + phrases.firefox + '" title="' + phrases.firefox + '" /><img src="' + icons.opera + '" alt="' + phrases.opera + '" title="' + phrases.opera + '" /><img src="' + icons.explorer + '" alt="' + phrases.explorer + '" title="' +
      phrases.explorer + '" /></span></div></li>';
    f += '<li id="NagishLiHelp">';
    f += '<div id="NLToggleHelp" tabindex="14">';
    f += '<span data-balloon="' + phrases.help_exp + '" data-balloon-pos="' + phrases.align_left + '">' + phrases.help + "</span>";
    f += "</div>";
    f += "</li>";
    B && (f += "<li>", f += '<div id="NLResetSettings" tabindex="15"><span class="help" data-balloon="' + phrases.reset_settings_exp + '" tabindex="15">&#x2753;&#xfe0e;&nbsp;</span>' + phrases.reset_settings + "</div>", f += "</li>");
    if ("0" == M || "" != N && Y != qa) f += '<li id="NagishLiDeveloper" class="not-clickable">',
      f += "<div>", f += '<a href="http://www.localize.co.il" target="_blank" id="NLDevelopedBy" title="' + phrases.developed_by_exp + '" tabindex="16">' + phrases.developed_by + '<sup style="font-size: 65% !important;">&#x2731;</sup></a>', f += '<a href="' + phrases.developed_in_link + '" target="_blank" id="NLDevelopedIn" data-balloon="' + phrases.developed_in + '" data-balloon-pos="' + phrases.align_right + '" tabindex="16"><img src="' + icons.sod + '" /></a>', f += "</div>", f += "</li>";
    f += "</ul>";
    f += "</li>";
    f += '<li class="dropdown">';
    f += '<div class="dropdown-toggle" tabindex="20"><span class="dropdown-title">' + phrases.text_size + '</span><span id="NLTextVal"></span><span class="dropdown-arrow"></span></div>';
    f += '<ul id="NagishLiText" class="dropdown-menu">';
    f += "<li>";
    f += '<div id="NLBiggerText" tabindex="21"><span class="help" data-balloon="' + phrases.larger_text_exp + '" tabindex="21">&#x2753;&#xfe0e;&nbsp;</span>' + phrases.larger_text + "</div>";
    f += "</li>";
    f += "<li>";
    f += '<div id="NLSmallerText" tabindex="22"><span class="help" data-balloon="' +
      phrases.smaller_text_exp + '" tabindex="22">&#x2753;&#xfe0e;&nbsp;</span>' + phrases.smaller_text + "</div>";
    f += "</li>";
    f += "<li>";
    f += '<div id="NLNormalText" tabindex="23">' + commons.checkmark + phrases.normal + "</div>";
    f += "</li>";
    f += "</ul>";
    f += "</li>";
    f += '<li class="dropdown">';
    f += '<div class="dropdown-toggle" tabindex="30"><span class="dropdown-title">' + phrases.colors + '</span><span class="dropdown-arrow"></span></div>';
    f += '<ul id="NagishLiColors" class="dropdown-menu">';
    sa || (f += "<li>", f += '<div id="NLGrayscaleColors" tabindex="31"><span class="help" data-balloon="' +
      phrases.blind_exp + '" tabindex="31">&#x2753;&#xfe0e;&nbsp;</span><span class="option-title">' + phrases.blind + "</span></div>", f += "</li>", f += "<li>", f += '<div id="NLInvertColors" tabindex="32"><span class="help" data-balloon="' + phrases.impaired_exp + '" tabindex="32">&#x2753;&#xfe0e;&nbsp;</span><span class="option-title">' + phrases.impaired + "</span></div>", f += "</li>", f += "<li>", f += '<div id="NLWarmColors" tabindex="33"><span class="help" data-balloon="' + phrases.bl_filter_exp + '" tabindex="33">&#x2753;&#xfe0e;&nbsp;</span><span class="notice" data-balloon="' +
      phrases.experimental_feat + '" tabindex="33">&#x26a0;&#xfe0e;&nbsp;</span><span class="option-title">' + phrases.bl_filter + "</span></div>", f += "</li>", f += "<li>", f += '<div id="NLColdColors" tabindex="34"><span class="help" data-balloon="' + phrases.lc_filter_exp + '" tabindex="34">&#x2753;&#xfe0e;&nbsp;</span><span class="notice" data-balloon="' + phrases.experimental_feat + '" tabindex="34">&#x26a0;&#xfe0e;&nbsp;</span><span class="option-title">' + phrases.lc_filter + "</span></div>", f += "</li>");
    if (null != b("body").css("background-color") ||
      null != b("body").css("color")) f += '<li class="not-clickable">', f += '<div id="NLCustomColors"><span class="help" data-balloon="' + phrases.custom_colors_exp + '" tabindex="35">&#x2753;&#xfe0e;&nbsp;</span><span class="notice" data-balloon="' + phrases.experimental_feat + '" tabindex="35">&#x26a0;&#xfe0e;&nbsp;</span><span class="option-title">' + phrases.custom_colors + "</span>:&nbsp;" + (null != b("body").css("background-color") && "rgba(0, 0, 0, 0)" != b("body").css("background-color") ? '<span id="NLCustomColorsBG" tabindex="35"><span id="NLCurrentBG" style="display: none;"></span>' +
      phrases.bg + "</span>&nbsp;" : "") + (null != b("body").css("color") && "rgba(0, 0, 0, 0)" != b("body").css("color") ? '<span id="NLCustomColorsTXT" tabindex="35"><span id="NLCurrentTXT" style="display: none;"></span>' + phrases.txt + "</span></div>" : ""), f += "</li>";
    f += '<li class="active">';
    f += '<div id="NLNormalColors" tabindex="35">' + commons.checkmark + '<span class="option-title">' + phrases.normal_plu + "</span></div>";
    f += "</li>";
    f += "</ul>";
    f += "</li>";
    f += '<li class="dropdown">';
    f += '<div class="dropdown-toggle" tabindex="40"><span class="dropdown-title">' +
      phrases.display + '</span><span class="dropdown-arrow"></span></div>';
    f += '<ul id="NagishLiDisplay" class="dropdown-menu">';
    f += "<li>";
    f += '<div id="NLTextDisplay" tabindex="41"><span class="help" data-balloon="' + phrases.text_only_exp + '" tabindex="41">&#x2753;&#xfe0e;&nbsp;</span><span class="option-title">' + phrases.text_only + "</span></div>";
    f += "</li>";
    f += "<li>";
    f += '<div id="NLImagesDisplay" tabindex="42"><span class="help" data-balloon="' + phrases.images_only_exp + '" tabindex="42">&#x2753;&#xfe0e;&nbsp;</span><span class="option-title">' +
      phrases.images_only + "</span></div>";
    f += "</li>";
    f += '<li class="active">';
    f += '<div id="NLNormalDisplay" tabindex="43">' + commons.checkmark + '<span class="option-title">' + phrases.normal_display + "</span></div>";
    f += "</li>";
    f += "</ul>";
    f += "</li>";
    f += '<li class="dropdown">';
    f += '<div class="dropdown-toggle" tabindex="50"><span class="dropdown-title">' + phrases.highlight + '</span><span class="dropdown-arrow"></span></div>';
    f += '<ul id="NagishLiHighlight" class="dropdown-menu">';
    f += "<li>";
    f += '<div id="NLHighlightLinks" tabindex="51"><span class="help" data-balloon="' +
      phrases.hl_links_exp + '" tabindex="51">&#x2753;&#xfe0e;&nbsp;</span><span class="option-title">' + phrases.hl_links + "</span></div>";
    f += "</li>";
    f += "<li>";
    f += '<div id="NLHighlightHeadings" tabindex="52"><span class="help" data-balloon="' + phrases.hl_headings_exp + '" tabindex="52">&#x2753;&#xfe0e;&nbsp;</span><span class="option-title">' + phrases.hl_headings + "</span></div>";
    f += "</li>";
    f += "</ul>";
    f += "</li>";
    f += '<li class="dropdown">';
    f += '<div class="dropdown-toggle" tabindex="60"><span class="dropdown-title">' +
      phrases.misc + '</span><span class="dropdown-arrow"></span></div>';
    f += '<ul id="NagishLiMisc" class="dropdown-menu">';
    f += '<li class="not-clickable">';
    f += '<div id="NLZoom"><span class="help" data-balloon="' + phrases.zoom_exp + '" tabindex="62">&#x2753;&#xfe0e;&nbsp;</span>' + phrases.zoom + ':&nbsp;<span id="NLZoomVal"></span><span id="NLZoomIn" tabindex="61">&#x2795;&#xfe0e;</span>&nbsp;&nbsp;<span id="NLZoomOut" tabindex="61">&#x2796;&#xfe0e;</span>&nbsp;&nbsp;<span id="NLNormalZoom" tabindex="61">' + phrases.normal +
      "</span></div>";
    f += "</li>";
    f += "<li>";
    f += '<div id="NLFont" tabindex="63"><span class="help" data-balloon="' + phrases.font_exp + '" tabindex="63">&#x2753;&#xfe0e;&nbsp;</span>' + phrases.font + ':&nbsp;<span id="NLFontVal">' + phrases.normal + "</span></div>";
    f += "</li>";
    f += "<li>";
    f += '<div id="NLAnimations" tabindex="64"><span class="help" data-balloon="' + phrases.animations_exp + '" tabindex="64">&#x2753;&#xfe0e;&nbsp;</span><span class="notice" data-balloon="' + phrases.experimental_feat + '" tabindex="64">&#x26a0;&#xfe0e;&nbsp;</span>' +
      phrases.animations + ':&nbsp;<span id="NLAnimationsVal" title="' + phrases.animations_on + '">&#x25ba;&#xfe0e;&nbsp;' + phrases.animations_on + "</span></div>";
    f += "</li>";
    f += "<li>";
    f += '<div id="NLR2M" tabindex="65"><span class="help" data-balloon="' + phrases.r2m_exp + '" tabindex="65">&#x2753;&#xfe0e;&nbsp;</span><span class="notice" data-balloon="' + phrases.experimental_feat + '" tabindex="65">&#x26a0;&#xfe0e;&nbsp;</span>' + phrases.r2m + ':&nbsp;<span id="NLR2MVal" title="' + phrases.r2m_off + '">' + phrases.r2m_off + "</span></div>";
    f += "</li>";
    f += '<li class="not-clickable">';
    f += '<div id="NLCursor"><span class="help" data-balloon="' + phrases.cursor_exp + '" tabindex="67">&#x2753;&#xfe0e;&nbsp;</span><span class="notice" data-balloon="' + phrases.experimental_feat + '" tabindex="67">&#x26a0;&#xfe0e;&nbsp;</span>' + phrases.cursor + ':&nbsp;<span id="NLCursorBlack" title="' + phrases.cursor_black + '" tabindex="66">' + phrases.cursor_black + '</span>&nbsp;<span id="NLCursorWhite" title="' + phrases.cursor_white + '" tabindex="66">' + phrases.cursor_white +
      "</span></div>";
    f += "</li>";
    f += "<li>";
    f += '<div id="NLKBNav" tabindex="68"><span class="help" data-balloon="' + phrases.kbnav_exp + '" tabindex="68">&#x2753;&#xfe0e;&nbsp;</span><span class="notice" data-balloon="' + phrases.experimental_feat + '" tabindex="68">&#x26a0;&#xfe0e;&nbsp;</span>' + phrases.kbnav + ':&nbsp;<span id="NLKBNavVal" title="' + phrases.kbnav_off + '">' + phrases.kbnav_off + "</span></div>";
    f += "</li>";
    f += "</ul>";
    f += "</li>";
    f += "</ul>";
    f += "</div>";
    f += "</nagishli>";
    e = '<style type="text/css" id="NagishLiStyle">';
    e += "* nagishli#NagishLiTag * { font-family: Arial, Helvetica, sans-serif !important; font-size: 18px !important; line-height: 1.15 !important; -ms-text-size-adjust: 100% !important; -webkit-text-size-adjust: 100% !important; box-sizing: border-box !important; z-index: 9999998 !important; -webkit-user-select: none !important; -khtml-user-select: none !important; -o-user-select: none !important; -moz-user-select: none !important; user-select: none !important; backface-visibility: hidden !important; color: inherit !important; -webkit-animation: none !important; animation: none !important; transition-property: none !important; vertical-align: baseline !important; font-weight: bold !important; outline: none !important; }";
    e += "* nagishli[lang='he'] #NagishLiLogo { -moz-transform:scaleX(-1) !important;-o-transform:scaleX(-1) !important;-webkit-transform:scaleX(-1) !important;transform:scaleX(-1) !important;filter:FlipH !important;-ms-filter:\"FlipH\" !important; }";
    e += "* nagishli#NagishLiTag a { color: inherit !important; text-decoration: none !important; cursor: pointer !important; }";
    e += "* nagishli#NagishLiTag a:hover, * nagishli#NagishLiTag a:active { outline-width: 0 !important; }";
    e += "* nagishli#NagishLiTag sub, * nagishli#NagishLiTag sup { font-size: 75% !important; line-height: 0 !important; position: relative !important; vertical-align: baseline !important; }";
    e += "* nagishli#NagishLiTag sub { bottom: -0.25em !important; }";
    e += "* nagishli#NagishLiTag sup { top: -0.5em !important; }";
    e += "* nagishli#NagishLiTag #NagishLiOverlayContent > .NagishLiStatementText > ul { display: block !important; list-style-type: disc !important; margin: 1em 0 !important; padding-" + phrases.align_right + ": 40px !important; }";
    e += "* nagishli#NagishLiTag li { margin: 0 !important; }";
    e += "nagishli#NagishLiTag, nagishli#NagishLiTag:before, nagishli#NagishLiTag:after { box-sizing: border-box !important; }";
    e += commons.menus + " { list-style: none !important; display: none; padding: 0 !important; margin: 0 !important; width: 100% !important; min-width: 345px !important; max-height: " + (b(window).height() - 41) + "px; overflow-x: hidden !important; }";
    A && (e += commons.menus + " { overflow: hidden !important; }");
    e += commons.bar + " { position: fixed !important; direction: " + phrases.dir + "; text-align: " + phrases.align_right + " !important; " + positions[J.toUpperCase()] + " }";
    e += commons.dropdown + " > .dropdown-toggle { cursor: pointer !important; position: relative !important; display: block !important; color: white !important; text-shadow: 0 0 1px #000 !important; padding: 15px !important; }";
    e += commons.bar + " > #NagishLiBarStrip { display: inline-block; color: white !important; cursor: pointer !important; background: #000000 !important; box-shadow: -1px -1px 0 #404040 inset, -1px -1px 0 #404040 !important; text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.3) !important; padding: 10px !important; }";
    e += commons.bar + " > #NagishLiBarStrip.open { display: block; }";
    e += commons.dropdown + " > .dropdown-menu > li > div { border-right: 2px solid !important; border-left: 2px solid !important; }";
    e += commons.dropdown +
      ":last-child > .dropdown-menu > li:last-child > div { border-bottom: 2px solid !important; }";
    e += commons.dropdown + ' > .dropdown-toggle > .selected:before {content: ": " !important; }';
    e += commons.dropdown + " > .dropdown-menu { display: none; list-style: none !important; padding: 0 !important; margin: 0 !important; position: relative !important; float: none !important; border: 0 !important; border-radius: 0 !important; }";
    e += commons.dropdown + " > .dropdown-menu > li { position: relative !important; text-align: " +
      phrases.align_right + " !important; }";
    e += commons.dropdown + " > .dropdown-menu > li > div { display: block !important; color: #6f6f6f !important; background: #EEE !important; box-shadow: 0 1px 0 white inset, 0 -1px 0 #d5d5d5 inset !important; text-shadow: 0 -1px 0 rgba(255, 255, 255, 0.3) !important; padding: 15px !important; cursor: pointer !important; }";
    e += commons.dropdown + " > .dropdown-menu > li > div:hover { background: #f6f6f6 !important; }";
    e += commons.dropdown + " > .dropdown-menu > li.not-clickable > div { cursor: default !important; }";
    e += commons.dropdown + " > .dropdown-menu > li.not-clickable > div:hover { background: #EEE !important; }";
    e += commons.dropdown + " > .dropdown-menu.show { display: block !important; }";
    e += commons.bar + " > #NagishLiBarStrip > .expand-all, " + commons.bar + " > #NagishLiBarStrip > .collapse-all, " + commons.dropdown + " > .dropdown-toggle > .dropdown-arrow { display: none; position: absolute !important; }";
    e += commons.bar + " > #NagishLiBarStrip.open > .expand-all, " + commons.bar + " > #NagishLiBarStrip.open > .collapse-all { display: inline-block !important; }";
    e += commons.bar + " > #NagishLiBarStrip > .collapse-all, " + commons.dropdown + " > .dropdown-toggle.open > .dropdown-arrow { top: 13px !important; " + phrases.align_left + ': 15px !important; -moz-transform: scaleY(-1) !important; -o-transform: scaleY(-1) !important; -webkit-transform: scaleY(-1); transform: scaleY(-1) !important; filter: FlipV !important; -ms-filter: "FlipV" !important; }';
    e += commons.bar + " > #NagishLiBarStrip > .collapse-all { top: 8px !important; " + phrases.align_left + ": 15px !important; }";
    e += commons.bar + " > #NagishLiBarStrip > .expand-all { top: 12px !important; " + phrases.align_left + ": 15px !important; }";
    e += commons.dropdown + " > .dropdown-menu > li > div > .help, " + commons.dropdown + " > .dropdown-menu > li > div > .notice { display: none; cursor: help !important; }";
    e += commons.dropdown + " > .dropdown-toggle > .dropdown-arrow { display: inline-block !important; top: 18px !important; " + phrases.align_left + ": 15px !important; }";
    e += commons.dropdown + " > .dropdown-menu > li > div, " + commons.dropdown +
      ":last-child > .dropdown-menu > li:last-child > div, " + commons.menus + ".blue > .dropdown > .dropdown-menu > li > div, " + commons.menus + ".blue > .dropdown:last-child > .dropdown-menu > li:last-child > div { border-color: #5478E4 !important; }";
    e += commons.dropdown + " > .dropdown-toggle, " + commons.menus + ".blue > .dropdown > .dropdown-toggle { background: #4169E1 !important; box-shadow: 0 1px 0 #5478E4 inset, 0 -1px 0 #3A5ECA inset !important; }";
    e += commons.dropdown + " > .dropdown-toggle:hover, " + commons.menus +
      ".blue > .dropdown > .dropdown-toggle:hover { background: #5478E4 !important; }";
    e += commons.menus + ".red > .dropdown > .dropdown-menu > li > div, " + commons.menus + ".red > .dropdown:last-child > .dropdown-menu > li:last-child > div { border-color: #EB2B36 !important; }";
    e += commons.menus + ".red > .dropdown > .dropdown-toggle { background: #E50000 !important; box-shadow: 0 1px 0 #E71919 inset, 0 -1px 0 #CE0000 inset !important; }";
    e += commons.menus + ".red > .dropdown > .dropdown-toggle:hover { background: #EB2B36 !important; }";
    e += commons.menus + ".green > .dropdown > .dropdown-menu > li > div, " + commons.menus + ".green > .dropdown:last-child > .dropdown-menu > li:last-child > div { border-color: #365E1B !important; }";
    e += commons.menus + ".green > .dropdown > .dropdown-toggle { background: #204D02 !important; box-shadow: 0 1px 0 #365E1B inset, 0 -1px 0 #1C4501 inset !important; }";
    e += commons.menus + ".green > .dropdown > .dropdown-toggle:hover { background: #365E1B !important; }";
    e += commons.menus + ".purple > .dropdown > .dropdown-menu > li > div, " +
      commons.menus + ".purple > .dropdown:last-child > .dropdown-menu > li:last-child > div { border-color: #8562B1 !important; }";
    e += commons.menus + ".purple > .dropdown > .dropdown-toggle { background: #7851A9 !important; box-shadow: 0 1px 0 #8562B1 inset, 0 -1px 0 #6C4898 inset !important; }";
    e += commons.menus + ".purple > .dropdown > .dropdown-toggle:hover { background: #8562B1 !important; }";
    e += commons.menus + ".yellow > .dropdown > .dropdown-menu > li > div, " + commons.menus + ".yellow > .dropdown:last-child > .dropdown-menu > li:last-child > div { border-color: #EDCA19 !important; }";
    e += commons.menus + ".yellow > .dropdown > .dropdown-toggle { background: #E5C100 !important; box-shadow: 0 1px 0 #EDCA19 inset, 0 -1px 0 #D5B516 inset !important; }";
    e += commons.menus + ".yellow > .dropdown > .dropdown-toggle:hover { background: #EDCA19 !important; }";
    e += commons.menus + ".pink > .dropdown > .dropdown-menu > li > div, " + commons.menus + ".pink > .dropdown:last-child > .dropdown-menu > li:last-child > div { border-color: #FF69B4 !important; }";
    e += commons.menus + ".pink > .dropdown > .dropdown-toggle { background: #FF69B4 !important; box-shadow: 0 1px 0 #FF78BB inset, 0 -1px 0 #E55EA2 inset !important; }";
    e += commons.menus + ".pink > .dropdown > .dropdown-toggle:hover { background: #FF78BB !important; }";
    e += commons.menus + ".gray > .dropdown > .dropdown-menu > li > div, " + commons.menus + ".gray > .dropdown:last-child > .dropdown-menu > li:last-child > div { border-color: #778899 !important; }";
    e += commons.menus + ".gray > .dropdown > .dropdown-toggle { background: #778899 !important; box-shadow: 0 1px 0 #8493A3 inset, 0 -1px 0 #6B7A89 inset !important; }";
    e += commons.menus + ".gray > .dropdown > .dropdown-toggle:hover { background: #8493A3 !important; }";
    e += commons.menus + ".brown > .dropdown > .dropdown-menu > li > div, " + commons.menus + ".brown > .dropdown:last-child > .dropdown-menu > li:last-child > div { border-color: #A0522D !important; }";
    e += commons.menus + ".brown > .dropdown > .dropdown-toggle { background: #A0522D !important; box-shadow: 0 1px 0 #A96342 inset, 0 -1px 0 #904928 inset !important; }";
    e += commons.menus + ".brown > .dropdown > .dropdown-toggle:hover { background: #A96342 !important; }";
    e += commons.menus + ".orange > .dropdown > .dropdown-menu > li > div, " +
      commons.menus + ".orange > .dropdown:last-child > .dropdown-menu > li:last-child > div { border-color: #FF8C00 !important; }";
    e += commons.menus + ".orange > .dropdown > .dropdown-toggle { background: #FF8C00 !important; box-shadow: 0 1px 0 #FF9719 inset, 0 -1px 0 #E57E00 inset !important; }";
    e += commons.menus + ".orange > .dropdown > .dropdown-toggle:hover { background: #FF9719 !important; }";
    e += commons.menus + ".turquoise > .dropdown > .dropdown-menu > li > div, " + commons.menus + ".turquoise > .dropdown:last-child > .dropdown-menu > li:last-child > div { border-color: #20B2AA !important; }";
    e += commons.menus + ".turquoise > .dropdown > .dropdown-toggle { background: #20B2AA !important; box-shadow: 0 1px 0 #36B9B2 inset, 0 -1px 0 #1CA099 inset !important; }";
    e += commons.menus + ".turquoise > .dropdown > .dropdown-toggle:hover { background: #36B9B2 !important; }";
    e += commons.dropdown + " > .dropdown-menu > li > div > #NagishLiSupportedBrowsers > img { vertical-align: middle !important; margin: 0 2px !important; }";
    e += commons.dropdown + " > .dropdown-menu > li > div > #NagishLiSupportedBrowsers > img:first-child, " +
      commons.dropdown + " > .dropdown-menu > li > div > #NagishLiSupportedBrowsers > img:last-child { margin-" + phrases.align_right + ": 4px !important; margin-" + phrases.align_left + ": 0 !important; }";
    e += commons.dropdown + " > .dropdown-menu > li > div > #NLDevelopedIn { display: inline-block !important; position: absolute !important; " + phrases.align_left + ": 10px !important; top: 12px !important; }";
    A ? (e += commons.bar + " > #NagishLiBarStrip.open > #NagishLiMove { margin-" + phrases.align_left + ": 0 !important; }",
      e += commons.bar + " > #NagishLiBarStrip > #NagishLiMove { margin-" + phrases.align_right + ": 10px !important; }") : e += commons.bar + " > #NagishLiBarStrip.open > #NagishLiMove { margin-" + phrases.align_left + ": 30px !important; }";
    pa && (e += commons.bar + " > #NagishLiBarStrip > #NagishLiTitle, " + commons.bar + " > #NagishLiBarStrip > #NagishLiMove, " + commons.bar + " > #NagishLiBarStrip > #NagishLiToggleMenus  { display: none !important; }", e += commons.bar + " > #NagishLiBarStrip.open > #NagishLiTitle, " + commons.bar + " > #NagishLiBarStrip.open > #NagishLiMove, " +
      commons.bar + " > #NagishLiBarStrip.open > #NagishLiToggleMenus { display: inline-block !important; }", e += commons.bar + " > #NagishLiBarStrip > #NagishLiLogo { width: 25px !important; height: 25px !important; }", e += commons.bar + " > #NagishLiBarStrip.open > #NagishLiLogo { width: 21px !important; height: 21px !important; }");
    U || (e += 'button[data-balloon]{overflow:visible}[data-balloon]{position:relative;cursor:pointer}[data-balloon]:after{filter:alpha(opactiy=0);-ms-filter:"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";-moz-opacity:0;-khtml-opacity:0;opacity:0;pointer-events:none;-webkit-transition:all 0.18s ease-out 0.18s;-moz-transition:all 0.18s ease-out 0.18s;-ms-transition:all 0.18s ease-out 0.18s;-o-transition:all 0.18s ease-out 0.18s;transition:all 0.18s ease-out 0.18s;font-family:sans-serif !important;font-weight:normal !important;font-style:normal !important;text-shadow:none !important;font-size:12px !important;background:rgba(17,17,17,0.9);border-radius:4px;color:#fff;content:attr(data-balloon);padding:.5em 1em;position:absolute;white-space:nowrap;z-index:10}[data-balloon]:before{background:no-repeat url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http://www.w3.org/2000/svg%22%20width%3D%2236px%22%20height%3D%2212px%22%3E%3Cpath%20fill%3D%22rgba(17,17,17,0.9)%22%20transform%3D%22rotate(0)%22%20d%3D%22M2.658,0.000%20C-13.615,0.000%2050.938,0.000%2034.662,0.000%20C28.662,0.000%2023.035,12.002%2018.660,12.002%20C14.285,12.002%208.594,0.000%202.658,0.000%20Z%22/%3E%3C/svg%3E");background-size:100% auto;width:18px;height:6px;filter:alpha(opactiy=0);-ms-filter:"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";-moz-opacity:0;-khtml-opacity:0;opacity:0;pointer-events:none;-webkit-transition:all 0.18s ease-out 0.18s;-moz-transition:all 0.18s ease-out 0.18s;-ms-transition:all 0.18s ease-out 0.18s;-o-transition:all 0.18s ease-out 0.18s;transition:all 0.18s ease-out 0.18s;content:"";position:absolute;z-index:10}[data-balloon]:hover:before,[data-balloon]:hover:after,[data-balloon][data-balloon-visible]:before,[data-balloon][data-balloon-visible]:after{filter:alpha(opactiy=100);-ms-filter:"progid:DXImageTransform.Microsoft.Alpha(Opacity=100)";-moz-opacity:1;-khtml-opacity:1;opacity:1;pointer-events:auto}[data-balloon].font-awesome:after{font-family:FontAwesome}[data-balloon][data-balloon-break]:after{white-space:pre}[data-balloon][data-balloon-blunt]:before,[data-balloon][data-balloon-blunt]:after{-webkit-transition:none;-moz-transition:none;-ms-transition:none;-o-transition:none;transition:none}[data-balloon][data-balloon-pos="up"]:after{bottom:100%;left:50%;margin-bottom:11px;-webkit-transform:translate(-50%, 10px);-moz-transform:translate(-50%, 10px);-ms-transform:translate(-50%, 10px);transform:translate(-50%, 10px);-webkit-transform-origin:top;-moz-transform-origin:top;-ms-transform-origin:top;transform-origin:top}[data-balloon][data-balloon-pos="up"]:before{bottom:100%;left:50%;margin-bottom:5px;-webkit-transform:translate(-50%, 10px);-moz-transform:translate(-50%, 10px);-ms-transform:translate(-50%, 10px);transform:translate(-50%, 10px);-webkit-transform-origin:top;-moz-transform-origin:top;-ms-transform-origin:top;transform-origin:top}[data-balloon][data-balloon-pos="up"]:hover:after,[data-balloon][data-balloon-pos="up"][data-balloon-visible]:after{-webkit-transform:translate(-50%, 0);-moz-transform:translate(-50%, 0);-ms-transform:translate(-50%, 0);transform:translate(-50%, 0)}[data-balloon][data-balloon-pos="up"]:hover:before,[data-balloon][data-balloon-pos="up"][data-balloon-visible]:before{-webkit-transform:translate(-50%, 0);-moz-transform:translate(-50%, 0);-ms-transform:translate(-50%, 0);transform:translate(-50%, 0)}[data-balloon][data-balloon-pos="up-left"]:after{bottom:100%;left:0;margin-bottom:11px;-webkit-transform:translate(0, 10px);-moz-transform:translate(0, 10px);-ms-transform:translate(0, 10px);transform:translate(0, 10px);-webkit-transform-origin:top;-moz-transform-origin:top;-ms-transform-origin:top;transform-origin:top}[data-balloon][data-balloon-pos="up-left"]:before{bottom:100%;left:5px;margin-bottom:5px;-webkit-transform:translate(0, 10px);-moz-transform:translate(0, 10px);-ms-transform:translate(0, 10px);transform:translate(0, 10px);-webkit-transform-origin:top;-moz-transform-origin:top;-ms-transform-origin:top;transform-origin:top}[data-balloon][data-balloon-pos="up-left"]:hover:after,[data-balloon][data-balloon-pos="up-left"][data-balloon-visible]:after{-webkit-transform:translate(0, 0);-moz-transform:translate(0, 0);-ms-transform:translate(0, 0);transform:translate(0, 0)}[data-balloon][data-balloon-pos="up-left"]:hover:before,[data-balloon][data-balloon-pos="up-left"][data-balloon-visible]:before{-webkit-transform:translate(0, 0);-moz-transform:translate(0, 0);-ms-transform:translate(0, 0);transform:translate(0, 0)}[data-balloon][data-balloon-pos="up-right"]:after{bottom:100%;right:0;margin-bottom:11px;-webkit-transform:translate(0, 10px);-moz-transform:translate(0, 10px);-ms-transform:translate(0, 10px);transform:translate(0, 10px);-webkit-transform-origin:top;-moz-transform-origin:top;-ms-transform-origin:top;transform-origin:top}[data-balloon][data-balloon-pos="up-right"]:before{bottom:100%;right:5px;margin-bottom:5px;-webkit-transform:translate(0, 10px);-moz-transform:translate(0, 10px);-ms-transform:translate(0, 10px);transform:translate(0, 10px);-webkit-transform-origin:top;-moz-transform-origin:top;-ms-transform-origin:top;transform-origin:top}[data-balloon][data-balloon-pos="up-right"]:hover:after,[data-balloon][data-balloon-pos="up-right"][data-balloon-visible]:after{-webkit-transform:translate(0, 0);-moz-transform:translate(0, 0);-ms-transform:translate(0, 0);transform:translate(0, 0)}[data-balloon][data-balloon-pos="up-right"]:hover:before,[data-balloon][data-balloon-pos="up-right"][data-balloon-visible]:before{-webkit-transform:translate(0, 0);-moz-transform:translate(0, 0);-ms-transform:translate(0, 0);transform:translate(0, 0)}[data-balloon][data-balloon-pos="down"]:after{left:50%;margin-top:11px;top:100%;-webkit-transform:translate(-50%, -10px);-moz-transform:translate(-50%, -10px);-ms-transform:translate(-50%, -10px);transform:translate(-50%, -10px)}[data-balloon][data-balloon-pos="down"]:before{background:no-repeat url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http://www.w3.org/2000/svg%22%20width%3D%2236px%22%20height%3D%2212px%22%3E%3Cpath%20fill%3D%22rgba(17,17,17,0.9)%22%20transform%3D%22rotate(180 18 6)%22%20d%3D%22M2.658,0.000%20C-13.615,0.000%2050.938,0.000%2034.662,0.000%20C28.662,0.000%2023.035,12.002%2018.660,12.002%20C14.285,12.002%208.594,0.000%202.658,0.000%20Z%22/%3E%3C/svg%3E");background-size:100% auto;width:18px;height:6px;left:50%;margin-top:5px;top:100%;-webkit-transform:translate(-50%, -10px);-moz-transform:translate(-50%, -10px);-ms-transform:translate(-50%, -10px);transform:translate(-50%, -10px)}[data-balloon][data-balloon-pos="down"]:hover:after,[data-balloon][data-balloon-pos="down"][data-balloon-visible]:after{-webkit-transform:translate(-50%, 0);-moz-transform:translate(-50%, 0);-ms-transform:translate(-50%, 0);transform:translate(-50%, 0)}[data-balloon][data-balloon-pos="down"]:hover:before,[data-balloon][data-balloon-pos="down"][data-balloon-visible]:before{-webkit-transform:translate(-50%, 0);-moz-transform:translate(-50%, 0);-ms-transform:translate(-50%, 0);transform:translate(-50%, 0)}[data-balloon][data-balloon-pos="down-left"]:after{left:0;margin-top:11px;top:100%;-webkit-transform:translate(0, -10px);-moz-transform:translate(0, -10px);-ms-transform:translate(0, -10px);transform:translate(0, -10px)}[data-balloon][data-balloon-pos="down-left"]:before{background:no-repeat url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http://www.w3.org/2000/svg%22%20width%3D%2236px%22%20height%3D%2212px%22%3E%3Cpath%20fill%3D%22rgba(17,17,17,0.9)%22%20transform%3D%22rotate(180 18 6)%22%20d%3D%22M2.658,0.000%20C-13.615,0.000%2050.938,0.000%2034.662,0.000%20C28.662,0.000%2023.035,12.002%2018.660,12.002%20C14.285,12.002%208.594,0.000%202.658,0.000%20Z%22/%3E%3C/svg%3E");background-size:100% auto;width:18px;height:6px;left:5px;margin-top:5px;top:100%;-webkit-transform:translate(0, -10px);-moz-transform:translate(0, -10px);-ms-transform:translate(0, -10px);transform:translate(0, -10px)}[data-balloon][data-balloon-pos="down-left"]:hover:after,[data-balloon][data-balloon-pos="down-left"][data-balloon-visible]:after{-webkit-transform:translate(0, 0);-moz-transform:translate(0, 0);-ms-transform:translate(0, 0);transform:translate(0, 0)}[data-balloon][data-balloon-pos="down-left"]:hover:before,[data-balloon][data-balloon-pos="down-left"][data-balloon-visible]:before{-webkit-transform:translate(0, 0);-moz-transform:translate(0, 0);-ms-transform:translate(0, 0);transform:translate(0, 0)}[data-balloon][data-balloon-pos="down-right"]:after{right:0;margin-top:11px;top:100%;-webkit-transform:translate(0, -10px);-moz-transform:translate(0, -10px);-ms-transform:translate(0, -10px);transform:translate(0, -10px)}[data-balloon][data-balloon-pos="down-right"]:before{background:no-repeat url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http://www.w3.org/2000/svg%22%20width%3D%2236px%22%20height%3D%2212px%22%3E%3Cpath%20fill%3D%22rgba(17,17,17,0.9)%22%20transform%3D%22rotate(180 18 6)%22%20d%3D%22M2.658,0.000%20C-13.615,0.000%2050.938,0.000%2034.662,0.000%20C28.662,0.000%2023.035,12.002%2018.660,12.002%20C14.285,12.002%208.594,0.000%202.658,0.000%20Z%22/%3E%3C/svg%3E");background-size:100% auto;width:18px;height:6px;right:5px;margin-top:5px;top:100%;-webkit-transform:translate(0, -10px);-moz-transform:translate(0, -10px);-ms-transform:translate(0, -10px);transform:translate(0, -10px)}[data-balloon][data-balloon-pos="down-right"]:hover:after,[data-balloon][data-balloon-pos="down-right"][data-balloon-visible]:after{-webkit-transform:translate(0, 0);-moz-transform:translate(0, 0);-ms-transform:translate(0, 0);transform:translate(0, 0)}[data-balloon][data-balloon-pos="down-right"]:hover:before,[data-balloon][data-balloon-pos="down-right"][data-balloon-visible]:before{-webkit-transform:translate(0, 0);-moz-transform:translate(0, 0);-ms-transform:translate(0, 0);transform:translate(0, 0)}[data-balloon][data-balloon-pos="left"]:after{margin-right:11px;right:100%;top:50%;-webkit-transform:translate(10px, -50%);-moz-transform:translate(10px, -50%);-ms-transform:translate(10px, -50%);transform:translate(10px, -50%)}[data-balloon][data-balloon-pos="left"]:before{background:no-repeat url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http://www.w3.org/2000/svg%22%20width%3D%2212px%22%20height%3D%2236px%22%3E%3Cpath%20fill%3D%22rgba(17,17,17,0.9)%22%20transform%3D%22rotate(-90 18 18)%22%20d%3D%22M2.658,0.000%20C-13.615,0.000%2050.938,0.000%2034.662,0.000%20C28.662,0.000%2023.035,12.002%2018.660,12.002%20C14.285,12.002%208.594,0.000%202.658,0.000%20Z%22/%3E%3C/svg%3E");background-size:100% auto;width:6px;height:18px;margin-right:5px;right:100%;top:50%;-webkit-transform:translate(10px, -50%);-moz-transform:translate(10px, -50%);-ms-transform:translate(10px, -50%);transform:translate(10px, -50%)}[data-balloon][data-balloon-pos="left"]:hover:after,[data-balloon][data-balloon-pos="left"][data-balloon-visible]:after{-webkit-transform:translate(0, -50%);-moz-transform:translate(0, -50%);-ms-transform:translate(0, -50%);transform:translate(0, -50%)}[data-balloon][data-balloon-pos="left"]:hover:before,[data-balloon][data-balloon-pos="left"][data-balloon-visible]:before{-webkit-transform:translate(0, -50%);-moz-transform:translate(0, -50%);-ms-transform:translate(0, -50%);transform:translate(0, -50%)}[data-balloon][data-balloon-pos="right"]:after{left:100%;margin-left:11px;top:50%;-webkit-transform:translate(-10px, -50%);-moz-transform:translate(-10px, -50%);-ms-transform:translate(-10px, -50%);transform:translate(-10px, -50%)}[data-balloon][data-balloon-pos="right"]:before{background:no-repeat url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http://www.w3.org/2000/svg%22%20width%3D%2212px%22%20height%3D%2236px%22%3E%3Cpath%20fill%3D%22rgba(17,17,17,0.9)%22%20transform%3D%22rotate(90 6 6)%22%20d%3D%22M2.658,0.000%20C-13.615,0.000%2050.938,0.000%2034.662,0.000%20C28.662,0.000%2023.035,12.002%2018.660,12.002%20C14.285,12.002%208.594,0.000%202.658,0.000%20Z%22/%3E%3C/svg%3E");background-size:100% auto;width:6px;height:18px;left:100%;margin-left:5px;top:50%;-webkit-transform:translate(-10px, -50%);-moz-transform:translate(-10px, -50%);-ms-transform:translate(-10px, -50%);transform:translate(-10px, -50%)}[data-balloon][data-balloon-pos="right"]:hover:after,[data-balloon][data-balloon-pos="right"][data-balloon-visible]:after{-webkit-transform:translate(0, -50%);-moz-transform:translate(0, -50%);-ms-transform:translate(0, -50%);transform:translate(0, -50%)}[data-balloon][data-balloon-pos="right"]:hover:before,[data-balloon][data-balloon-pos="right"][data-balloon-visible]:before{-webkit-transform:translate(0, -50%);-moz-transform:translate(0, -50%);-ms-transform:translate(0, -50%);transform:translate(0, -50%)}[data-balloon][data-balloon-length="small"]:after{white-space:normal;width:80px}[data-balloon][data-balloon-length="medium"]:after{white-space:normal;width:150px}[data-balloon][data-balloon-length="large"]:after{white-space:normal;width:260px}[data-balloon][data-balloon-length="xlarge"]:after{white-space:normal;width:380px}@media screen and (max-width: 768px){[data-balloon][data-balloon-length="xlarge"]:after{white-space:normal;width:90vw}}[data-balloon][data-balloon-length="fit"]:after{white-space:normal;width:100%}',
      e += commons.dropdown + " > .dropdown-menu > li > div > .notice { z-index: 9999997 !important; }", e += "* nagishli#NagishLiTag *[data-balloon]:before, * nagishli#NagishLiTag *[data-balloon]:after, body span.r2m[data-balloon]:before, body span.r2m[data-balloon]:after { -webkit-transition: none !important; -moz-transition: none !important; -ms-transition: none !important; -o-transition: none !important; transition: none !important; font-weight: bold !important;}");
    e += "nagishli#NagishLiTag > .NagishLiOverlay { position: fixed !important; top: 0 !important; " +
      phrases.align_left + ": 0 !important; width: 100% !important; height: 100% !important; background: rgba(0, 0, 0, 0.7) repeat !important; text-align: center !important; z-index: 9999999 !important; opacity: 1; }";
    e += "nagishli#NagishLiTag > .NagishLiOverlay #closeBtn { position: absolute !important; " + phrases.align_left + ": 1% !important; top: 2% !important; font-size: 120% !important; cursor: pointer !important; }";
    e += ".animated{-webkit-animation-duration:1s;animation-duration:1s;-webkit-animation-fill-mode:both;animation-fill-mode:both}.animated.bounceIn,.animated.bounceOut{-webkit-animation-duration:.75s;animation-duration:.75s}@-webkit-keyframes bounceIn{20%,40%,60%,80%,from,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;-webkit-transform:scale3d(.3,.3,.3);transform:scale3d(.3,.3,.3)}20%{-webkit-transform:scale3d(1.1,1.1,1.1);transform:scale3d(1.1,1.1,1.1)}40%{-webkit-transform:scale3d(.9,.9,.9);transform:scale3d(.9,.9,.9)}60%{opacity:1;-webkit-transform:scale3d(1.03,1.03,1.03);transform:scale3d(1.03,1.03,1.03)}80%{-webkit-transform:scale3d(.97,.97,.97);transform:scale3d(.97,.97,.97)}to{opacity:1;-webkit-transform:scale3d(1,1,1);transform:scale3d(1,1,1)}}@keyframes bounceIn{20%,40%,60%,80%,from,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;-webkit-transform:scale3d(.3,.3,.3);transform:scale3d(.3,.3,.3)}20%{-webkit-transform:scale3d(1.1,1.1,1.1);transform:scale3d(1.1,1.1,1.1)}40%{-webkit-transform:scale3d(.9,.9,.9);transform:scale3d(.9,.9,.9)}60%{opacity:1;-webkit-transform:scale3d(1.03,1.03,1.03);transform:scale3d(1.03,1.03,1.03)}80%{-webkit-transform:scale3d(.97,.97,.97);transform:scale3d(.97,.97,.97)}to{opacity:1;-webkit-transform:scale3d(1,1,1);transform:scale3d(1,1,1)}}.bounceIn{-webkit-animation-name:bounceIn;animation-name:bounceIn}@-webkit-keyframes bounceOut{20%{-webkit-transform:scale3d(.9,.9,.9);transform:scale3d(.9,.9,.9)}50%,55%{opacity:1;-webkit-transform:scale3d(1.1,1.1,1.1);transform:scale3d(1.1,1.1,1.1)}to{opacity:0;-webkit-transform:scale3d(.3,.3,.3);transform:scale3d(.3,.3,.3)}}@keyframes bounceOut{20%{-webkit-transform:scale3d(.9,.9,.9);transform:scale3d(.9,.9,.9)}50%,55%{opacity:1;-webkit-transform:scale3d(1.1,1.1,1.1);transform:scale3d(1.1,1.1,1.1)}to{opacity:0;-webkit-transform:scale3d(.3,.3,.3);transform:scale3d(.3,.3,.3)}}.bounceOut{-webkit-animation-name:bounceOut;animation-name:bounceOut}";
    e += commons.dropdown + " > #NagishLiMisc > li > #NLZoom > span:not(#NLZoomVal), #NagishLiMisc > li > #NLCursor > span, " + commons.dropdown + " > #NagishLiColors > li > #NLCustomColors > #NLCustomColorsBG, " + commons.dropdown + " > #NagishLiColors > li > #NLCustomColors > #NLCustomColorsTXT { cursor: pointer !important; }";
    e += 'html[nl-cursor="white"] * { cursor: url(' + icons.white_cursor + ") 0 0, auto !important; }";
    e += 'html[nl-cursor="white"] * a:hover, html[nl-cursor="white"] * a:focus, html[nl-cursor="white"] * a:active, html[nl-cursor="white"] * a:visited { cursor: url(' +
      icons.white_pointer + ") 18 0, auto !important; }";
    e += 'html[nl-cursor="black"] * { cursor: url(' + icons.black_cursor + ") 0 0, auto !important; }";
    e += 'html[nl-cursor="black"] * a:hover, html[nl-cursor="black"] * a:focus, html[nl-cursor="black"] * a:active, html[nl-cursor="black"] * a:visited { cursor: url(' + icons.black_pointer + ") 18 0, auto !important; }";
    e += commons.dropdown + " > #NagishLiColors > li > #NLCustomColors > ul > li { display: inline-block !important; vertical-align: middle !important; width: 20px !important; height: 20px !important; cursor: pointer !important; margin: 5px !important; border: 1px solid black !important; }";
    e += commons.dropdown + " > #NagishLiColors > li > #NLCustomColors > ul > li:hover, " + commons.dropdown + " > #NagishLiColors > li > #NLCustomColors > ul > li.selected { border-color: white !important; }";
    e += commons.dropdown + " > #NagishLiColors > li > #NLCustomColors > #NLCustomColorsBG > #NLCurrentBG, " + commons.dropdown + " > #NagishLiColors > li > #NLCustomColors > #NLCustomColorsTXT > #NLCurrentTXT { width: 16px !important; height: 16px !important; vertical-align: middle !important; border: 1px solid black !important; margin-" +
      phrases.align_left + ": 5px !important; background-color: transparent; }";
    e += "</style>";
    b("body").append(w, e, f);
    b("video, audio").attr("nl-role", "media");
    b("iframe[src*='youtube.com']").attr("nl-role", "ytmedia");
    b("img").each(function () {
      if (!b(this).attr("alt")) {
        var c = b(this).attr("title") ? phrases.img_alt + b(this).attr("title") : phrases.img_alt_missing;
        b(this).attr("alt", c)
      }
    });
    b(commons.dropdown + " > #NagishLiColors > li > #NLGrayscaleColors").click(function () {
      l()
    });
    b(commons.dropdown + " > #NagishLiColors > li > #NLInvertColors").click(function () {
      F()
    });
    b(commons.dropdown + " > #NagishLiColors > li > #NLWarmColors").click(function () {
      K("warm")
    });
    b(commons.dropdown + " > #NagishLiColors > li > #NLColdColors").click(function () {
      K("cold")
    });
    b(commons.dropdown + " > #NagishLiColors > li > #NLNormalColors").click(function () {
      O()
    });
    b(commons.dropdown + " > #NagishLiText > li > #NLBiggerText").click(function () {
      x()
    });
    b(commons.dropdown + " > #NagishLiText > li > #NLSmallerText").click(function () {
      r()
    });
    b(commons.dropdown + " > #NagishLiText > li > #NLNormalText").click(function () {
      u()
    });
    b(commons.dropdown + " > #NagishLiDisplay > li > #NLTextDisplay").click(function () {
      C()
    });
    b(commons.dropdown + " > #NagishLiDisplay > li > #NLImagesDisplay").click(function () {
      y()
    });
    b(commons.dropdown + " > #NagishLiDisplay > li > #NLNormalDisplay").click(function () {
      ba()
    });
    b(commons.dropdown + " > #NagishLiHighlight > li > #NLHighlightLinks").click(function () {
      ca()
    });
    b(commons.dropdown + " > #NagishLiHighlight > li > #NLHighlightHeadings").click(function () {
      da()
    });
    b(commons.dropdown + " > #NagishLiMisc > li > #NLZoom > #NLZoomIn").click(function () {
      ea()
    });
    b(commons.dropdown + " > #NagishLiMisc > li > #NLZoom > #NLZoomOut").click(function () {
      fa()
    });
    b(commons.dropdown + " > #NagishLiMisc > li > #NLZoom > #NLNormalZoom").click(function () {
      ha()
    });
    b(commons.dropdown + " > #NagishLiMisc > li > #NLFont").click(function () {
      ia()
    });
    b(commons.bar + " > #NagishLiBarStrip > #NagishLiMove > #NagishLiMoveTL").click(function () {
      G("TL")
    });
    b(commons.bar + " > #NagishLiBarStrip > #NagishLiMove > #NagishLiMoveBR").click(function () {
      G("BR")
    });
    b(commons.bar + " > #NagishLiBarStrip > #NagishLiMove > #NagishLiMoveBL").click(function () {
      G("BL")
    });
    b(commons.bar + " > #NagishLiBarStrip > #NagishLiMove > #NagishLiMoveTR").click(function () {
      G("TR")
    });
    B && b(commons.dropdown + " > #NagishLiInfo > li > #NLResetSettings").click(function () {
      var c = confirm(phrases.reset_prompt);
      if (1 == c) return g("NagishLi", "delete", "all"), b(commons.bar).css({
          "max-height": "",
          "overflow-y": ""
        }), b(commons.bar + " > #NagishLiBarStrip > #NagishLiToggleMenus, " + commons.bar + " > #NagishLiBarStrip > #NagishLiMove").remove(), b(commons.bar + " > #NagishLiBarStrip").addClass("open"), b(commons.menus).show(),
        b(commons.menus).html('<li class="dropdown"><ul class="dropdown-menu show"><li class="not-clickable"><div href="#">' + phrases.settings_reset_html_ok + "</div></li></ul></li>"), alert(phrases.settings_reset_alert_ok), !1;
      0 == c && alert(phrases.settings_save)
    });
    b(commons.dropdown + " > #NagishLiMisc > li > #NLAnimations").click(function () {
      ja()
    });
    b(commons.dropdown + " > #NagishLiInfo > #NagishLiHelp").click(function () {
      ma()
    });
    b(commons.dropdown + " > #NagishLiMisc > li > #NLR2M").click(function () {
      ka()
    });
    b(commons.dropdown +
      " > #NagishLiMisc > li > #NLCursor > #NLCursorBlack").click(function () {
      S("black")
    });
    b(commons.dropdown + " > #NagishLiMisc > li > #NLCursor > #NLCursorWhite").click(function () {
      S("white")
    });
    b(commons.dropdown + " > #NagishLiMisc > li > #NLKBNav").click(function () {
      na()
    });
    B ? function (c) {
      c = void 0 === c ? "NagishLi" : c;
      var d = g(c, "read", "ok"),
        e = g(c, "read", "position"),
        f = g(c, "read", "text"),
        q = g(c, "read", "colors"),
        n = g(c, "read", "display"),
        w = g(c, "read", "zoom"),
        A = g(c, "read", "font"),
        B = g(c, "read", "highlight", 1),
        D = g(c, "read",
          "highlight", 2),
        L = g(c, "read", "help"),
        I = g(c, "read", "animations"),
        J = g(c, "read", "cursor"),
        M = g(c, "read", "tabbing"),
        N = g(c, "read", "r2m");
      if ("0" == d && ("0" != f && (8 >= parseInt(f) || 35 <= parseInt(f)) || "0.0" != w && (.5 >= parseFloat(w) || 2.5 <= parseFloat(w)) || -1 !== q.indexOf(",") && q.split(",")[0] == q.split(",")[1])) {
        d = confirm(phrases.settings_prompt);
        if (1 == d) return g("NagishLi", "delete", "all"), b(commons.bar).css({
            "max-height": "",
            "overflow-y": ""
          }), b(commons.bar + " > #NagishLiBarStrip > #NagishLiToggleMenus, " + commons.bar + " > #NagishLiBarStrip > #NagishLiMove").remove(),
          b(commons.bar + " > #NagishLiBarStrip").addClass("open"), b(commons.menus).show(), b(commons.menus).html('<li class="dropdown"><ul class="dropdown-menu show"><li class="not-clickable"><div href="#">' + phrases.settings_reset_html_ok + "</div></li></ul></li>"), alert(phrases.settings_reset_alert_ok), !1;
        0 == d && (g(c, "write", "ok", 1, "1"), alert(phrases.settings_save + "\n" + phrases.settings_save_reminder))
      }
      "open" == g(c, "read", "menu") ? b("#NagishLiBarStrip").addClass("open").next("#NagishLiMenus").show() : b("#NagishLiMenus").hide();
      "TR" == e ? G("TR", !0) : "BR" == e ? G("BR", !0) : "BL" == e ? G("BL", !0) : G("TL", !0);
      e = !0;
      c = g(c, "read", "submenus");
      d = void 0;
      c = void 0 === c ? "000000" : c;
      d = void 0 === d ? "1" : d;
      if (void 0 === e ? 0 : e)
        for (e = c.length; e--;) c[e] == d && b(commons.dropdown + " > .dropdown-toggle").eq(e).addClass("open").next("ul.dropdown-menu").show().addClass("show");
      else
        for (e = c.length; e--;) c[e] == d && b(commons.dropdown + " > .dropdown-toggle").eq(e).addClass("open").next("ul.dropdown-menu").slideDown("fast").addClass("show");
      la();
      0 == parseInt(f) ? u() : 0 < parseInt(f) ?
        x(!0) : r(!0);
      "grayscale" == q ? l(!0) : "invert" == q ? F(!0) : "warm" == q ? K("warm", !0) : "cold" == q ? K("cold", !0) : -1 !== q.indexOf(",") ? ("-" != q.split(",")[0] && Q("bg", V(q.split(",")[0]), !0), "-" != q.split(",")[1] && Q("txt", V(q.split(",")[1]), !0)) : O();
      "textonly" == n ? C(!0) : "imagesonly" == n ? y(!0) : ba();
      0 < parseFloat(w) ? ea(!0) : 0 > parseFloat(w) ? fa(!0) : ha();
      "readable" == A && ia("readable", !0);
      "1" == B && ca(!0);
      "1" == D && da(!0);
      !b("ul#NagishLiHighlight").prev(".dropdown-toggle", "div").hasClass("open") && b("ul#NagishLiHighlight > li.active").length &&
        (1 < b("ul#NagishLiHighlight > li.active").find("span.sign").length ? (f = b("ul#NagishLiHighlight").children("li.active:first-child").find(".option-title").text() + " " + b("ul#NagishLiHighlight").children("li.active:nth-child(2)").find(".option-title").text(), f = f.split(" "), f[1] = "en" == p ? f[1].charAt(0).toUpperCase() + f[1].substr(1) : f[1], b('<span class="selected">' + f[1] + "&nbsp;" + phrases.and + f[3] + "</span>").insertAfter(b("ul#NagishLiHighlight").prev(".dropdown-toggle", "div").children(".dropdown-title"))) : (f =
          b("ul#NagishLiHighlight > li.active").find(".option-title").text(), b('<span class="selected">' + f + "</span>").insertAfter(b("ul#NagishLiHighlight").prev(".dropdown-toggle", "div").children(".dropdown-title"))));
      "1" == L && ma(!0);
      "off" == I && ja(!0);
      "on" == N && ka(!0);
      "black" == J ? S("black", !0) : "white" == J && S("white", !0);
      "on" == M && na(!0)
    }() : b(commons.bar + " > #NagishLiBarStrip > #NagishLiMove > #NagishLiMove" + J).css("visibility", "hidden");
    b("body").on("mousedown", function (c) {
      !b(commons.menus).is(":visible") || b(c.target).parents("#NagishLiBar, .NagishLiOverlay, a, span[nl-r2m-data]").length ||
        b(c.target).is(".NagishLiOverlay, a") || b(this).children("a").length || (b(commons.menus).slideUp(150, function () {
          b(commons.bar + " > #NagishLiBarStrip").removeClass("open")
        }), g("NagishLi", "write", "menu", "", "closed"))
    });
    b(commons.bar + " > #NagishLiBarStrip").on("click keypress", function (c, d) {
      1 !== c.which && 13 !== c.which || b(c.target).parent("span").is("#NagishLiMove, #NagishLiToggleMenus") || (b(commons.menus).is(":visible") ? (b(commons.menus).slideUp(150, function () {
          b(commons.bar + " > #NagishLiBarStrip").removeClass("open")
        }),
        d = "closed") : (b(this).addClass("open").next("#NagishLiMenus").slideDown(150), d = "open"), g("NagishLi", "write", "menu", "", d))
    });
    b(commons.dropdown + " > .dropdown-toggle").click(function (c, d) {
      A ? (b(commons.dropdown + " > .dropdown-toggle").not(b(this)).removeClass("open").next("ul.dropdown-menu").slideUp("fast").removeClass("show"), b(this).toggleClass("open").next("ul.dropdown-menu").slideToggle("fast").toggleClass("show"), d = b(commons.dropdown + " > .dropdown-toggle").index(this), c = "000000", b(this).hasClass("open") &&
        (c = c.substr(0, d) + "1" + c.substr(d + 1)), g("NagishLi", "write", "submenus", "all", c)) : (b(this).toggleClass("open").next("ul.dropdown-menu").slideToggle("fast").toggleClass("show"), d = b(commons.dropdown + " > .dropdown-toggle").index(this) + 1, c = b(this).hasClass("open") ? "1" : "0", g("NagishLi", "write", "submenus", d, c));
      la()
    });
    b(commons.bar + " > #NagishLiBarStrip > #NagishLiToggleMenus").on("click keypress", function (c) {
      !b(c.target).parent("span#NagishLiToggleMenus") || 1 !== c.which && 13 !== c.which || (b(this).hasClass("expand-all") ?
        (b(this).attr("class", "collapse-all").children("img").attr("alt", phrases.collapse_all), b(commons.dropdown + " > .dropdown-toggle").addClass("open").children("span.selected").remove(), b(commons.dropdown + " > .dropdown-menu").slideDown("fast").addClass("show"), c = "111111") : (b(this).attr("class", "expand-all").children("img").attr("alt", phrases.expand_all), b(commons.dropdown + " > .dropdown-toggle.open").removeClass("open"), b(commons.dropdown + " > .dropdown-menu.show").slideUp("fast").removeClass("show"), c =
          "000000", b(commons.dropdown + " > .dropdown-toggle").each(function (c) {
            b(this).next("#NagishLiColors, #NagishLiDisplay", "ul").children("li.active:not(':last-child')").length ? !b(this).children("span.selected").length && b(this).next("ul").children("li.active").length && (c = b(this).next("ul").children("li.active").find(".option-title").text(), b('<span class="selected">' + c + "</span>").insertAfter(b(this).children(".dropdown-title"))) : b(this).next("#NagishLiHighlight", "ul").length && (!b(this).children("span.selected").length &&
              1 < b(this).next("ul").children("li.active").find("span.sign").length ? (c = b(this).next("ul").children("li.active:first-child").find(".option-title").text() + " " + b(this).next("ul").children("li.active:nth-child(2)").find(".option-title").text(), c = c.split(" "), c[1] = "en" == p ? c[1].charAt(0).toUpperCase() + c[1].substr(1) : c[1], b('<span class="selected">' + c[1] + "&nbsp;" + phrases.and + c[3] + "</span>").insertAfter(b(this).children(".dropdown-title"))) : !b(this).children("span.selected").length && b(this).next("ul").find("span.sign").length ?
              (c = b(this).next("ul").children("li.active").find(".option-title").text(), b('<span class="selected">' + c + "</span>").insertAfter(b(this).children(".dropdown-title"))) : b(this).children("span.selected").remove())
          })), g(name, "write", "submenus", "all", c))
    });
    b(commons.dropdown + " > #NagishLiInfo > li > #NagishLiStatement, " + commons.dropdown + " > #NagishLiInfo > li > #NagishLiHowAccessible").click(function (c) {
      if ("NagishLiStatement" == c.target.id && W) window.location.replace(W);
      else {
        b("body[nl-kbnav]").length && b(this).blur();
        b("html")[0].style.setProperty("overflow", "hidden", "important");
        b("body")[0].style.setProperty("overflow", "hidden", "important");
        b(document).on("keydown.nlkbnav mousedown.nlkbnav", function (c) {
          if (27 === c.which || b(c.target).hasClass("NagishLiOverlay") || "closeBtn" == c.target.id && 9 !== c.which) b("#DeveloperMsg").length ? b(".NagishLiOverlay").fadeOut("fast", function () {
            b(this).remove();
            b("body[nl-kbnav]").length && b(commons.dropdown + " > #NagishLiInfo > li > #NagishLiHowAccessible").focus()
          }) : b(".NagishLiOverlay").fadeOut("fast",
            function () {
              b(this).remove();
              b("body[nl-kbnav]").length && b(commons.dropdown + " > #NagishLiInfo > li > #NagishLiStatement").focus()
            }), b("html")[0].style.setProperty("overflow", "", ""), b("body")[0].style.setProperty("overflow", "", ""), b(document).off("keydown.nlkbnav mousedown.nlkbnav")
        });
        var d = b(commons.dropdown + ":last-child > .dropdown-menu > li:last-child > div").css("border-bottom-color");
        "NagishLiHowAccessible" == c.target.id ? (c = '<div class="NagishLiAboutText" style="text-align: ' + phrases.align_right +
            ' !important; width: 80% !important; margin: 0 auto !important;"><a role="button" id="closeBtn" tabindex="1">&#x274c;&#xfe0e;</a><span class="nlap-title">' + phrases.about + "</span>", c = "0" != D ? c + phrases.about_text_lic : c + ('<span id="DeveloperMsg" style="border: 1px solid ' + d + " !important; border-" + phrases.align_right + "-width: 10px !important; border-radius: 10px !important; display: block !important; padding: 2% !important; text-align: " + phrases.align_right + ' !important; font-size: 90% !important; background: #EEE !important; font-weight: bold !important; color: #6f6f6f !important; margin-bottom: 2% !important;"><a href="https://fb.me/ZannyBoy" target="_blank" tabindex="1"><img src="//graph.facebook.com/1452532180/picture?type=normal&amp;width=87&amp;height=87" onerror="this.parentNode.style.display=\'none\';" style="border-radius: 50% !important; margin-top: 1% !important; margin-' +
              phrases.align_left + ": 2% !important; float: " + phrases.align_right + ' !important;" /></a>' + phrases.developer_message + "</span>" + phrases.about_text), c += '<br /><br /></div><style type="text/css">#NagishLiOverlayContent > .NagishLiAboutText > .nlap-title { font-size: 150% !important; color: ' + d + " !important; display: block !important; margin: 2% 0 !important; font-weight: bold !important; text-align: center !important; } #NagishLiOverlayContent > .NagishLiAboutText > a { color: " + d + " !important; text-decoration: none !important; } #NagishLiOverlayContent > .NagishLiAboutText > .nlap-stitle { font-weight: bold !important; font-size: 110% !important; text-decoration: underline !important; }</style>") :
          c = '<div class="NagishLiStatementText" style="text-align: ' + phrases.align_right + ' !important; width: 80% !important; margin: 0 auto !important;"><a href="javascript:void(0);" role="button" id="closeBtn" tabindex="1">&#x274c;&#xfe0e;</a><span class="nlas-title">' + Y.toUpperCase() + "&nbsp;-&nbsp;" + phrases.a11y_info + "</span>" + phrases.accessibility_statement + '</div><style type="text/css">#NagishLiOverlayContent > .NagishLiStatementText > .nlas-title { font-size: 150% !important; color: ' + d + " !important; display: block !important; margin: 2% 0 !important; font-weight: bold !important; text-align: center !important; } #NagishLiOverlayContent > .NagishLiStatementText > a { color: " +
          d + " !important; text-decoration: none !important; } #NagishLiOverlayContent > .NagishLiStatementText > .nlas-stitle { font-weight: bold !important; font-size: 110% !important; text-decoration: underline !important; }</style>";
        b('<div class="NagishLiOverlay"><div id="NagishLiOverlayContent" style="color: black !important; background-color: white !important; width: 50% !important; margin: auto !important; top: 25% !important; height: 50% !important; position: relative !important; border: 10px solid !important; border-color: ' +
          d + " !important; border-radius: 25px !important; overflow-x: hidden !important; direction: " + phrases.dir + ' !important; cursor: context-menu !important;">' + c + "</div></div>").fadeIn("fast").appendTo("#NagishLiTag");
        b("#NagishLiOverlayContent").niceScroll({
          autohidemode: !U,
          horizrailenabled: !1,
          railalign: phrases.align_left,
          cursorcolor: d
        });
        d = b("#NagishLiOverlayContent a");
        var e = d.first(),
          f = d.last();
        e.focus();
        f.on("keydown", function (b) {
          9 !== b.which || b.shiftKey || (b.preventDefault(), e.focus())
        });
        e.on("keydown",
          function (b) {
            9 === b.which && b.shiftKey && (b.preventDefault(), f.focus())
          })
      }
    });
    b(commons.dropdown + " > ul > li > div > span.help, " + commons.dropdown + " > ul > li > div > span.notice").attr("data-balloon-pos", phrases.align_left).on("mousedown keypress.nlkbnavclk", function () {
      alert(b(this).data("balloon"));
      return !1
    });
    b(commons.dropdown + " > #NagishLiColors > li > #NLCustomColors > span:not(.sign, .help, .option-title)").click(function () {
      var c = b(this).is("#NLCustomColorsBG") ? b("#NLCurrentBG") : b("#NLCurrentTXT"),
        d = b(this).is("#NLCustomColorsBG") ? phrases.bg : phrases.txt,
        e = b(this).parent("div#NLCustomColors").contents().detach();
      var f = d == phrases.bg ? n(b("body").css("background-color")) : n(b("body").css("color"));
      var g = document.createElement("input");
      g.setAttribute("type", "color");
      g = "text" !== g.type ? '<li style="background-color: ' + f + '; width: inherit !important;" role="button" aria-label="' + phrases.aria_select_color + d.toLowerCase() + '"><input tabindex="35" id="NLColorPicker" type="color" value="' + f + "\" onchange=\"$(this).parent('li').css('background-color', $('#NLColorPicker').val()).attr('aria-label', '" +
        phrases.clr_custom + '\');" style="min-width: 18px !important; min-height: 18px !important; width: 100% !important; height: 100% !important; vertical-align: top !important;" /></li>' : "";
      f = '<span class="option-title" style="display: none !important;">' + phrases.custom_colors + "</span>";
      "he" == p ? f += phrases.color + " " + d + ':<ul id="colorPanel" data-type="' + d + '" style="padding: 0 !important; text-align: center !important;"><li style="background-color: #000000;" tabindex="35" role="button" aria-label="' + d + " " +
        phrases.clr_black + '"></li><li style="background-color: #6495ed;" tabindex="35" role="button" aria-label="' + d + " " + phrases.clr_blue + '"></li><li style="background-color: #3cb371;" tabindex="35" role="button" aria-label="' + d + " " + phrases.clr_green + '"></li><li style="background-color: #ffd800;" tabindex="35" role="button" aria-label="' + d + " " + phrases.clr_yellow + '"></li><li style="background-color: #e95d4f;" tabindex="35" role="button" aria-label="' + d + " " + phrases.clr_red + '"></li><li style="background-color: #ffa500;" tabindex="35" role="button" aria-label="' +
        d + " " + phrases.clr_orange + '"></li><br /><li style="background-color: #a569bd;" tabindex="35" role="button" aria-label="' + d + " " + phrases.clr_purple + '"></li><li style="background-color: #ff78bb;" tabindex="35" role="button" aria-label="' + d + " " + phrases.clr_pink + '"></li><li style="background-color: #ffffff;" tabindex="35" role="button" aria-label="' + d + " " + phrases.clr_white + '"></li><li style="background-color: #a3a3a3;" tabindex="35" role="button" aria-label="' + d + " " + phrases.clr_gray + '"></li>' + g : (f += d + " " +
          phrases.color + ':<ul id="colorPanel" data-type="' + d + '" style="padding: 0 !important; text-align: center !important;">', d = d.toLowerCase(), f += '<li style="background-color: #000000;" tabindex="35" role="button" aria-label="' + phrases.clr_black + " " + d + '"></li><li style="background-color: #6495ed;" tabindex="35" role="button" aria-label="' + phrases.clr_blue + " " + d + '"></li><li style="background-color: #3cb371;" tabindex="35" role="button" aria-label="' + phrases.clr_green + " " + d + '"></li><li style="background-color: #ffd800;" tabindex="35" role="button" aria-label="' +
          phrases.clr_yellow + " " + d + '"></li><li style="background-color: #e95d4f;" tabindex="35" role="button" aria-label="' + phrases.clr_red + " " + d + '"></li><li style="background-color: #ffa500;" tabindex="35" role="button" aria-label="' + phrases.clr_orange + " " + d + '"></li><br /><li style="background-color: #a569bd;" tabindex="35" role="button" aria-label="' + phrases.clr_purple + " " + d + '"></li><li style="background-color: #ff78bb;" tabindex="35" role="button" aria-label="' + phrases.clr_pink + " " + d + '"></li><li style="background-color: #ffffff;" tabindex="35" role="button" aria-label="' +
          phrases.clr_white + " " + d + '"></li><li style="background-color: #a3a3a3;" tabindex="35" role="button" aria-label="' + phrases.clr_gray + " " + d + '"></li>' + g);
      f += '<li style="border-color: transparent !important;" tabindex="35" role="button" id="NLCloseColorPanel">&#x274c;&#xfe0e;</li></ul>';
      b(commons.dropdown + " > #NagishLiColors > li > #NLCustomColors")[0].innerHTML = f;
      "none" != c.css("display") && (b(commons.checkmark).prependTo(b("div#NLCustomColors")), b(commons.dropdown + ' > #NagishLiColors > li.not-clickable > #NLCustomColors > ul#colorPanel > li[style="background-color: ' +
        n(c.css("background-color")) + ';"]').length ? b(commons.dropdown + ' > #NagishLiColors > li.not-clickable > #NLCustomColors > ul#colorPanel > li[style="background-color: ' + n(c.css("background-color")) + ';"]').eq(0).addClass("selected") : (b(commons.dropdown + " > #NagishLiColors > li.not-clickable > #NLCustomColors > ul#colorPanel[data-type='" + phrases.bg + "'] > li[aria-label='" + phrases.aria_select_bgcolor + "'] > input#NLColorPicker").attr("value", n(c.css("background-color"))).parent("li").attr("aria-label", phrases.clr_custom).addClass("selected"),
        b(commons.dropdown + " > #NagishLiColors > li.not-clickable > #NLCustomColors > ul#colorPanel[data-type='" + phrases.txt + "'] > li[aria-label='" + phrases.aria_select_txtcolor + "'] > input#NLColorPicker").attr("value", n(c.css("background-color"))).parent("li").attr("aria-label", phrases.clr_custom).addClass("selected")));
      b(commons.dropdown + " > #NagishLiColors > li > #NLCustomColors > ul > li#NLCloseColorPanel").on("click keypress.nlkbnavclk", function () {
        var c = b(commons.dropdown + " > #NagishLiColors > li.not-clickable > #NLCustomColors > ul#colorPanel[data-type='" +
            phrases.bg + "'] > li.selected"),
          d = b(commons.dropdown + " > #NagishLiColors > li.not-clickable > #NLCustomColors > ul#colorPanel[data-type='" + phrases.txt + "'] > li.selected");
        b(commons.dropdown + " > #NagishLiColors > li > #NLCustomColors").empty().append(e);
        b(this).parent("ul#colorPanel").data("type") === phrases.bg ? c.length ? b(commons.dropdown + " > #NagishLiColors > li > #NLCustomColors > #NLCustomColorsBG > #NLCurrentBG").css({
          "background-color": c.css("background-color"),
          display: "inline-block"
        }).attr("aria-label",
          c.attr("aria-label")) : b(commons.dropdown + " > #NagishLiColors > li > #NLCustomColors > #NLCustomColorsBG > #NLCurrentBG").css({
          "background-color": "",
          display: "none"
        }) : d.length ? b(commons.dropdown + " > #NagishLiColors > li > #NLCustomColors > #NLCustomColorsTXT > #NLCurrentTXT").css({
          "background-color": d.css("background-color"),
          display: "inline-block"
        }).attr("aria-label", d.attr("aria-label")) : b(commons.dropdown + " > #NagishLiColors > li > #NLCustomColors > #NLCustomColorsTXT > #NLCurrentTXT").css({
          "background-color": "",
          display: "none"
        });
        1 <= b("#NLCurrentBG:visible, #NLCurrentTXT:visible").length ? b("div#NLCustomColors").children("span.sign").length || b(commons.checkmark).prependTo(b("div#NLCustomColors")) : b("div#NLCustomColors").children("span.sign").remove()
      })
    });
    b(commons.dropdown + " > .dropdown-toggle").click(function (c) {
      b(this).next("#NagishLiColors, #NagishLiDisplay", "ul").children("li.active:not(':last-child')").length ? !b(this).children("span.selected").length && b(this).next("ul").children("li.active").length ? (c =
        b(this).next("ul").children("li.active").find(".option-title").text(), b('<span class="selected">' + c + "</span>").insertAfter(b(this).children(".dropdown-title"))) : b(this).children("span.selected").remove() : b(this).next("#NagishLiHighlight", "ul").length && (!b(this).children("span.selected").length && 1 < b(this).next("ul").children("li.active").find("span.sign").length ? (c = b(this).next("ul").children("li.active:first-child").find(".option-title").text() + " " + b(this).next("ul").children("li.active:nth-child(2)").find(".option-title").text(),
        c = c.split(" "), c[1] = "en" == p ? c[1].charAt(0).toUpperCase() + c[1].substr(1) : c[1], b('<span class="selected">' + c[1] + "&nbsp;" + phrases.and + c[3] + "</span>").insertAfter(b(this).children(".dropdown-title"))) : !b(this).children("span.selected").length && b(this).next("ul").find("span.sign").length ? (c = b(this).next("ul").children("li.active").find(".option-title").text(), b('<span class="selected">' + c + "</span>").insertAfter(b(this).children(".dropdown-title"))) : b(this).children("span.selected").remove())
    });
    b(commons.dropdown +
      " > #NagishLiText > li").click(function () {
      b(this).is(":last-child") && !b(this).find("span.sign").length && b(commons.checkmark).prependTo(b(this).children("div"))
    }).on("mousedown keypress", function (c) {
      if (1 === c.which || 13 === c.which) b(this).siblings("li:last").find("span.sign").remove(), b(this).is(":first-child") ? b('<span class="sign">&nbsp;&nbsp;&#x2795;&#xfe0e;</span>').appendTo(b(this).children("div")) : b(this).is(":nth-child(2)") && b('<span class="sign">&nbsp;&nbsp;&#x2796;&#xfe0e;</span>').appendTo(b(this).children("div"))
    }).on("mouseup mouseleave mouseout keydown keyup",
      function () {
        b(this).is(":last-child") || b(this).find("span.sign").remove()
      });
    b(commons.dropdown + " > #NagishLiColors > li:not(.not-clickable), " + commons.dropdown + " > #NagishLiDisplay > li").click(function () {
      b(this).hasClass("active") ? (b(this).not("li:last-child").removeClass("active").find("span.sign").remove(), b(commons.checkmark).prependTo(b(this).siblings("li:last-child").addClass("active").children("div"))) : (b(this).addClass("active").siblings("li").removeClass("active").find("span.sign").remove(),
        b(commons.checkmark).prependTo(b(this).children("div")))
    });
    b(commons.dropdown + " > #NagishLiColors > li.not-clickable").on("click change keypress.nlkbnavclk", "#NLCustomColors > ul#colorPanel > li:not(#NLCloseColorPanel)", function () {
      !b(this).hasClass("selected") || b(this).children("input").is("#NLColorPicker") ? (b(this).children("input").is("#NLColorPicker") && b(this).siblings("li.selected").length ? b(this).removeClass("selected") : b(this).addClass("selected").siblings("li").removeClass("selected").closest("li.not-clickable").addClass("active").siblings("li").removeClass("active").find("span.sign").remove(),
        b(this).closest("div#NLCustomColors").children("span.sign").length || b(commons.checkmark).prependTo(b(this).closest("#NLCustomColors", "div"))) : b(this).removeClass("selected").closest("#NLCustomColors", "div").find("span.sign").remove();
      b(this).attr("aria-label") != phrases.aria_select_bgcolor && b(this).attr("aria-label") != phrases.aria_select_txtcolor ? (b(this).siblings("li").removeClass("selected").closest("li.not-clickable").addClass("active").siblings("li").removeClass("active").find("span.sign").remove(),
        b(this).children("input").is("#NLColorPicker") ? b(this).addClass("selected").children("input#NLColorPicker").attr("value", b("#NLColorPicker").val()) : (b(this).parent("ul[data-type='" + phrases.bg + "']").children("li[aria-label='" + phrases.clr_custom + "']").attr("aria-label", phrases.aria_select_bgcolor).css("background-color", "transparent"), b(this).parent("ul[data-type='" + phrases.txt + "']").children("li[aria-label='" + phrases.clr_custom + "']").attr("aria-label", phrases.aria_select_txtcolor).css("background-color",
          "transparent")), b(this).parent("ul#colorPanel").data("type") === phrases.bg ? Q() : Q("txt")) : b(this).closest("div#NLCustomColors").children("span.sign").length && !b("body[nl-colors]").length && b(this).removeClass("selected").closest("#NLCustomColors", "div").find("span.sign").remove();
      b("body[nl-colors]").length || b("#NLCustomColors > ul#colorPanel > li.selected").length || b(commons.checkmark).prependTo(b(this).closest("li.not-clickable").removeClass("active").siblings("li:last-child").addClass("active").children("div"))
    });
    b(commons.dropdown + " > #NagishLiHighlight > li").click(function () {
      b(this).hasClass("active") ? b(this).removeClass("active").find("span.sign").remove() : b(commons.checkmark).prependTo(b(this).addClass("active").children("div"))
    });
    b(commons.dropdown + " > #NagishLiMisc > li > #NLCursor > #NLCursorBlack, " + commons.dropdown + " > #NagishLiMisc > li > #NLCursor > #NLCursorWhite").click(function () {
      b(this).hasClass("active") ? b(this).removeClass("active").find("span.sign").remove() : (b(this).siblings("span").removeClass("active").find("span.sign").remove(),
        b(commons.checkmark).prependTo(b(this).addClass("active")))
    });
    b("span#NagishLiMove > span").each(function () {
      this.style.setProperty("display", "inline-block", "important");
      this.style.setProperty("float", phrases.align_left, "important");
      this.style.setProperty("background-color", "transparent", "important");
      this.style.setProperty("background-position", "center", "important");
      this.style.setProperty("background-size", "cover", "important");
      this.style.setProperty("width", "50%", "important");
      this.style.setProperty("height",
        "50%", "important");
      this.style.setProperty("z-index", "9999999", "important")
    });
    b("span#NagishLiMove > span").hover(function (c) {
      b(this).css("background-color", "mouseenter" === c.type ? "white" : "transparent")
    });
    A || b(commons.dropdown + " > .dropdown-toggle > .dropdown-arrow").each(function () {
      b(this).html('<img src="' + icons.toggle_single + '" />').children("img").attr("alt", phrases.toggle_single_alt + b(this).siblings(".dropdown-title").text())
    });
    b(commons.dropdown + " > .dropdown-menu > li > div[tabindex='13']").click(function () {
      alert(b(this).data("balloon"))
    });
    if (!A) {
      var L = b(commons.dropdown + ":last-child > .dropdown-menu > li:last-child > div").css("border-bottom-color");
      b(commons.menus).niceScroll({
        autohidemode: !0,
        horizrailenabled: !1,
        railalign: phrases.align_left,
        cursorcolor: L
      })
    }
    b(window).resize(function () {
      b(commons.menus).css("max-height", b(window).height() - 40 + "px")
    });
    b("body").css("-ms-overflow-style", "scrollbar");
    b(commons.menus + " > li.dropdown > ul.dropdown-menu > li").on("dragstart", function () {
      return !1
    });
    b(commons.bar).on("contextmenu", function () {
      return !1
    })
  })
};
